(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));

  // node_modules/glightbox/dist/js/glightbox.min.js
  var require_glightbox_min = __commonJS({
    "node_modules/glightbox/dist/js/glightbox.min.js"(exports, module) {
      !function(e, t) {
        "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = e || self).GLightbox = t();
      }(exports, function() {
        "use strict";
        function e(e2, t2) {
          if (!(e2 instanceof t2)) throw new TypeError("Cannot call a class as a function");
        }
        function t(e2, t2) {
          for (var i2 = 0; i2 < t2.length; i2++) {
            var s2 = t2[i2];
            s2.enumerable = s2.enumerable || false, s2.configurable = true, "value" in s2 && (s2.writable = true), Object.defineProperty(e2, n(s2.key), s2);
          }
        }
        function i(e2, i2, n2) {
          return i2 && t(e2.prototype, i2), n2 && t(e2, n2), Object.defineProperty(e2, "prototype", { writable: false }), e2;
        }
        function n(e2) {
          var t2 = function(e3, t3) {
            if ("object" != typeof e3 || !e3) return e3;
            var i2 = e3[Symbol.toPrimitive];
            if (void 0 !== i2) {
              var n2 = i2.call(e3, t3 || "default");
              if ("object" != typeof n2) return n2;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t3 ? String : Number)(e3);
          }(e2, "string");
          return "symbol" == typeof t2 ? t2 : t2 + "";
        }
        function s(e2) {
          return (s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e3) {
            return typeof e3;
          } : function(e3) {
            return e3 && "function" == typeof Symbol && e3.constructor === Symbol && e3 !== Symbol.prototype ? "symbol" : typeof e3;
          })(e2);
        }
        var l = Date.now();
        function o() {
          var e2 = {}, t2 = true, i2 = 0, n2 = arguments.length;
          "[object Boolean]" === Object.prototype.toString.call(arguments[0]) && (t2 = arguments[0], i2++);
          for (var s2 = function(i3) {
            for (var n3 in i3) Object.prototype.hasOwnProperty.call(i3, n3) && (t2 && "[object Object]" === Object.prototype.toString.call(i3[n3]) ? e2[n3] = o(true, e2[n3], i3[n3]) : e2[n3] = i3[n3]);
          }; i2 < n2; i2++) {
            var l2 = arguments[i2];
            s2(l2);
          }
          return e2;
        }
        function r(e2, t2) {
          if ((E(e2) || e2 === window || e2 === document) && (e2 = [e2]), L(e2) || I(e2) || (e2 = [e2]), 0 != M(e2)) {
            if (L(e2) && !I(e2)) for (var i2 = e2.length, n2 = 0; n2 < i2 && false !== t2.call(e2[n2], e2[n2], n2, e2); n2++) ;
            else if (I(e2)) {
              for (var s2 in e2) if (P(e2, s2) && false === t2.call(e2[s2], e2[s2], s2, e2)) break;
            }
          }
        }
        function a(e2) {
          var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, i2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, n2 = e2[l] = e2[l] || [], s2 = { all: n2, evt: null, found: null };
          return t2 && i2 && M(n2) > 0 && r(n2, function(e3, n3) {
            if (e3.eventName == t2 && e3.fn.toString() == i2.toString()) return s2.found = true, s2.evt = n3, false;
          }), s2;
        }
        function h(e2) {
          var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, i2 = t2.onElement, n2 = t2.withCallback, s2 = t2.avoidDuplicate, l2 = void 0 === s2 || s2, o2 = t2.once, h2 = void 0 !== o2 && o2, d2 = t2.useCapture, c2 = void 0 !== d2 && d2, u2 = arguments.length > 2 ? arguments[2] : void 0, g2 = i2 || [];
          function v2(e3) {
            C(n2) && n2.call(u2, e3, this), h2 && v2.destroy();
          }
          return k(g2) && (g2 = document.querySelectorAll(g2)), v2.destroy = function() {
            r(g2, function(t3) {
              var i3 = a(t3, e2, v2);
              i3.found && i3.all.splice(i3.evt, 1), t3.removeEventListener && t3.removeEventListener(e2, v2, c2);
            });
          }, r(g2, function(t3) {
            var i3 = a(t3, e2, v2);
            (t3.addEventListener && l2 && !i3.found || !l2) && (t3.addEventListener(e2, v2, c2), i3.all.push({ eventName: e2, fn: v2 }));
          }), v2;
        }
        function d(e2, t2) {
          r(t2.split(" "), function(t3) {
            return e2.classList.add(t3);
          });
        }
        function c(e2, t2) {
          r(t2.split(" "), function(t3) {
            return e2.classList.remove(t3);
          });
        }
        function u(e2, t2) {
          return e2.classList.contains(t2);
        }
        function g(e2, t2) {
          for (; e2 !== document.body; ) {
            if (!(e2 = e2.parentElement)) return false;
            if ("function" == typeof e2.matches ? e2.matches(t2) : e2.msMatchesSelector(t2)) return e2;
          }
        }
        function v(e2) {
          var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "", i2 = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          if (!e2 || "" === t2) return false;
          if ("none" === t2) return C(i2) && i2(), false;
          var n2 = b(), s2 = t2.split(" ");
          r(s2, function(t3) {
            d(e2, "g" + t3);
          }), h(n2, { onElement: e2, avoidDuplicate: false, once: true, withCallback: function(e3, t3) {
            r(s2, function(e4) {
              c(t3, "g" + e4);
            }), C(i2) && i2();
          } });
        }
        function f(e2) {
          var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
          if ("" === t2) return e2.style.webkitTransform = "", e2.style.MozTransform = "", e2.style.msTransform = "", e2.style.OTransform = "", e2.style.transform = "", false;
          e2.style.webkitTransform = t2, e2.style.MozTransform = t2, e2.style.msTransform = t2, e2.style.OTransform = t2, e2.style.transform = t2;
        }
        function p(e2) {
          e2.style.display = "block";
        }
        function m(e2) {
          e2.style.display = "none";
        }
        function y(e2) {
          var t2 = document.createDocumentFragment(), i2 = document.createElement("div");
          for (i2.innerHTML = e2; i2.firstChild; ) t2.appendChild(i2.firstChild);
          return t2;
        }
        function x() {
          return { width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth, height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight };
        }
        function b() {
          var e2, t2 = document.createElement("fakeelement"), i2 = { animation: "animationend", OAnimation: "oAnimationEnd", MozAnimation: "animationend", WebkitAnimation: "webkitAnimationEnd" };
          for (e2 in i2) if (void 0 !== t2.style[e2]) return i2[e2];
        }
        function S(e2, t2, i2, n2) {
          if (e2()) t2();
          else {
            var s2;
            i2 || (i2 = 100);
            var l2 = setInterval(function() {
              e2() && (clearInterval(l2), s2 && clearTimeout(s2), t2());
            }, i2);
            n2 && (s2 = setTimeout(function() {
              clearInterval(l2);
            }, n2));
          }
        }
        function w(e2, t2, i2) {
          if (O(e2)) console.error("Inject assets error");
          else if (C(t2) && (i2 = t2, t2 = false), k(t2) && t2 in window) C(i2) && i2();
          else {
            var n2;
            if (-1 !== e2.indexOf(".css")) {
              if ((n2 = document.querySelectorAll('link[href="' + e2 + '"]')) && n2.length > 0) return void (C(i2) && i2());
              var s2 = document.getElementsByTagName("head")[0], l2 = s2.querySelectorAll('link[rel="stylesheet"]'), o2 = document.createElement("link");
              return o2.rel = "stylesheet", o2.type = "text/css", o2.href = e2, o2.media = "all", l2 ? s2.insertBefore(o2, l2[0]) : s2.appendChild(o2), void (C(i2) && i2());
            }
            if ((n2 = document.querySelectorAll('script[src="' + e2 + '"]')) && n2.length > 0) {
              if (C(i2)) {
                if (k(t2)) return S(function() {
                  return void 0 !== window[t2];
                }, function() {
                  i2();
                }), false;
                i2();
              }
            } else {
              var r2 = document.createElement("script");
              r2.type = "text/javascript", r2.src = e2, r2.onload = function() {
                if (C(i2)) {
                  if (k(t2)) return S(function() {
                    return void 0 !== window[t2];
                  }, function() {
                    i2();
                  }), false;
                  i2();
                }
              }, document.body.appendChild(r2);
            }
          }
        }
        function T() {
          return "navigator" in window && window.navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(Android)|(PlayBook)|(BB10)|(BlackBerry)|(Opera Mini)|(IEMobile)|(webOS)|(MeeGo)/i);
        }
        function C(e2) {
          return "function" == typeof e2;
        }
        function k(e2) {
          return "string" == typeof e2;
        }
        function E(e2) {
          return !(!e2 || !e2.nodeType || 1 != e2.nodeType);
        }
        function A(e2) {
          return Array.isArray(e2);
        }
        function L(e2) {
          return e2 && e2.length && isFinite(e2.length);
        }
        function I(e2) {
          return "object" === s(e2) && null != e2 && !C(e2) && !A(e2);
        }
        function O(e2) {
          return null == e2;
        }
        function P(e2, t2) {
          return null !== e2 && hasOwnProperty.call(e2, t2);
        }
        function M(e2) {
          if (I(e2)) {
            if (e2.keys) return e2.keys().length;
            var t2 = 0;
            for (var i2 in e2) P(e2, i2) && t2++;
            return t2;
          }
          return e2.length;
        }
        function z(e2) {
          return !isNaN(parseFloat(e2)) && isFinite(e2);
        }
        function X() {
          var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : -1, t2 = document.querySelectorAll(".gbtn[data-taborder]:not(.disabled)");
          if (!t2.length) return false;
          if (1 == t2.length) return t2[0];
          "string" == typeof e2 && (e2 = parseInt(e2));
          var i2 = [];
          r(t2, function(e3) {
            i2.push(e3.getAttribute("data-taborder"));
          });
          var n2 = Math.max.apply(Math, i2.map(function(e3) {
            return parseInt(e3);
          })), s2 = e2 < 0 ? 1 : e2 + 1;
          s2 > n2 && (s2 = "1");
          var l2 = i2.filter(function(e3) {
            return e3 >= parseInt(s2);
          }), o2 = l2.sort()[0];
          return document.querySelector('.gbtn[data-taborder="'.concat(o2, '"]'));
        }
        function Y(e2) {
          if (e2.events.hasOwnProperty("keyboard")) return false;
          e2.events.keyboard = h("keydown", { onElement: window, withCallback: function(t2, i2) {
            var n2 = (t2 = t2 || window.event).keyCode;
            if (9 == n2) {
              var s2 = document.querySelector(".gbtn.focused");
              if (!s2) {
                var l2 = !(!document.activeElement || !document.activeElement.nodeName) && document.activeElement.nodeName.toLocaleLowerCase();
                if ("input" == l2 || "textarea" == l2 || "button" == l2) return;
              }
              t2.preventDefault();
              var o2 = document.querySelectorAll(".gbtn[data-taborder]");
              if (!o2 || o2.length <= 0) return;
              if (!s2) {
                var r2 = X();
                return void (r2 && (r2.focus(), d(r2, "focused")));
              }
              var a2 = X(s2.getAttribute("data-taborder"));
              c(s2, "focused"), a2 && (a2.focus(), d(a2, "focused"));
            }
            39 == n2 && e2.nextSlide(), 37 == n2 && e2.prevSlide(), 27 == n2 && e2.close();
          } });
        }
        var q = i(function t2(i2, n2) {
          var s2 = this, l2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
          if (e(this, t2), this.img = i2, this.slide = n2, this.onclose = l2, this.img.setZoomEvents) return false;
          this.active = false, this.zoomedIn = false, this.dragging = false, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.img.addEventListener("mousedown", function(e2) {
            return s2.dragStart(e2);
          }, false), this.img.addEventListener("mouseup", function(e2) {
            return s2.dragEnd(e2);
          }, false), this.img.addEventListener("mousemove", function(e2) {
            return s2.drag(e2);
          }, false), this.img.addEventListener("click", function(e2) {
            return s2.slide.classList.contains("dragging-nav") ? (s2.zoomOut(), false) : s2.zoomedIn ? void (s2.zoomedIn && !s2.dragging && s2.zoomOut()) : s2.zoomIn();
          }, false), this.img.setZoomEvents = true;
        }, [{ key: "zoomIn", value: function() {
          var e2 = this.widowWidth();
          if (!(this.zoomedIn || e2 <= 768)) {
            var t2 = this.img;
            if (t2.setAttribute("data-style", t2.getAttribute("style")), t2.style.maxWidth = t2.naturalWidth + "px", t2.style.maxHeight = t2.naturalHeight + "px", t2.naturalWidth > e2) {
              var i2 = e2 / 2 - t2.naturalWidth / 2;
              this.setTranslate(this.img.parentNode, i2, 0);
            }
            this.slide.classList.add("zoomed"), this.zoomedIn = true;
          }
        } }, { key: "zoomOut", value: function() {
          this.img.parentNode.setAttribute("style", ""), this.img.setAttribute("style", this.img.getAttribute("data-style")), this.slide.classList.remove("zoomed"), this.zoomedIn = false, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.onclose && "function" == typeof this.onclose && this.onclose();
        } }, { key: "dragStart", value: function(e2) {
          e2.preventDefault(), this.zoomedIn ? ("touchstart" === e2.type ? (this.initialX = e2.touches[0].clientX - this.xOffset, this.initialY = e2.touches[0].clientY - this.yOffset) : (this.initialX = e2.clientX - this.xOffset, this.initialY = e2.clientY - this.yOffset), e2.target === this.img && (this.active = true, this.img.classList.add("dragging"))) : this.active = false;
        } }, { key: "dragEnd", value: function(e2) {
          var t2 = this;
          e2.preventDefault(), this.initialX = this.currentX, this.initialY = this.currentY, this.active = false, setTimeout(function() {
            t2.dragging = false, t2.img.isDragging = false, t2.img.classList.remove("dragging");
          }, 100);
        } }, { key: "drag", value: function(e2) {
          this.active && (e2.preventDefault(), "touchmove" === e2.type ? (this.currentX = e2.touches[0].clientX - this.initialX, this.currentY = e2.touches[0].clientY - this.initialY) : (this.currentX = e2.clientX - this.initialX, this.currentY = e2.clientY - this.initialY), this.xOffset = this.currentX, this.yOffset = this.currentY, this.img.isDragging = true, this.dragging = true, this.setTranslate(this.img, this.currentX, this.currentY));
        } }, { key: "onMove", value: function(e2) {
          if (this.zoomedIn) {
            var t2 = e2.clientX - this.img.naturalWidth / 2, i2 = e2.clientY - this.img.naturalHeight / 2;
            this.setTranslate(this.img, t2, i2);
          }
        } }, { key: "setTranslate", value: function(e2, t2, i2) {
          e2.style.transform = "translate3d(" + t2 + "px, " + i2 + "px, 0)";
        } }, { key: "widowWidth", value: function() {
          return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        } }]), N = i(function t2() {
          var i2 = this, n2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          e(this, t2);
          var s2 = n2.dragEl, l2 = n2.toleranceX, o2 = void 0 === l2 ? 40 : l2, r2 = n2.toleranceY, a2 = void 0 === r2 ? 65 : r2, h2 = n2.slide, d2 = void 0 === h2 ? null : h2, c2 = n2.instance, u2 = void 0 === c2 ? null : c2;
          this.el = s2, this.active = false, this.dragging = false, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.direction = null, this.lastDirection = null, this.toleranceX = o2, this.toleranceY = a2, this.toleranceReached = false, this.dragContainer = this.el, this.slide = d2, this.instance = u2, this.el.addEventListener("mousedown", function(e2) {
            return i2.dragStart(e2);
          }, false), this.el.addEventListener("mouseup", function(e2) {
            return i2.dragEnd(e2);
          }, false), this.el.addEventListener("mousemove", function(e2) {
            return i2.drag(e2);
          }, false);
        }, [{ key: "dragStart", value: function(e2) {
          if (this.slide.classList.contains("zoomed")) this.active = false;
          else {
            "touchstart" === e2.type ? (this.initialX = e2.touches[0].clientX - this.xOffset, this.initialY = e2.touches[0].clientY - this.yOffset) : (this.initialX = e2.clientX - this.xOffset, this.initialY = e2.clientY - this.yOffset);
            var t2 = e2.target.nodeName.toLowerCase();
            e2.target.classList.contains("nodrag") || g(e2.target, ".nodrag") || -1 !== ["input", "select", "textarea", "button", "a"].indexOf(t2) ? this.active = false : (e2.preventDefault(), (e2.target === this.el || "img" !== t2 && g(e2.target, ".gslide-inline")) && (this.active = true, this.el.classList.add("dragging"), this.dragContainer = g(e2.target, ".ginner-container")));
          }
        } }, { key: "dragEnd", value: function(e2) {
          var t2 = this;
          e2 && e2.preventDefault(), this.initialX = 0, this.initialY = 0, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.active = false, this.doSlideChange && (this.instance.preventOutsideClick = true, "right" == this.doSlideChange && this.instance.prevSlide(), "left" == this.doSlideChange && this.instance.nextSlide()), this.doSlideClose && this.instance.close(), this.toleranceReached || this.setTranslate(this.dragContainer, 0, 0, true), setTimeout(function() {
            t2.instance.preventOutsideClick = false, t2.toleranceReached = false, t2.lastDirection = null, t2.dragging = false, t2.el.isDragging = false, t2.el.classList.remove("dragging"), t2.slide.classList.remove("dragging-nav"), t2.dragContainer.style.transform = "", t2.dragContainer.style.transition = "";
          }, 100);
        } }, { key: "drag", value: function(e2) {
          if (this.active) {
            e2.preventDefault(), this.slide.classList.add("dragging-nav"), "touchmove" === e2.type ? (this.currentX = e2.touches[0].clientX - this.initialX, this.currentY = e2.touches[0].clientY - this.initialY) : (this.currentX = e2.clientX - this.initialX, this.currentY = e2.clientY - this.initialY), this.xOffset = this.currentX, this.yOffset = this.currentY, this.el.isDragging = true, this.dragging = true, this.doSlideChange = false, this.doSlideClose = false;
            var t2 = Math.abs(this.currentX), i2 = Math.abs(this.currentY);
            if (t2 > 0 && t2 >= Math.abs(this.currentY) && (!this.lastDirection || "x" == this.lastDirection)) {
              this.yOffset = 0, this.lastDirection = "x", this.setTranslate(this.dragContainer, this.currentX, 0);
              var n2 = this.shouldChange();
              if (!this.instance.settings.dragAutoSnap && n2 && (this.doSlideChange = n2), this.instance.settings.dragAutoSnap && n2) return this.instance.preventOutsideClick = true, this.toleranceReached = true, this.active = false, this.instance.preventOutsideClick = true, this.dragEnd(null), "right" == n2 && this.instance.prevSlide(), void ("left" == n2 && this.instance.nextSlide());
            }
            if (this.toleranceY > 0 && i2 > 0 && i2 >= t2 && (!this.lastDirection || "y" == this.lastDirection)) {
              this.xOffset = 0, this.lastDirection = "y", this.setTranslate(this.dragContainer, 0, this.currentY);
              var s2 = this.shouldClose();
              return !this.instance.settings.dragAutoSnap && s2 && (this.doSlideClose = true), void (this.instance.settings.dragAutoSnap && s2 && this.instance.close());
            }
          }
        } }, { key: "shouldChange", value: function() {
          var e2 = false;
          if (Math.abs(this.currentX) >= this.toleranceX) {
            var t2 = this.currentX > 0 ? "right" : "left";
            ("left" == t2 && this.slide !== this.slide.parentNode.lastChild || "right" == t2 && this.slide !== this.slide.parentNode.firstChild) && (e2 = t2);
          }
          return e2;
        } }, { key: "shouldClose", value: function() {
          var e2 = false;
          return Math.abs(this.currentY) >= this.toleranceY && (e2 = true), e2;
        } }, { key: "setTranslate", value: function(e2, t2, i2) {
          var n2 = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
          e2.style.transition = n2 ? "all .2s ease" : "", e2.style.transform = "translate3d(".concat(t2, "px, ").concat(i2, "px, 0)");
        } }]);
        function D(e2, t2, i2, n2) {
          var s2 = e2.querySelector(".gslide-media"), l2 = new Image(), o2 = "gSlideTitle_" + i2, r2 = "gSlideDesc_" + i2;
          l2.addEventListener("load", function() {
            C(n2) && n2();
          }, false), l2.src = t2.href, "" != t2.sizes && "" != t2.srcset && (l2.sizes = t2.sizes, l2.srcset = t2.srcset), l2.alt = "", O(t2.alt) || "" === t2.alt || (l2.alt = t2.alt), "" !== t2.title && l2.setAttribute("aria-labelledby", o2), "" !== t2.description && l2.setAttribute("aria-describedby", r2), t2.hasOwnProperty("_hasCustomWidth") && t2._hasCustomWidth && (l2.style.width = t2.width), t2.hasOwnProperty("_hasCustomHeight") && t2._hasCustomHeight && (l2.style.height = t2.height), s2.insertBefore(l2, s2.firstChild);
        }
        function _(e2, t2, i2, n2) {
          var s2 = this, l2 = e2.querySelector(".ginner-container"), o2 = "gvideo" + i2, r2 = e2.querySelector(".gslide-media"), a2 = this.getAllPlayers();
          d(l2, "gvideo-container"), r2.insertBefore(y('<div class="gvideo-wrapper"></div>'), r2.firstChild);
          var h2 = e2.querySelector(".gvideo-wrapper");
          w(this.settings.plyr.css, "Plyr");
          var c2 = t2.href, u2 = null == t2 ? void 0 : t2.videoProvider, g2 = false;
          r2.style.maxWidth = t2.width, w(this.settings.plyr.js, "Plyr", function() {
            if (!u2 && c2.match(/vimeo\.com\/([0-9]*)/) && (u2 = "vimeo"), !u2 && (c2.match(/(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/) || c2.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/) || c2.match(/(youtube\.com|youtube-nocookie\.com)\/embed\/([a-zA-Z0-9\-_]+)/) || c2.match(/(youtube\.com|youtube-nocookie\.com)\/shorts\/([a-zA-Z0-9\-_]+)/)) && (u2 = "youtube"), "local" === u2 || !u2) {
              u2 = "local";
              var l3 = '<video id="' + o2 + '" ';
              l3 += 'style="background:#000; max-width: '.concat(t2.width, ';" '), l3 += 'preload="metadata" ', l3 += 'x-webkit-airplay="allow" ', l3 += "playsinline ", l3 += "controls ", l3 += 'class="gvideo-local">', l3 += '<source src="'.concat(c2, '">'), g2 = y(l3 += "</video>");
            }
            var r3 = g2 || y('<div id="'.concat(o2, '" data-plyr-provider="').concat(u2, '" data-plyr-embed-id="').concat(c2, '"></div>'));
            d(h2, "".concat(u2, "-video gvideo")), h2.appendChild(r3), h2.setAttribute("data-id", o2), h2.setAttribute("data-index", i2);
            var v2 = P(s2.settings.plyr, "config") ? s2.settings.plyr.config : {}, f2 = new Plyr("#" + o2, v2);
            f2.on("ready", function(e3) {
              a2[o2] = e3.detail.plyr, C(n2) && n2();
            }), S(function() {
              return e2.querySelector("iframe") && "true" == e2.querySelector("iframe").dataset.ready;
            }, function() {
              s2.resize(e2);
            }), f2.on("enterfullscreen", W), f2.on("exitfullscreen", W);
          });
        }
        function W(e2) {
          var t2 = g(e2.target, ".gslide-media");
          "enterfullscreen" === e2.type && d(t2, "fullscreen"), "exitfullscreen" === e2.type && c(t2, "fullscreen");
        }
        function B(e2, t2, i2, n2) {
          var s2, l2 = this, o2 = e2.querySelector(".gslide-media"), r2 = !(!P(t2, "href") || !t2.href) && t2.href.split("#").pop().trim(), a2 = !(!P(t2, "content") || !t2.content) && t2.content;
          if (a2 && (k(a2) && (s2 = y('<div class="ginlined-content">'.concat(a2, "</div>"))), E(a2))) {
            "none" == a2.style.display && (a2.style.display = "block");
            var c2 = document.createElement("div");
            c2.className = "ginlined-content", c2.appendChild(a2), s2 = c2;
          }
          if (r2) {
            var u2 = document.getElementById(r2);
            if (!u2) return false;
            var g2 = u2.cloneNode(true);
            g2.style.height = t2.height, g2.style.maxWidth = t2.width, d(g2, "ginlined-content"), s2 = g2;
          }
          if (!s2) return console.error("Unable to append inline slide content", t2), false;
          o2.style.height = t2.height, o2.style.width = t2.width, o2.appendChild(s2), this.events["inlineclose" + r2] = h("click", { onElement: o2.querySelectorAll(".gtrigger-close"), withCallback: function(e3) {
            e3.preventDefault(), l2.close();
          } }), C(n2) && n2();
        }
        function H(e2, t2, i2, n2) {
          var s2 = e2.querySelector(".gslide-media"), l2 = function(e3) {
            var t3 = e3.url, i3 = e3.allow, n3 = e3.callback, s3 = e3.appendTo, l3 = document.createElement("iframe");
            return l3.className = "vimeo-video gvideo", l3.src = t3, l3.style.width = "100%", l3.style.height = "100%", i3 && l3.setAttribute("allow", i3), l3.onload = function() {
              l3.onload = null, d(l3, "node-ready"), C(n3) && n3();
            }, s3 && s3.appendChild(l3), l3;
          }({ url: t2.href, callback: n2 });
          s2.parentNode.style.maxWidth = t2.width, s2.parentNode.style.height = t2.height, s2.appendChild(l2);
        }
        var j = i(function t2() {
          var i2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          e(this, t2), this.defaults = { href: "", sizes: "", srcset: "", title: "", type: "", videoProvider: "", description: "", alt: "", descPosition: "bottom", effect: "", width: "", height: "", content: false, zoomable: true, draggable: true }, I(i2) && (this.defaults = o(this.defaults, i2));
        }, [{ key: "sourceType", value: function(e2) {
          var t2 = e2;
          return null !== (e2 = e2.toLowerCase()).match(/\.(jpeg|jpg|jpe|gif|png|apn|webp|avif|svg)/) ? "image" : e2.match(/(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/) || e2.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/) || e2.match(/(youtube\.com|youtube-nocookie\.com)\/embed\/([a-zA-Z0-9\-_]+)/) || e2.match(/(youtube\.com|youtube-nocookie\.com)\/shorts\/([a-zA-Z0-9\-_]+)/) || e2.match(/vimeo\.com\/([0-9]*)/) || null !== e2.match(/\.(mp4|ogg|webm|mov)/) ? "video" : null !== e2.match(/\.(mp3|wav|wma|aac|ogg)/) ? "audio" : e2.indexOf("#") > -1 && "" !== t2.split("#").pop().trim() ? "inline" : e2.indexOf("goajax=true") > -1 ? "ajax" : "external";
        } }, { key: "parseConfig", value: function(e2, t2) {
          var i2 = this, n2 = o({ descPosition: t2.descPosition }, this.defaults);
          if (I(e2) && !E(e2)) {
            P(e2, "type") || (P(e2, "content") && e2.content ? e2.type = "inline" : P(e2, "href") && (e2.type = this.sourceType(e2.href)));
            var s2 = o(n2, e2);
            return this.setSize(s2, t2), s2;
          }
          var l2 = "", a2 = e2.getAttribute("data-glightbox"), h2 = e2.nodeName.toLowerCase();
          if ("a" === h2 && (l2 = e2.href), "img" === h2 && (l2 = e2.src, n2.alt = e2.alt), n2.href = l2, r(n2, function(s3, l3) {
            P(t2, l3) && "width" !== l3 && (n2[l3] = t2[l3]);
            var o2 = e2.dataset[l3];
            O(o2) || (n2[l3] = i2.sanitizeValue(o2));
          }), n2.content && (n2.type = "inline"), !n2.type && l2 && (n2.type = this.sourceType(l2)), O(a2)) {
            if (!n2.title && "a" == h2) {
              var d2 = e2.title;
              O(d2) || "" === d2 || (n2.title = d2);
            }
            if (!n2.title && "img" == h2) {
              var c2 = e2.alt;
              O(c2) || "" === c2 || (n2.title = c2);
            }
          } else {
            var u2 = [];
            r(n2, function(e3, t3) {
              u2.push(";\\s?" + t3);
            }), u2 = u2.join("\\s?:|"), "" !== a2.trim() && r(n2, function(e3, t3) {
              var s3 = a2, l3 = new RegExp("s?" + t3 + "s?:s?(.*?)(" + u2 + "s?:|$)"), o2 = s3.match(l3);
              if (o2 && o2.length && o2[1]) {
                var r2 = o2[1].trim().replace(/;\s*$/, "");
                n2[t3] = i2.sanitizeValue(r2);
              }
            });
          }
          if (n2.description && "." === n2.description.substring(0, 1)) {
            var g2;
            try {
              g2 = document.querySelector(n2.description).innerHTML;
            } catch (e3) {
              if (!(e3 instanceof DOMException)) throw e3;
            }
            g2 && (n2.description = g2);
          }
          if (!n2.description) {
            var v2 = e2.querySelector(".glightbox-desc");
            v2 && (n2.description = v2.innerHTML);
          }
          return this.setSize(n2, t2, e2), this.slideConfig = n2, n2;
        } }, { key: "setSize", value: function(e2, t2) {
          var i2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, n2 = "video" == e2.type ? this.checkSize(t2.videosWidth) : this.checkSize(t2.width), s2 = this.checkSize(t2.height);
          return e2.width = P(e2, "width") && "" !== e2.width ? this.checkSize(e2.width) : n2, e2.height = P(e2, "height") && "" !== e2.height ? this.checkSize(e2.height) : s2, i2 && "image" == e2.type && (e2._hasCustomWidth = !!i2.dataset.width, e2._hasCustomHeight = !!i2.dataset.height), e2;
        } }, { key: "checkSize", value: function(e2) {
          return z(e2) ? "".concat(e2, "px") : e2;
        } }, { key: "sanitizeValue", value: function(e2) {
          return "true" !== e2 && "false" !== e2 ? e2 : "true" === e2;
        } }]), V = i(function t2(i2, n2, s2) {
          e(this, t2), this.element = i2, this.instance = n2, this.index = s2;
        }, [{ key: "setContent", value: function() {
          var e2 = this, t2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, i2 = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          if (u(t2, "loaded")) return false;
          var n2 = this.instance.settings, s2 = this.slideConfig, l2 = T();
          C(n2.beforeSlideLoad) && n2.beforeSlideLoad({ index: this.index, slide: t2, player: false });
          var o2 = s2.type, r2 = s2.descPosition, a2 = t2.querySelector(".gslide-media"), h2 = t2.querySelector(".gslide-title"), c2 = t2.querySelector(".gslide-desc"), g2 = t2.querySelector(".gdesc-inner"), v2 = i2, f2 = "gSlideTitle_" + this.index, p2 = "gSlideDesc_" + this.index;
          if (C(n2.afterSlideLoad) && (v2 = function() {
            C(i2) && i2(), n2.afterSlideLoad({ index: e2.index, slide: t2, player: e2.instance.getSlidePlayerInstance(e2.index) });
          }), "" == s2.title && "" == s2.description ? g2 && g2.parentNode.parentNode.removeChild(g2.parentNode) : (h2 && "" !== s2.title ? (h2.id = f2, h2.innerHTML = s2.title) : h2.parentNode.removeChild(h2), c2 && "" !== s2.description ? (c2.id = p2, l2 && n2.moreLength > 0 ? (s2.smallDescription = this.slideShortDesc(s2.description, n2.moreLength, n2.moreText), c2.innerHTML = s2.smallDescription, this.descriptionEvents(c2, s2)) : c2.innerHTML = s2.description) : c2.parentNode.removeChild(c2), d(a2.parentNode, "desc-".concat(r2)), d(g2.parentNode, "description-".concat(r2))), d(a2, "gslide-".concat(o2)), d(t2, "loaded"), "video" !== o2) {
            if ("external" !== o2) return "inline" === o2 ? (B.apply(this.instance, [t2, s2, this.index, v2]), void (s2.draggable && new N({ dragEl: t2.querySelector(".gslide-inline"), toleranceX: n2.dragToleranceX, toleranceY: n2.dragToleranceY, slide: t2, instance: this.instance }))) : void ("image" !== o2 ? C(v2) && v2() : D(t2, s2, this.index, function() {
              var i3 = t2.querySelector("img");
              s2.draggable && new N({ dragEl: i3, toleranceX: n2.dragToleranceX, toleranceY: n2.dragToleranceY, slide: t2, instance: e2.instance }), s2.zoomable && i3.naturalWidth > i3.offsetWidth && (d(i3, "zoomable"), new q(i3, t2, function() {
                e2.instance.resize();
              })), C(v2) && v2();
            }));
            H.apply(this, [t2, s2, this.index, v2]);
          } else _.apply(this.instance, [t2, s2, this.index, v2]);
        } }, { key: "slideShortDesc", value: function(e2) {
          var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 50, i2 = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n2 = document.createElement("div");
          n2.innerHTML = e2;
          var s2 = n2.innerText, l2 = i2;
          if ((e2 = s2.trim()).length <= t2) return e2;
          var o2 = e2.substr(0, t2 - 1);
          return l2 ? (n2 = null, o2 + '... <a href="#" class="desc-more">' + i2 + "</a>") : o2;
        } }, { key: "descriptionEvents", value: function(e2, t2) {
          var i2 = this, n2 = e2.querySelector(".desc-more");
          if (!n2) return false;
          h("click", { onElement: n2, withCallback: function(e3, n3) {
            e3.preventDefault();
            var s2 = document.body, l2 = g(n3, ".gslide-desc");
            if (!l2) return false;
            l2.innerHTML = t2.description, d(s2, "gdesc-open");
            var o2 = h("click", { onElement: [s2, g(l2, ".gslide-description")], withCallback: function(e4, n4) {
              "a" !== e4.target.nodeName.toLowerCase() && (c(s2, "gdesc-open"), d(s2, "gdesc-closed"), l2.innerHTML = t2.smallDescription, i2.descriptionEvents(l2, t2), setTimeout(function() {
                c(s2, "gdesc-closed");
              }, 400), o2.destroy());
            } });
          } });
        } }, { key: "create", value: function() {
          return y(this.instance.settings.slideHTML);
        } }, { key: "getConfig", value: function() {
          E(this.element) || this.element.hasOwnProperty("draggable") || (this.element.draggable = this.instance.settings.draggable);
          var e2 = new j(this.instance.settings.slideExtraAttributes);
          return this.slideConfig = e2.parseConfig(this.element, this.instance.settings), this.slideConfig;
        } }]);
        function F(e2) {
          return Math.sqrt(e2.x * e2.x + e2.y * e2.y);
        }
        function R(e2, t2) {
          var i2 = function(e3, t3) {
            var i3 = F(e3) * F(t3);
            if (0 === i3) return 0;
            var n2 = function(e4, t4) {
              return e4.x * t4.x + e4.y * t4.y;
            }(e3, t3) / i3;
            return n2 > 1 && (n2 = 1), Math.acos(n2);
          }(e2, t2);
          return function(e3, t3) {
            return e3.x * t3.y - t3.x * e3.y;
          }(e2, t2) > 0 && (i2 *= -1), 180 * i2 / Math.PI;
        }
        var G = i(function t2(i2) {
          e(this, t2), this.handlers = [], this.el = i2;
        }, [{ key: "add", value: function(e2) {
          this.handlers.push(e2);
        } }, { key: "del", value: function(e2) {
          e2 || (this.handlers = []);
          for (var t2 = this.handlers.length; t2 >= 0; t2--) this.handlers[t2] === e2 && this.handlers.splice(t2, 1);
        } }, { key: "dispatch", value: function() {
          for (var e2 = 0, t2 = this.handlers.length; e2 < t2; e2++) {
            var i2 = this.handlers[e2];
            "function" == typeof i2 && i2.apply(this.el, arguments);
          }
        } }]);
        function Z(e2, t2) {
          var i2 = new G(e2);
          return i2.add(t2), i2;
        }
        var U = i(function t2(i2, n2) {
          e(this, t2), this.element = "string" == typeof i2 ? document.querySelector(i2) : i2, this.start = this.start.bind(this), this.move = this.move.bind(this), this.end = this.end.bind(this), this.cancel = this.cancel.bind(this), this.element.addEventListener("touchstart", this.start, false), this.element.addEventListener("touchmove", this.move, false), this.element.addEventListener("touchend", this.end, false), this.element.addEventListener("touchcancel", this.cancel, false), this.preV = { x: null, y: null }, this.pinchStartLen = null, this.zoom = 1, this.isDoubleTap = false;
          var s2 = function() {
          };
          this.rotate = Z(this.element, n2.rotate || s2), this.touchStart = Z(this.element, n2.touchStart || s2), this.multipointStart = Z(this.element, n2.multipointStart || s2), this.multipointEnd = Z(this.element, n2.multipointEnd || s2), this.pinch = Z(this.element, n2.pinch || s2), this.swipe = Z(this.element, n2.swipe || s2), this.tap = Z(this.element, n2.tap || s2), this.doubleTap = Z(this.element, n2.doubleTap || s2), this.longTap = Z(this.element, n2.longTap || s2), this.singleTap = Z(this.element, n2.singleTap || s2), this.pressMove = Z(this.element, n2.pressMove || s2), this.twoFingerPressMove = Z(this.element, n2.twoFingerPressMove || s2), this.touchMove = Z(this.element, n2.touchMove || s2), this.touchEnd = Z(this.element, n2.touchEnd || s2), this.touchCancel = Z(this.element, n2.touchCancel || s2), this.translateContainer = this.element, this._cancelAllHandler = this.cancelAll.bind(this), window.addEventListener("scroll", this._cancelAllHandler), this.delta = null, this.last = null, this.now = null, this.tapTimeout = null, this.singleTapTimeout = null, this.longTapTimeout = null, this.swipeTimeout = null, this.x1 = this.x2 = this.y1 = this.y2 = null, this.preTapPosition = { x: null, y: null };
        }, [{ key: "start", value: function(e2) {
          if (e2.touches) if (e2.target && e2.target.nodeName && ["a", "button", "input"].indexOf(e2.target.nodeName.toLowerCase()) >= 0) console.log("ignore drag for this touched element", e2.target.nodeName.toLowerCase());
          else {
            this.now = Date.now(), this.x1 = e2.touches[0].pageX, this.y1 = e2.touches[0].pageY, this.delta = this.now - (this.last || this.now), this.touchStart.dispatch(e2, this.element), null !== this.preTapPosition.x && (this.isDoubleTap = this.delta > 0 && this.delta <= 250 && Math.abs(this.preTapPosition.x - this.x1) < 30 && Math.abs(this.preTapPosition.y - this.y1) < 30, this.isDoubleTap && clearTimeout(this.singleTapTimeout)), this.preTapPosition.x = this.x1, this.preTapPosition.y = this.y1, this.last = this.now;
            var t2 = this.preV;
            if (e2.touches.length > 1) {
              this._cancelLongTap(), this._cancelSingleTap();
              var i2 = { x: e2.touches[1].pageX - this.x1, y: e2.touches[1].pageY - this.y1 };
              t2.x = i2.x, t2.y = i2.y, this.pinchStartLen = F(t2), this.multipointStart.dispatch(e2, this.element);
            }
            this._preventTap = false, this.longTapTimeout = setTimeout(function() {
              this.longTap.dispatch(e2, this.element), this._preventTap = true;
            }.bind(this), 750);
          }
        } }, { key: "move", value: function(e2) {
          if (e2.touches) {
            var t2 = this.preV, i2 = e2.touches.length, n2 = e2.touches[0].pageX, s2 = e2.touches[0].pageY;
            if (this.isDoubleTap = false, i2 > 1) {
              var l2 = e2.touches[1].pageX, o2 = e2.touches[1].pageY, r2 = { x: e2.touches[1].pageX - n2, y: e2.touches[1].pageY - s2 };
              null !== t2.x && (this.pinchStartLen > 0 && (e2.zoom = F(r2) / this.pinchStartLen, this.pinch.dispatch(e2, this.element)), e2.angle = R(r2, t2), this.rotate.dispatch(e2, this.element)), t2.x = r2.x, t2.y = r2.y, null !== this.x2 && null !== this.sx2 ? (e2.deltaX = (n2 - this.x2 + l2 - this.sx2) / 2, e2.deltaY = (s2 - this.y2 + o2 - this.sy2) / 2) : (e2.deltaX = 0, e2.deltaY = 0), this.twoFingerPressMove.dispatch(e2, this.element), this.sx2 = l2, this.sy2 = o2;
            } else {
              if (null !== this.x2) {
                e2.deltaX = n2 - this.x2, e2.deltaY = s2 - this.y2;
                var a2 = Math.abs(this.x1 - this.x2), h2 = Math.abs(this.y1 - this.y2);
                (a2 > 10 || h2 > 10) && (this._preventTap = true);
              } else e2.deltaX = 0, e2.deltaY = 0;
              this.pressMove.dispatch(e2, this.element);
            }
            this.touchMove.dispatch(e2, this.element), this._cancelLongTap(), this.x2 = n2, this.y2 = s2, i2 > 1 && e2.preventDefault();
          }
        } }, { key: "end", value: function(e2) {
          if (e2.changedTouches) {
            this._cancelLongTap();
            var t2 = this;
            e2.touches.length < 2 && (this.multipointEnd.dispatch(e2, this.element), this.sx2 = this.sy2 = null), this.x2 && Math.abs(this.x1 - this.x2) > 30 || this.y2 && Math.abs(this.y1 - this.y2) > 30 ? (e2.direction = this._swipeDirection(this.x1, this.x2, this.y1, this.y2), this.swipeTimeout = setTimeout(function() {
              t2.swipe.dispatch(e2, t2.element);
            }, 0)) : (this.tapTimeout = setTimeout(function() {
              t2._preventTap || t2.tap.dispatch(e2, t2.element), t2.isDoubleTap && (t2.doubleTap.dispatch(e2, t2.element), t2.isDoubleTap = false);
            }, 0), t2.isDoubleTap || (t2.singleTapTimeout = setTimeout(function() {
              t2.singleTap.dispatch(e2, t2.element);
            }, 250))), this.touchEnd.dispatch(e2, this.element), this.preV.x = 0, this.preV.y = 0, this.zoom = 1, this.pinchStartLen = null, this.x1 = this.x2 = this.y1 = this.y2 = null;
          }
        } }, { key: "cancelAll", value: function() {
          this._preventTap = true, clearTimeout(this.singleTapTimeout), clearTimeout(this.tapTimeout), clearTimeout(this.longTapTimeout), clearTimeout(this.swipeTimeout);
        } }, { key: "cancel", value: function(e2) {
          this.cancelAll(), this.touchCancel.dispatch(e2, this.element);
        } }, { key: "_cancelLongTap", value: function() {
          clearTimeout(this.longTapTimeout);
        } }, { key: "_cancelSingleTap", value: function() {
          clearTimeout(this.singleTapTimeout);
        } }, { key: "_swipeDirection", value: function(e2, t2, i2, n2) {
          return Math.abs(e2 - t2) >= Math.abs(i2 - n2) ? e2 - t2 > 0 ? "Left" : "Right" : i2 - n2 > 0 ? "Up" : "Down";
        } }, { key: "on", value: function(e2, t2) {
          this[e2] && this[e2].add(t2);
        } }, { key: "off", value: function(e2, t2) {
          this[e2] && this[e2].del(t2);
        } }, { key: "destroy", value: function() {
          return this.singleTapTimeout && clearTimeout(this.singleTapTimeout), this.tapTimeout && clearTimeout(this.tapTimeout), this.longTapTimeout && clearTimeout(this.longTapTimeout), this.swipeTimeout && clearTimeout(this.swipeTimeout), this.element.removeEventListener("touchstart", this.start), this.element.removeEventListener("touchmove", this.move), this.element.removeEventListener("touchend", this.end), this.element.removeEventListener("touchcancel", this.cancel), this.rotate.del(), this.touchStart.del(), this.multipointStart.del(), this.multipointEnd.del(), this.pinch.del(), this.swipe.del(), this.tap.del(), this.doubleTap.del(), this.longTap.del(), this.singleTap.del(), this.pressMove.del(), this.twoFingerPressMove.del(), this.touchMove.del(), this.touchEnd.del(), this.touchCancel.del(), this.preV = this.pinchStartLen = this.zoom = this.isDoubleTap = this.delta = this.last = this.now = this.tapTimeout = this.singleTapTimeout = this.longTapTimeout = this.swipeTimeout = this.x1 = this.x2 = this.y1 = this.y2 = this.preTapPosition = this.rotate = this.touchStart = this.multipointStart = this.multipointEnd = this.pinch = this.swipe = this.tap = this.doubleTap = this.longTap = this.singleTap = this.pressMove = this.touchMove = this.touchEnd = this.touchCancel = this.twoFingerPressMove = null, window.removeEventListener("scroll", this._cancelAllHandler), null;
        } }]);
        function $(e2) {
          var t2 = function() {
            var e3, t3 = document.createElement("fakeelement"), i3 = { transition: "transitionend", OTransition: "oTransitionEnd", MozTransition: "transitionend", WebkitTransition: "webkitTransitionEnd" };
            for (e3 in i3) if (void 0 !== t3.style[e3]) return i3[e3];
          }(), i2 = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth, n2 = u(e2, "gslide-media") ? e2 : e2.querySelector(".gslide-media"), s2 = g(n2, ".ginner-container"), l2 = e2.querySelector(".gslide-description");
          i2 > 769 && (n2 = s2), d(n2, "greset"), f(n2, "translate3d(0, 0, 0)"), h(t2, { onElement: n2, once: true, withCallback: function(e3, t3) {
            c(n2, "greset");
          } }), n2.style.opacity = "", l2 && (l2.style.opacity = "");
        }
        function J(e2) {
          if (e2.events.hasOwnProperty("touch")) return false;
          var t2, i2, n2, s2 = x(), l2 = s2.width, o2 = s2.height, r2 = false, a2 = null, h2 = null, v2 = null, p2 = false, m2 = 1, y2 = 1, b2 = false, S2 = false, w2 = null, T2 = null, C2 = null, k2 = null, E2 = 0, A2 = 0, L2 = false, I2 = false, O2 = {}, P2 = {}, M2 = 0, z2 = 0, X2 = document.getElementById("glightbox-slider"), Y2 = document.querySelector(".goverlay"), q2 = new U(X2, { touchStart: function(t3) {
            if (r2 = true, (u(t3.targetTouches[0].target, "ginner-container") || g(t3.targetTouches[0].target, ".gslide-desc") || "a" == t3.targetTouches[0].target.nodeName.toLowerCase()) && (r2 = false), g(t3.targetTouches[0].target, ".gslide-inline") && !u(t3.targetTouches[0].target.parentNode, "gslide-inline") && (r2 = false), r2) {
              if (P2 = t3.targetTouches[0], O2.pageX = t3.targetTouches[0].pageX, O2.pageY = t3.targetTouches[0].pageY, M2 = t3.targetTouches[0].clientX, z2 = t3.targetTouches[0].clientY, a2 = e2.activeSlide, h2 = a2.querySelector(".gslide-media"), n2 = a2.querySelector(".gslide-inline"), v2 = null, u(h2, "gslide-image") && (v2 = h2.querySelector("img")), (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) > 769 && (h2 = a2.querySelector(".ginner-container")), c(Y2, "greset"), t3.pageX > 20 && t3.pageX < window.innerWidth - 20) return;
              t3.preventDefault();
            }
          }, touchMove: function(s3) {
            if (r2 && (P2 = s3.targetTouches[0], !b2 && !S2)) {
              if (n2 && n2.offsetHeight > o2) {
                var a3 = O2.pageX - P2.pageX;
                if (Math.abs(a3) <= 13) return false;
              }
              p2 = true;
              var d2, c2 = s3.targetTouches[0].clientX, u2 = s3.targetTouches[0].clientY, g2 = M2 - c2, m3 = z2 - u2;
              if (Math.abs(g2) > Math.abs(m3) ? (L2 = false, I2 = true) : (I2 = false, L2 = true), t2 = P2.pageX - O2.pageX, E2 = 100 * t2 / l2, i2 = P2.pageY - O2.pageY, A2 = 100 * i2 / o2, L2 && v2 && (d2 = 1 - Math.abs(i2) / o2, Y2.style.opacity = d2, e2.settings.touchFollowAxis && (E2 = 0)), I2 && (d2 = 1 - Math.abs(t2) / l2, h2.style.opacity = d2, e2.settings.touchFollowAxis && (A2 = 0)), !v2) return f(h2, "translate3d(".concat(E2, "%, 0, 0)"));
              f(h2, "translate3d(".concat(E2, "%, ").concat(A2, "%, 0)"));
            }
          }, touchEnd: function() {
            if (r2) {
              if (p2 = false, S2 || b2) return C2 = w2, void (k2 = T2);
              var t3 = Math.abs(parseInt(A2)), i3 = Math.abs(parseInt(E2));
              if (!(t3 > 29 && v2)) return t3 < 29 && i3 < 25 ? (d(Y2, "greset"), Y2.style.opacity = 1, $(h2)) : void 0;
              e2.close();
            }
          }, multipointEnd: function() {
            setTimeout(function() {
              b2 = false;
            }, 50);
          }, multipointStart: function() {
            b2 = true, m2 = y2 || 1;
          }, pinch: function(e3) {
            if (!v2 || p2) return false;
            b2 = true, v2.scaleX = v2.scaleY = m2 * e3.zoom;
            var t3 = m2 * e3.zoom;
            if (S2 = true, t3 <= 1) return S2 = false, t3 = 1, k2 = null, C2 = null, w2 = null, T2 = null, void v2.setAttribute("style", "");
            t3 > 4.5 && (t3 = 4.5), v2.style.transform = "scale3d(".concat(t3, ", ").concat(t3, ", 1)"), y2 = t3;
          }, pressMove: function(e3) {
            if (S2 && !b2) {
              var t3 = P2.pageX - O2.pageX, i3 = P2.pageY - O2.pageY;
              C2 && (t3 += C2), k2 && (i3 += k2), w2 = t3, T2 = i3;
              var n3 = "translate3d(".concat(t3, "px, ").concat(i3, "px, 0)");
              y2 && (n3 += " scale3d(".concat(y2, ", ").concat(y2, ", 1)")), f(v2, n3);
            }
          }, swipe: function(t3) {
            if (!S2) if (b2) b2 = false;
            else {
              if ("Left" == t3.direction) {
                if (e2.index == e2.elements.length - 1) return $(h2);
                e2.nextSlide();
              }
              if ("Right" == t3.direction) {
                if (0 == e2.index) return $(h2);
                e2.prevSlide();
              }
            }
          } });
          e2.events.touch = q2;
        }
        var K = T(), Q = null !== T() || void 0 !== document.createTouch || "ontouchstart" in window || "onmsgesturechange" in window || navigator.msMaxTouchPoints, ee = document.getElementsByTagName("html")[0], te = { selector: ".glightbox", elements: null, skin: "clean", theme: "clean", closeButton: true, startAt: null, autoplayVideos: true, autofocusVideos: true, descPosition: "bottom", width: "900px", height: "506px", videosWidth: "960px", beforeSlideChange: null, afterSlideChange: null, beforeSlideLoad: null, afterSlideLoad: null, slideInserted: null, slideRemoved: null, slideExtraAttributes: null, onOpen: null, onClose: null, loop: false, zoomable: true, draggable: true, dragAutoSnap: false, dragToleranceX: 40, dragToleranceY: 65, preload: true, oneSlidePerOpen: false, touchNavigation: true, touchFollowAxis: true, keyboardNavigation: true, closeOnOutsideClick: true, plugins: false, plyr: { css: "https://cdn.plyr.io/3.6.12/plyr.css", js: "https://cdn.plyr.io/3.6.12/plyr.js", config: { ratio: "16:9", fullscreen: { enabled: true, iosNative: true }, youtube: { noCookie: true, rel: 0, showinfo: 0, iv_load_policy: 3 }, vimeo: { byline: false, portrait: false, title: false, transparent: false } } }, openEffect: "zoom", closeEffect: "zoom", slideEffect: "slide", moreText: "See more", moreLength: 60, cssEfects: { fade: { in: "fadeIn", out: "fadeOut" }, zoom: { in: "zoomIn", out: "zoomOut" }, slide: { in: "slideInRight", out: "slideOutLeft" }, slideBack: { in: "slideInLeft", out: "slideOutRight" }, none: { in: "none", out: "none" } }, svg: { close: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve"><g><g><path d="M505.943,6.058c-8.077-8.077-21.172-8.077-29.249,0L6.058,476.693c-8.077,8.077-8.077,21.172,0,29.249C10.096,509.982,15.39,512,20.683,512c5.293,0,10.586-2.019,14.625-6.059L505.943,35.306C514.019,27.23,514.019,14.135,505.943,6.058z"/></g></g><g><g><path d="M505.942,476.694L35.306,6.059c-8.076-8.077-21.172-8.077-29.248,0c-8.077,8.076-8.077,21.171,0,29.248l470.636,470.636c4.038,4.039,9.332,6.058,14.625,6.058c5.293,0,10.587-2.019,14.624-6.057C514.018,497.866,514.018,484.771,505.942,476.694z"/></g></g></svg>', next: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve"> <g><path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"/></g></svg>', prev: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve"><g><path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"/></g></svg>' }, slideHTML: '<div class="gslide">\n    <div class="gslide-inner-content">\n        <div class="ginner-container">\n            <div class="gslide-media">\n            </div>\n            <div class="gslide-description">\n                <div class="gdesc-inner">\n                    <h4 class="gslide-title"></h4>\n                    <div class="gslide-desc"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>', lightboxHTML: '<div id="glightbox-body" class="glightbox-container" tabindex="-1" role="dialog" aria-hidden="false">\n    <div class="gloader visible"></div>\n    <div class="goverlay"></div>\n    <div class="gcontainer">\n    <div id="glightbox-slider" class="gslider"></div>\n    <button class="gclose gbtn" aria-label="Close" data-taborder="3">{closeSVG}</button>\n    <button class="gprev gbtn" aria-label="Previous" data-taborder="2">{prevSVG}</button>\n    <button class="gnext gbtn" aria-label="Next" data-taborder="1">{nextSVG}</button>\n</div>\n</div>' }, ie = i(function t2() {
          var i2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          e(this, t2), this.customOptions = i2, this.settings = o(te, i2), this.effectsClasses = this.getAnimationClasses(), this.videoPlayers = {}, this.apiEvents = [], this.fullElementsList = false;
        }, [{ key: "init", value: function() {
          var e2 = this, t2 = this.getSelector();
          t2 && (this.baseEvents = h("click", { onElement: t2, withCallback: function(t3, i2) {
            t3.preventDefault(), e2.open(i2);
          } })), this.elements = this.getElements();
        } }, { key: "open", value: function() {
          var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
          if (0 === this.elements.length) return false;
          this.activeSlide = null, this.prevActiveSlideIndex = null, this.prevActiveSlide = null;
          var i2 = z(t2) ? t2 : this.settings.startAt;
          if (E(e2)) {
            var n2 = e2.getAttribute("data-gallery");
            n2 && (this.fullElementsList = this.elements, this.elements = this.getGalleryElements(this.elements, n2)), O(i2) && (i2 = this.getElementIndex(e2)) < 0 && (i2 = 0);
          }
          z(i2) || (i2 = 0), this.build(), v(this.overlay, "none" === this.settings.openEffect ? "none" : this.settings.cssEfects.fade.in);
          var s2 = document.body, l2 = window.innerWidth - document.documentElement.clientWidth;
          if (l2 > 0) {
            var o2 = document.createElement("style");
            o2.type = "text/css", o2.className = "gcss-styles", o2.innerText = ".gscrollbar-fixer {margin-right: ".concat(l2, "px}"), document.head.appendChild(o2), d(s2, "gscrollbar-fixer");
          }
          d(s2, "glightbox-open"), d(ee, "glightbox-open"), K && (d(document.body, "glightbox-mobile"), this.settings.slideEffect = "slide"), this.showSlide(i2, true), 1 === this.elements.length ? (d(this.prevButton, "glightbox-button-hidden"), d(this.nextButton, "glightbox-button-hidden")) : (c(this.prevButton, "glightbox-button-hidden"), c(this.nextButton, "glightbox-button-hidden")), this.lightboxOpen = true, this.trigger("open"), C(this.settings.onOpen) && this.settings.onOpen(), Q && this.settings.touchNavigation && J(this), this.settings.keyboardNavigation && Y(this);
        } }, { key: "openAt", value: function() {
          var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
          this.open(null, e2);
        } }, { key: "showSlide", value: function() {
          var e2 = this, t2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, i2 = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          p(this.loader), this.index = parseInt(t2);
          var n2 = this.slidesContainer.querySelector(".current");
          n2 && c(n2, "current"), this.slideAnimateOut();
          var s2 = this.slidesContainer.querySelectorAll(".gslide")[t2];
          if (u(s2, "loaded")) this.slideAnimateIn(s2, i2), m(this.loader);
          else {
            p(this.loader);
            var l2 = this.elements[t2], o2 = { index: this.index, slide: s2, slideNode: s2, slideConfig: l2.slideConfig, slideIndex: this.index, trigger: l2.node, player: null };
            this.trigger("slide_before_load", o2), l2.instance.setContent(s2, function() {
              m(e2.loader), e2.resize(), e2.slideAnimateIn(s2, i2), e2.trigger("slide_after_load", o2);
            });
          }
          this.slideDescription = s2.querySelector(".gslide-description"), this.slideDescriptionContained = this.slideDescription && u(this.slideDescription.parentNode, "gslide-media"), this.settings.preload && (this.preloadSlide(t2 + 1), this.preloadSlide(t2 - 1)), this.updateNavigationClasses(), this.activeSlide = s2;
        } }, { key: "preloadSlide", value: function(e2) {
          var t2 = this;
          if (e2 < 0 || e2 > this.elements.length - 1) return false;
          if (O(this.elements[e2])) return false;
          var i2 = this.slidesContainer.querySelectorAll(".gslide")[e2];
          if (u(i2, "loaded")) return false;
          var n2 = this.elements[e2], s2 = n2.type, l2 = { index: e2, slide: i2, slideNode: i2, slideConfig: n2.slideConfig, slideIndex: e2, trigger: n2.node, player: null };
          this.trigger("slide_before_load", l2), "video" === s2 || "external" === s2 ? setTimeout(function() {
            n2.instance.setContent(i2, function() {
              t2.trigger("slide_after_load", l2);
            });
          }, 200) : n2.instance.setContent(i2, function() {
            t2.trigger("slide_after_load", l2);
          });
        } }, { key: "prevSlide", value: function() {
          this.goToSlide(this.index - 1);
        } }, { key: "nextSlide", value: function() {
          this.goToSlide(this.index + 1);
        } }, { key: "goToSlide", value: function() {
          var e2 = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          if (this.prevActiveSlide = this.activeSlide, this.prevActiveSlideIndex = this.index, !this.loop() && (e2 < 0 || e2 > this.elements.length - 1)) return false;
          e2 < 0 ? e2 = this.elements.length - 1 : e2 >= this.elements.length && (e2 = 0), this.showSlide(e2);
        } }, { key: "insertSlide", value: function() {
          var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1;
          t2 < 0 && (t2 = this.elements.length);
          var i2 = new V(e2, this, t2), n2 = i2.getConfig(), s2 = o({}, n2), l2 = i2.create(), r2 = this.elements.length - 1;
          s2.index = t2, s2.node = false, s2.instance = i2, s2.slideConfig = n2, this.elements.splice(t2, 0, s2);
          var a2 = null, h2 = null;
          if (this.slidesContainer) {
            if (t2 > r2) this.slidesContainer.appendChild(l2);
            else {
              var d2 = this.slidesContainer.querySelectorAll(".gslide")[t2];
              this.slidesContainer.insertBefore(l2, d2);
            }
            (this.settings.preload && 0 == this.index && 0 == t2 || this.index - 1 == t2 || this.index + 1 == t2) && this.preloadSlide(t2), 0 === this.index && 0 === t2 && (this.index = 1), this.updateNavigationClasses(), a2 = this.slidesContainer.querySelectorAll(".gslide")[t2], h2 = this.getSlidePlayerInstance(t2), s2.slideNode = a2;
          }
          this.trigger("slide_inserted", { index: t2, slide: a2, slideNode: a2, slideConfig: n2, slideIndex: t2, trigger: null, player: h2 }), C(this.settings.slideInserted) && this.settings.slideInserted({ index: t2, slide: a2, player: h2 });
        } }, { key: "removeSlide", value: function() {
          var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : -1;
          if (e2 < 0 || e2 > this.elements.length - 1) return false;
          var t2 = this.slidesContainer && this.slidesContainer.querySelectorAll(".gslide")[e2];
          t2 && (this.getActiveSlideIndex() == e2 && (e2 == this.elements.length - 1 ? this.prevSlide() : this.nextSlide()), t2.parentNode.removeChild(t2)), this.elements.splice(e2, 1), this.trigger("slide_removed", e2), C(this.settings.slideRemoved) && this.settings.slideRemoved(e2);
        } }, { key: "slideAnimateIn", value: function(e2, t2) {
          var i2 = this, n2 = e2.querySelector(".gslide-media"), s2 = e2.querySelector(".gslide-description"), l2 = { index: this.prevActiveSlideIndex, slide: this.prevActiveSlide, slideNode: this.prevActiveSlide, slideIndex: this.prevActiveSlide, slideConfig: O(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].slideConfig, trigger: O(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].node, player: this.getSlidePlayerInstance(this.prevActiveSlideIndex) }, o2 = { index: this.index, slide: this.activeSlide, slideNode: this.activeSlide, slideConfig: this.elements[this.index].slideConfig, slideIndex: this.index, trigger: this.elements[this.index].node, player: this.getSlidePlayerInstance(this.index) };
          if (n2.offsetWidth > 0 && s2 && (m(s2), s2.style.display = ""), c(e2, this.effectsClasses), t2) v(e2, this.settings.cssEfects[this.settings.openEffect].in, function() {
            i2.settings.autoplayVideos && i2.slidePlayerPlay(e2), i2.trigger("slide_changed", { prev: l2, current: o2 }), C(i2.settings.afterSlideChange) && i2.settings.afterSlideChange.apply(i2, [l2, o2]);
          });
          else {
            var r2 = this.settings.slideEffect, a2 = "none" !== r2 ? this.settings.cssEfects[r2].in : r2;
            this.prevActiveSlideIndex > this.index && "slide" == this.settings.slideEffect && (a2 = this.settings.cssEfects.slideBack.in), v(e2, a2, function() {
              i2.settings.autoplayVideos && i2.slidePlayerPlay(e2), i2.trigger("slide_changed", { prev: l2, current: o2 }), C(i2.settings.afterSlideChange) && i2.settings.afterSlideChange.apply(i2, [l2, o2]);
            });
          }
          setTimeout(function() {
            i2.resize(e2);
          }, 100), d(e2, "current");
        } }, { key: "slideAnimateOut", value: function() {
          if (!this.prevActiveSlide) return false;
          var e2 = this.prevActiveSlide;
          c(e2, this.effectsClasses), d(e2, "prev");
          var t2 = this.settings.slideEffect, i2 = "none" !== t2 ? this.settings.cssEfects[t2].out : t2;
          this.slidePlayerPause(e2), this.trigger("slide_before_change", { prev: { index: this.prevActiveSlideIndex, slide: this.prevActiveSlide, slideNode: this.prevActiveSlide, slideIndex: this.prevActiveSlideIndex, slideConfig: O(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].slideConfig, trigger: O(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].node, player: this.getSlidePlayerInstance(this.prevActiveSlideIndex) }, current: { index: this.index, slide: this.activeSlide, slideNode: this.activeSlide, slideIndex: this.index, slideConfig: this.elements[this.index].slideConfig, trigger: this.elements[this.index].node, player: this.getSlidePlayerInstance(this.index) } }), C(this.settings.beforeSlideChange) && this.settings.beforeSlideChange.apply(this, [{ index: this.prevActiveSlideIndex, slide: this.prevActiveSlide, player: this.getSlidePlayerInstance(this.prevActiveSlideIndex) }, { index: this.index, slide: this.activeSlide, player: this.getSlidePlayerInstance(this.index) }]), this.prevActiveSlideIndex > this.index && "slide" == this.settings.slideEffect && (i2 = this.settings.cssEfects.slideBack.out), v(e2, i2, function() {
            var t3 = e2.querySelector(".ginner-container"), i3 = e2.querySelector(".gslide-media"), n2 = e2.querySelector(".gslide-description");
            t3.style.transform = "", i3.style.transform = "", c(i3, "greset"), i3.style.opacity = "", n2 && (n2.style.opacity = ""), c(e2, "prev");
          });
        } }, { key: "getAllPlayers", value: function() {
          return this.videoPlayers;
        } }, { key: "getSlidePlayerInstance", value: function(e2) {
          var t2 = "gvideo" + e2, i2 = this.getAllPlayers();
          return !(!P(i2, t2) || !i2[t2]) && i2[t2];
        } }, { key: "stopSlideVideo", value: function(e2) {
          if (E(e2)) {
            var t2 = e2.querySelector(".gvideo-wrapper");
            t2 && (e2 = t2.getAttribute("data-index"));
          }
          console.log("stopSlideVideo is deprecated, use slidePlayerPause");
          var i2 = this.getSlidePlayerInstance(e2);
          i2 && i2.playing && i2.pause();
        } }, { key: "slidePlayerPause", value: function(e2) {
          if (E(e2)) {
            var t2 = e2.querySelector(".gvideo-wrapper");
            t2 && (e2 = t2.getAttribute("data-index"));
          }
          var i2 = this.getSlidePlayerInstance(e2);
          i2 && i2.playing && i2.pause();
        } }, { key: "playSlideVideo", value: function(e2) {
          if (E(e2)) {
            var t2 = e2.querySelector(".gvideo-wrapper");
            t2 && (e2 = t2.getAttribute("data-index"));
          }
          console.log("playSlideVideo is deprecated, use slidePlayerPlay");
          var i2 = this.getSlidePlayerInstance(e2);
          i2 && !i2.playing && i2.play();
        } }, { key: "slidePlayerPlay", value: function(e2) {
          var t2;
          if (!K || null !== (t2 = this.settings.plyr.config) && void 0 !== t2 && t2.muted) {
            if (E(e2)) {
              var i2 = e2.querySelector(".gvideo-wrapper");
              i2 && (e2 = i2.getAttribute("data-index"));
            }
            var n2 = this.getSlidePlayerInstance(e2);
            n2 && !n2.playing && (n2.play(), this.settings.autofocusVideos && n2.elements.container.focus());
          }
        } }, { key: "setElements", value: function(e2) {
          var t2 = this;
          this.settings.elements = false;
          var i2 = [];
          e2 && e2.length && r(e2, function(e3, n2) {
            var s2 = new V(e3, t2, n2), l2 = s2.getConfig(), r2 = o({}, l2);
            r2.slideConfig = l2, r2.instance = s2, r2.index = n2, i2.push(r2);
          }), this.elements = i2, this.lightboxOpen && (this.slidesContainer.innerHTML = "", this.elements.length && (r(this.elements, function() {
            var e3 = y(t2.settings.slideHTML);
            t2.slidesContainer.appendChild(e3);
          }), this.showSlide(0, true)));
        } }, { key: "getElementIndex", value: function(e2) {
          var t2 = false;
          return r(this.elements, function(i2, n2) {
            if (P(i2, "node") && i2.node == e2) return t2 = n2, true;
          }), t2;
        } }, { key: "getElements", value: function() {
          var e2 = this, t2 = [];
          this.elements = this.elements ? this.elements : [], !O(this.settings.elements) && A(this.settings.elements) && this.settings.elements.length && r(this.settings.elements, function(i3, n2) {
            var s2 = new V(i3, e2, n2), l2 = s2.getConfig(), r2 = o({}, l2);
            r2.node = false, r2.index = n2, r2.instance = s2, r2.slideConfig = l2, t2.push(r2);
          });
          var i2 = false;
          return this.getSelector() && (i2 = document.querySelectorAll(this.getSelector())), i2 ? (r(i2, function(i3, n2) {
            var s2 = new V(i3, e2, n2), l2 = s2.getConfig(), r2 = o({}, l2);
            r2.node = i3, r2.index = n2, r2.instance = s2, r2.slideConfig = l2, r2.gallery = i3.getAttribute("data-gallery"), t2.push(r2);
          }), t2) : t2;
        } }, { key: "getGalleryElements", value: function(e2, t2) {
          return e2.filter(function(e3) {
            return e3.gallery == t2;
          });
        } }, { key: "getSelector", value: function() {
          return !this.settings.elements && (this.settings.selector && "data-" == this.settings.selector.substring(0, 5) ? "*[".concat(this.settings.selector, "]") : this.settings.selector);
        } }, { key: "getActiveSlide", value: function() {
          return this.slidesContainer.querySelectorAll(".gslide")[this.index];
        } }, { key: "getActiveSlideIndex", value: function() {
          return this.index;
        } }, { key: "getAnimationClasses", value: function() {
          var e2 = [];
          for (var t2 in this.settings.cssEfects) if (this.settings.cssEfects.hasOwnProperty(t2)) {
            var i2 = this.settings.cssEfects[t2];
            e2.push("g".concat(i2.in)), e2.push("g".concat(i2.out));
          }
          return e2.join(" ");
        } }, { key: "build", value: function() {
          var e2 = this;
          if (this.built) return false;
          var t2 = document.body.childNodes, i2 = [];
          r(t2, function(e3) {
            e3.parentNode == document.body && "#" !== e3.nodeName.charAt(0) && e3.hasAttribute && !e3.hasAttribute("aria-hidden") && (i2.push(e3), e3.setAttribute("aria-hidden", "true"));
          });
          var n2 = P(this.settings.svg, "next") ? this.settings.svg.next : "", s2 = P(this.settings.svg, "prev") ? this.settings.svg.prev : "", l2 = P(this.settings.svg, "close") ? this.settings.svg.close : "", o2 = this.settings.lightboxHTML;
          o2 = y(o2 = (o2 = (o2 = o2.replace(/{nextSVG}/g, n2)).replace(/{prevSVG}/g, s2)).replace(/{closeSVG}/g, l2)), document.body.appendChild(o2);
          var a2 = document.getElementById("glightbox-body");
          this.modal = a2;
          var c2 = a2.querySelector(".gclose");
          this.prevButton = a2.querySelector(".gprev"), this.nextButton = a2.querySelector(".gnext"), this.overlay = a2.querySelector(".goverlay"), this.loader = a2.querySelector(".gloader"), this.slidesContainer = document.getElementById("glightbox-slider"), this.bodyHiddenChildElms = i2, this.events = {}, d(this.modal, "glightbox-" + this.settings.skin), this.settings.closeButton && c2 && (this.events.close = h("click", { onElement: c2, withCallback: function(t3, i3) {
            t3.preventDefault(), e2.close();
          } })), c2 && !this.settings.closeButton && c2.parentNode.removeChild(c2), this.nextButton && (this.events.next = h("click", { onElement: this.nextButton, withCallback: function(t3, i3) {
            t3.preventDefault(), e2.nextSlide();
          } })), this.prevButton && (this.events.prev = h("click", { onElement: this.prevButton, withCallback: function(t3, i3) {
            t3.preventDefault(), e2.prevSlide();
          } })), this.settings.closeOnOutsideClick && (this.events.outClose = h("click", { onElement: a2, withCallback: function(t3, i3) {
            e2.preventOutsideClick || u(document.body, "glightbox-mobile") || g(t3.target, ".ginner-container") || g(t3.target, ".gbtn") || u(t3.target, "gnext") || u(t3.target, "gprev") || e2.close();
          } })), r(this.elements, function(t3, i3) {
            e2.slidesContainer.appendChild(t3.instance.create()), t3.slideNode = e2.slidesContainer.querySelectorAll(".gslide")[i3];
          }), Q && d(document.body, "glightbox-touch"), this.events.resize = h("resize", { onElement: window, withCallback: function() {
            e2.resize();
          } }), this.built = true;
        } }, { key: "resize", value: function() {
          var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
          if ((e2 = e2 || this.activeSlide) && !u(e2, "zoomed")) {
            var t2 = x(), i2 = e2.querySelector(".gvideo-wrapper"), n2 = e2.querySelector(".gslide-image"), s2 = this.slideDescription, l2 = t2.width, o2 = t2.height;
            if (l2 <= 768 ? d(document.body, "glightbox-mobile") : c(document.body, "glightbox-mobile"), i2 || n2) {
              var r2 = false;
              if (s2 && (u(s2, "description-bottom") || u(s2, "description-top")) && !u(s2, "gabsolute") && (r2 = true), n2) {
                if (l2 <= 768) n2.querySelector("img");
                else if (r2) {
                  var a2, h2, g2 = s2.offsetHeight, v2 = n2.querySelector("img"), f2 = null === (a2 = this.elements[this.index]) || void 0 === a2 ? void 0 : a2.node, p2 = "100vh";
                  f2 && (p2 = null !== (h2 = f2.getAttribute("data-height")) && void 0 !== h2 ? h2 : p2), v2.setAttribute("style", "max-height: calc(".concat(p2, " - ").concat(g2, "px)")), s2.setAttribute("style", "max-width: ".concat(v2.offsetWidth, "px;"));
                }
              }
              if (i2) {
                var m2 = P(this.settings.plyr.config, "ratio") ? this.settings.plyr.config.ratio : "";
                if (!m2) {
                  var y2 = i2.clientWidth, b2 = i2.clientHeight, S2 = y2 / b2;
                  m2 = "".concat(y2 / S2, ":").concat(b2 / S2);
                }
                var w2 = m2.split(":"), T2 = this.settings.videosWidth, C2 = this.settings.videosWidth, k2 = (C2 = z(T2) || -1 !== T2.indexOf("px") ? parseInt(T2) : -1 !== T2.indexOf("vw") ? l2 * parseInt(T2) / 100 : -1 !== T2.indexOf("vh") ? o2 * parseInt(T2) / 100 : -1 !== T2.indexOf("%") ? l2 * parseInt(T2) / 100 : parseInt(i2.clientWidth)) / (parseInt(w2[0]) / parseInt(w2[1]));
                if (k2 = Math.floor(k2), r2 && (o2 -= s2.offsetHeight), C2 > l2 || k2 > o2 || o2 < k2 && l2 > C2) {
                  var E2 = i2.offsetWidth, A2 = i2.offsetHeight, L2 = o2 / A2, I2 = { width: E2 * L2, height: A2 * L2 };
                  i2.parentNode.setAttribute("style", "max-width: ".concat(I2.width, "px")), r2 && s2.setAttribute("style", "max-width: ".concat(I2.width, "px;"));
                } else i2.parentNode.style.maxWidth = "".concat(T2), r2 && s2.setAttribute("style", "max-width: ".concat(T2, ";"));
              }
            }
          }
        } }, { key: "reload", value: function() {
          this.init();
        } }, { key: "updateNavigationClasses", value: function() {
          var e2 = this.loop();
          c(this.nextButton, "disabled"), c(this.prevButton, "disabled"), 0 == this.index && this.elements.length - 1 == 0 ? (d(this.prevButton, "disabled"), d(this.nextButton, "disabled")) : 0 !== this.index || e2 ? this.index !== this.elements.length - 1 || e2 || d(this.nextButton, "disabled") : d(this.prevButton, "disabled");
        } }, { key: "loop", value: function() {
          var e2 = P(this.settings, "loopAtEnd") ? this.settings.loopAtEnd : null;
          return e2 = P(this.settings, "loop") ? this.settings.loop : e2, e2;
        } }, { key: "close", value: function() {
          var e2 = this;
          if (!this.lightboxOpen) {
            if (this.events) {
              for (var t2 in this.events) this.events.hasOwnProperty(t2) && this.events[t2].destroy();
              this.events = null;
            }
            return false;
          }
          if (this.closing) return false;
          this.closing = true, this.slidePlayerPause(this.activeSlide), this.fullElementsList && (this.elements = this.fullElementsList), this.bodyHiddenChildElms.length && r(this.bodyHiddenChildElms, function(e3) {
            e3.removeAttribute("aria-hidden");
          }), d(this.modal, "glightbox-closing"), v(this.overlay, "none" == this.settings.openEffect ? "none" : this.settings.cssEfects.fade.out), v(this.activeSlide, this.settings.cssEfects[this.settings.closeEffect].out, function() {
            if (e2.activeSlide = null, e2.prevActiveSlideIndex = null, e2.prevActiveSlide = null, e2.built = false, e2.events) {
              for (var t3 in e2.events) e2.events.hasOwnProperty(t3) && e2.events[t3].destroy();
              e2.events = null;
            }
            var i2 = document.body;
            c(ee, "glightbox-open"), c(i2, "glightbox-open touching gdesc-open glightbox-touch glightbox-mobile gscrollbar-fixer"), e2.modal.parentNode.removeChild(e2.modal), e2.trigger("close"), C(e2.settings.onClose) && e2.settings.onClose();
            var n2 = document.querySelector(".gcss-styles");
            n2 && n2.parentNode.removeChild(n2), e2.lightboxOpen = false, e2.closing = null;
          });
        } }, { key: "destroy", value: function() {
          this.close(), this.clearAllEvents(), this.baseEvents && this.baseEvents.destroy();
        } }, { key: "on", value: function(e2, t2) {
          var i2 = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          if (!e2 || !C(t2)) throw new TypeError("Event name and callback must be defined");
          this.apiEvents.push({ evt: e2, once: i2, callback: t2 });
        } }, { key: "once", value: function(e2, t2) {
          this.on(e2, t2, true);
        } }, { key: "trigger", value: function(e2) {
          var t2 = this, i2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, n2 = [];
          r(this.apiEvents, function(t3, s2) {
            var l2 = t3.evt, o2 = t3.once, r2 = t3.callback;
            l2 == e2 && (r2(i2), o2 && n2.push(s2));
          }), n2.length && r(n2, function(e3) {
            return t2.apiEvents.splice(e3, 1);
          });
        } }, { key: "clearAllEvents", value: function() {
          this.apiEvents.splice(0, this.apiEvents.length);
        } }, { key: "version", value: function() {
          return "3.3.1";
        } }]);
        return function() {
          var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t2 = new ie(e2);
          return t2.init(), t2;
        };
      });
    }
  });

  // src/js/mobile-menu.js
  function initMobileMenu() {
    const menu = document.getElementById("hygge-mobile-menu");
    if (!menu) return;
    const rootView = menu.querySelector('[data-menu-view="root"]');
    const stage = menu.querySelector(".mobile-menu__stage");
    const toggleButtons = document.querySelectorAll("[data-mobile-menu-open]");
    let activeSubmenu = null;
    let savedScrollY = 0;
    let touchMoveHandler = null;
    const getToggleIcons = (button) => ({
      open: button.querySelector(".hygge-mobile-menu__toggle-icon--open"),
      close: button.querySelector(".hygge-mobile-menu__toggle-icon--close")
    });
    const isMenuScrollable = (target) => {
      const scrollable = target.closest(
        ".mobile-menu__submenu-inner, .mobile-menu__list--tier-1, .custom-select__listbox, .mobile-menu__footer, .mobile-menu__localization"
      );
      if (!scrollable) return false;
      return scrollable.scrollHeight > scrollable.clientHeight;
    };
    const lockPageScroll = () => {
      savedScrollY = window.scrollY;
      document.body.classList.add("mobile-menu-active");
      document.body.style.position = "fixed";
      document.body.style.top = `-${savedScrollY}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.width = "100%";
      touchMoveHandler = (event2) => {
        if (!menu.classList.contains("mobile-menu--open")) return;
        if (isMenuScrollable(event2.target)) return;
        event2.preventDefault();
      };
      document.addEventListener("touchmove", touchMoveHandler, { passive: false });
    };
    const unlockPageScroll = () => {
      document.body.classList.remove("mobile-menu-active");
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";
      window.scrollTo({ top: savedScrollY, left: 0, behavior: "instant" });
      if (touchMoveHandler) {
        document.removeEventListener("touchmove", touchMoveHandler, { passive: false });
        touchMoveHandler = null;
      }
    };
    const setExpanded = (expanded) => {
      toggleButtons.forEach((button) => {
        button.setAttribute("aria-expanded", expanded ? "true" : "false");
        button.setAttribute("aria-label", expanded ? button.dataset.closeLabel || "Close menu" : button.dataset.openLabel || button.getAttribute("aria-label") || "Menu");
        const icons = getToggleIcons(button);
        if (icons.open) icons.open.hidden = expanded;
        if (icons.close) icons.close.hidden = !expanded;
      });
      document.querySelector(".pageheader--hygge")?.classList.toggle("pageheader--mobile-menu-open", expanded);
    };
    const collapseAccordions = (container) => {
      container?.querySelectorAll(".toggle-target:not(.toggle-target--hidden)").forEach((panel) => {
        panel.classList.add("toggle-target--hidden");
      });
    };
    const resetSubmenuScroll = (submenu) => {
      submenu?.querySelector(".mobile-menu__submenu-inner")?.scrollTo({ top: 0, left: 0, behavior: "instant" });
    };
    const showRoot = () => {
      if (activeSubmenu) {
        collapseAccordions(activeSubmenu);
        activeSubmenu.classList.remove("is-active");
        activeSubmenu = null;
      }
      rootView?.classList.add("is-active");
      rootView?.classList.remove("is-behind");
      stage?.scrollTo({ top: 0, left: 0, behavior: "instant" });
    };
    const initLocalizationSelects = () => {
      menu.querySelectorAll("custom-select, country-selector").forEach((select) => {
        if (select.options?.length) return;
        if (typeof select.init === "function") select.init();
      });
    };
    const open = () => {
      showRoot();
      menu.classList.add("mobile-menu--open");
      menu.setAttribute("aria-hidden", "false");
      lockPageScroll();
      setExpanded(true);
      initLocalizationSelects();
    };
    const close = () => {
      menu.classList.remove("mobile-menu--open");
      menu.setAttribute("aria-hidden", "true");
      unlockPageScroll();
      setExpanded(false);
      window.setTimeout(() => {
        showRoot();
      }, 340);
    };
    const showSubmenu = (submenu) => {
      if (!submenu || !rootView) return;
      if (activeSubmenu) {
        collapseAccordions(activeSubmenu);
        activeSubmenu.classList.remove("is-active");
      }
      rootView.classList.remove("is-active");
      rootView.classList.add("is-behind");
      submenu.classList.add("is-active");
      activeSubmenu = submenu;
      resetSubmenuScroll(submenu);
    };
    toggleButtons.forEach((button) => {
      if (!button.dataset.openLabel) {
        button.dataset.openLabel = button.getAttribute("aria-label") || "Menu";
      }
      if (!button.dataset.closeLabel) {
        button.dataset.closeLabel = "Close menu";
      }
      button.addEventListener("click", (event2) => {
        event2.preventDefault();
        if (menu.classList.contains("mobile-menu--open")) {
          close();
        } else {
          open();
        }
      });
    });
    menu.querySelectorAll("[data-mobile-menu-close]").forEach((button) => {
      button.addEventListener("click", (event2) => {
        event2.preventDefault();
        close();
      });
    });
    menu.querySelectorAll("[data-mobile-menu-back]").forEach((button) => {
      button.addEventListener("click", (event2) => {
        event2.preventDefault();
        showRoot();
      });
    });
    menu.querySelectorAll("[data-mobile-submenu-open]").forEach((button) => {
      button.addEventListener("click", (event2) => {
        event2.preventDefault();
        const submenu = menu.querySelector(`#${button.dataset.mobileSubmenuOpen}`);
        showSubmenu(submenu);
      });
    });
    document.addEventListener("keydown", (event2) => {
      if (event2.key === "Escape" && menu.classList.contains("mobile-menu--open")) {
        if (activeSubmenu) {
          showRoot();
        } else {
          close();
        }
      }
    });
  }

  // node_modules/swiper/shared/ssr-window.esm.mjs
  function isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
  }
  function extend(target = {}, src = {}) {
    const noExtend = ["__proto__", "constructor", "prototype"];
    Object.keys(src).filter((key) => noExtend.indexOf(key) < 0).forEach((key) => {
      if (typeof target[key] === "undefined") target[key] = src[key];
      else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
        extend(target[key], src[key]);
      }
    });
  }
  var ssrDocument = {
    body: {},
    addEventListener() {
    },
    removeEventListener() {
    },
    activeElement: {
      blur() {
      },
      nodeName: ""
    },
    querySelector() {
      return null;
    },
    querySelectorAll() {
      return [];
    },
    getElementById() {
      return null;
    },
    createEvent() {
      return {
        initEvent() {
        }
      };
    },
    createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute() {
        },
        getElementsByTagName() {
          return [];
        }
      };
    },
    createElementNS() {
      return {};
    },
    importNode() {
      return null;
    },
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: ""
    }
  };
  function getDocument() {
    const doc = typeof document !== "undefined" ? document : {};
    extend(doc, ssrDocument);
    return doc;
  }
  var ssrWindow = {
    document: ssrDocument,
    navigator: {
      userAgent: ""
    },
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: ""
    },
    history: {
      replaceState() {
      },
      pushState() {
      },
      go() {
      },
      back() {
      }
    },
    CustomEvent: function CustomEvent2() {
      return this;
    },
    addEventListener() {
    },
    removeEventListener() {
    },
    getComputedStyle() {
      return {
        getPropertyValue() {
          return "";
        }
      };
    },
    Image() {
    },
    Date() {
    },
    screen: {},
    setTimeout() {
    },
    clearTimeout() {
    },
    matchMedia() {
      return {};
    },
    requestAnimationFrame(callback) {
      if (typeof setTimeout === "undefined") {
        callback();
        return null;
      }
      return setTimeout(callback, 0);
    },
    cancelAnimationFrame(id) {
      if (typeof setTimeout === "undefined") {
        return;
      }
      clearTimeout(id);
    }
  };
  function getWindow() {
    const win = typeof window !== "undefined" ? window : {};
    extend(win, ssrWindow);
    return win;
  }

  // node_modules/swiper/shared/utils.mjs
  function classesToTokens(classes2 = "") {
    return classes2.trim().split(" ").filter((c) => !!c.trim());
  }
  function deleteProps(obj) {
    const object = obj;
    Object.keys(object).forEach((key) => {
      try {
        object[key] = null;
      } catch (e) {
      }
      try {
        delete object[key];
      } catch (e) {
      }
    });
  }
  function nextTick(callback, delay = 0) {
    return setTimeout(callback, delay);
  }
  function now() {
    return Date.now();
  }
  function getComputedStyle2(el) {
    const window2 = getWindow();
    let style;
    if (window2.getComputedStyle) {
      style = window2.getComputedStyle(el, null);
    }
    if (!style && el.currentStyle) {
      style = el.currentStyle;
    }
    if (!style) {
      style = el.style;
    }
    return style;
  }
  function getTranslate(el, axis = "x") {
    const window2 = getWindow();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = getComputedStyle2(el);
    if (window2.WebKitCSSMatrix) {
      curTransform = curStyle.transform || curStyle.webkitTransform;
      if (curTransform.split(",").length > 6) {
        curTransform = curTransform.split(", ").map((a) => a.replace(",", ".")).join(", ");
      }
      transformMatrix = new window2.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
      transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
      matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
      if (window2.WebKitCSSMatrix) curTransform = transformMatrix.m41;
      else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
      else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
      if (window2.WebKitCSSMatrix) curTransform = transformMatrix.m42;
      else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
      else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
  }
  function isObject2(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
  }
  function isNode(node) {
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") {
      return node instanceof HTMLElement;
    }
    return node && (node.nodeType === 1 || node.nodeType === 11);
  }
  function extend2(...args) {
    const to = Object(args[0]);
    for (let i = 1; i < args.length; i += 1) {
      const nextSource = args[i];
      if (nextSource !== void 0 && nextSource !== null && !isNode(nextSource)) {
        const keysArray = Object.keys(Object(nextSource)).filter((key) => key !== "__proto__" && key !== "constructor" && key !== "prototype");
        for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
          const nextKey = keysArray[nextIndex];
          const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
          if (desc !== void 0 && desc.enumerable) {
            if (isObject2(to[nextKey]) && isObject2(nextSource[nextKey])) {
              if (nextSource[nextKey].__swiper__) {
                to[nextKey] = nextSource[nextKey];
              } else {
                extend2(to[nextKey], nextSource[nextKey]);
              }
            } else if (!isObject2(to[nextKey]) && isObject2(nextSource[nextKey])) {
              to[nextKey] = {};
              if (nextSource[nextKey].__swiper__) {
                to[nextKey] = nextSource[nextKey];
              } else {
                extend2(to[nextKey], nextSource[nextKey]);
              }
            } else {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
    }
    return to;
  }
  function setCSSProperty(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
  }
  function animateCSSModeScroll({
    swiper,
    targetPosition,
    side
  }) {
    const window2 = getWindow();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window2.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? "next" : "prev";
    const isOutOfBound = (current, target) => {
      return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    const animate = () => {
      time = (/* @__PURE__ */ new Date()).getTime();
      if (startTime === null) {
        startTime = time;
      }
      const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
      const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
      let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
      if (isOutOfBound(currentPosition, targetPosition)) {
        currentPosition = targetPosition;
      }
      swiper.wrapperEl.scrollTo({
        [side]: currentPosition
      });
      if (isOutOfBound(currentPosition, targetPosition)) {
        swiper.wrapperEl.style.overflow = "hidden";
        swiper.wrapperEl.style.scrollSnapType = "";
        setTimeout(() => {
          swiper.wrapperEl.style.overflow = "";
          swiper.wrapperEl.scrollTo({
            [side]: currentPosition
          });
        });
        window2.cancelAnimationFrame(swiper.cssModeFrameID);
        return;
      }
      swiper.cssModeFrameID = window2.requestAnimationFrame(animate);
    };
    animate();
  }
  function elementChildren(element, selector = "") {
    const window2 = getWindow();
    const children = [...element.children];
    if (window2.HTMLSlotElement && element instanceof HTMLSlotElement) {
      children.push(...element.assignedElements());
    }
    if (!selector) {
      return children;
    }
    return children.filter((el) => el.matches(selector));
  }
  function elementIsChildOfSlot(el, slot) {
    const elementsQueue = [slot];
    while (elementsQueue.length > 0) {
      const elementToCheck = elementsQueue.shift();
      if (el === elementToCheck) {
        return true;
      }
      elementsQueue.push(...elementToCheck.children, ...elementToCheck.shadowRoot ? elementToCheck.shadowRoot.children : [], ...elementToCheck.assignedElements ? elementToCheck.assignedElements() : []);
    }
  }
  function elementIsChildOf(el, parent) {
    const window2 = getWindow();
    let isChild = parent.contains(el);
    if (!isChild && window2.HTMLSlotElement && parent instanceof HTMLSlotElement) {
      const children = [...parent.assignedElements()];
      isChild = children.includes(el);
      if (!isChild) {
        isChild = elementIsChildOfSlot(el, parent);
      }
    }
    return isChild;
  }
  function showWarning(text) {
    try {
      console.warn(text);
      return;
    } catch (err) {
    }
  }
  function createElement(tag, classes2 = []) {
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes2) ? classes2 : classesToTokens(classes2));
    return el;
  }
  function elementPrevAll(el, selector) {
    const prevEls = [];
    while (el.previousElementSibling) {
      const prev = el.previousElementSibling;
      if (selector) {
        if (prev.matches(selector)) prevEls.push(prev);
      } else prevEls.push(prev);
      el = prev;
    }
    return prevEls;
  }
  function elementNextAll(el, selector) {
    const nextEls = [];
    while (el.nextElementSibling) {
      const next = el.nextElementSibling;
      if (selector) {
        if (next.matches(selector)) nextEls.push(next);
      } else nextEls.push(next);
      el = next;
    }
    return nextEls;
  }
  function elementStyle(el, prop) {
    const window2 = getWindow();
    return window2.getComputedStyle(el, null).getPropertyValue(prop);
  }
  function elementIndex(el) {
    let child = el;
    let i;
    if (child) {
      i = 0;
      while ((child = child.previousSibling) !== null) {
        if (child.nodeType === 1) i += 1;
      }
      return i;
    }
    return void 0;
  }
  function elementParents(el, selector) {
    const parents = [];
    let parent = el.parentElement;
    while (parent) {
      if (selector) {
        if (parent.matches(selector)) parents.push(parent);
      } else {
        parents.push(parent);
      }
      parent = parent.parentElement;
    }
    return parents;
  }
  function elementTransitionEnd(el, callback) {
    function fireCallBack(e) {
      if (e.target !== el) return;
      callback.call(el, e);
      el.removeEventListener("transitionend", fireCallBack);
    }
    if (callback) {
      el.addEventListener("transitionend", fireCallBack);
    }
  }
  function elementOuterSize(el, size, includeMargins) {
    const window2 = getWindow();
    if (includeMargins) {
      return el[size === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(window2.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-right" : "margin-top")) + parseFloat(window2.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-left" : "margin-bottom"));
    }
    return el.offsetWidth;
  }
  function makeElementsArray(el) {
    return (Array.isArray(el) ? el : [el]).filter((e) => !!e);
  }
  function setInnerHTML(el, html = "") {
    if (typeof trustedTypes !== "undefined") {
      el.innerHTML = trustedTypes.createPolicy("html", {
        createHTML: (s) => s
      }).createHTML(html);
    } else {
      el.innerHTML = html;
    }
  }

  // node_modules/swiper/shared/swiper-core.mjs
  var support;
  function calcSupport() {
    const window2 = getWindow();
    const document2 = getDocument();
    return {
      smoothScroll: document2.documentElement && document2.documentElement.style && "scrollBehavior" in document2.documentElement.style,
      touch: !!("ontouchstart" in window2 || window2.DocumentTouch && document2 instanceof window2.DocumentTouch)
    };
  }
  function getSupport() {
    if (!support) {
      support = calcSupport();
    }
    return support;
  }
  var deviceCached;
  function calcDevice({
    userAgent
  } = {}) {
    const support2 = getSupport();
    const window2 = getWindow();
    const platform = window2.navigator.platform;
    const ua = userAgent || window2.navigator.userAgent;
    const device = {
      ios: false,
      android: false
    };
    const screenWidth = window2.screen.width;
    const screenHeight = window2.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
    let ipad = ua.match(/(iPad)(?!\1).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === "Win32";
    let macos = platform === "MacIntel";
    const iPadScreens = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
    if (!ipad && macos && support2.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
      ipad = ua.match(/(Version)\/([\d.]+)/);
      if (!ipad) ipad = [0, 1, "13_0_0"];
      macos = false;
    }
    if (android && !windows) {
      device.os = "android";
      device.android = true;
    }
    if (ipad || iphone || ipod) {
      device.os = "ios";
      device.ios = true;
    }
    return device;
  }
  function getDevice(overrides = {}) {
    if (!deviceCached) {
      deviceCached = calcDevice(overrides);
    }
    return deviceCached;
  }
  var browser;
  function calcBrowser() {
    const window2 = getWindow();
    const device = getDevice();
    let needPerspectiveFix = false;
    function isSafari() {
      const ua = window2.navigator.userAgent.toLowerCase();
      return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    if (isSafari()) {
      const ua = String(window2.navigator.userAgent);
      if (ua.includes("Version/")) {
        const [major, minor] = ua.split("Version/")[1].split(" ")[0].split(".").map((num) => Number(num));
        needPerspectiveFix = major < 16 || major === 16 && minor < 2;
      }
    }
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window2.navigator.userAgent);
    const isSafariBrowser = isSafari();
    const need3dFix = isSafariBrowser || isWebView && device.ios;
    return {
      isSafari: needPerspectiveFix || isSafariBrowser,
      needPerspectiveFix,
      need3dFix,
      isWebView
    };
  }
  function getBrowser() {
    if (!browser) {
      browser = calcBrowser();
    }
    return browser;
  }
  function Resize({
    swiper,
    on,
    emit
  }) {
    const window2 = getWindow();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = () => {
      if (!swiper || swiper.destroyed || !swiper.initialized) return;
      emit("beforeResize");
      emit("resize");
    };
    const createObserver = () => {
      if (!swiper || swiper.destroyed || !swiper.initialized) return;
      observer = new ResizeObserver((entries) => {
        animationFrame = window2.requestAnimationFrame(() => {
          const {
            width,
            height
          } = swiper;
          let newWidth = width;
          let newHeight = height;
          entries.forEach(({
            contentBoxSize,
            contentRect,
            target
          }) => {
            if (target && target !== swiper.el) return;
            newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
            newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
          });
          if (newWidth !== width || newHeight !== height) {
            resizeHandler();
          }
        });
      });
      observer.observe(swiper.el);
    };
    const removeObserver = () => {
      if (animationFrame) {
        window2.cancelAnimationFrame(animationFrame);
      }
      if (observer && observer.unobserve && swiper.el) {
        observer.unobserve(swiper.el);
        observer = null;
      }
    };
    const orientationChangeHandler = () => {
      if (!swiper || swiper.destroyed || !swiper.initialized) return;
      emit("orientationchange");
    };
    on("init", () => {
      if (swiper.params.resizeObserver && typeof window2.ResizeObserver !== "undefined") {
        createObserver();
        return;
      }
      window2.addEventListener("resize", resizeHandler);
      window2.addEventListener("orientationchange", orientationChangeHandler);
    });
    on("destroy", () => {
      removeObserver();
      window2.removeEventListener("resize", resizeHandler);
      window2.removeEventListener("orientationchange", orientationChangeHandler);
    });
  }
  function Observer({
    swiper,
    extendParams,
    on,
    emit
  }) {
    const observers = [];
    const window2 = getWindow();
    const attach = (target, options = {}) => {
      const ObserverFunc = window2.MutationObserver || window2.WebkitMutationObserver;
      const observer = new ObserverFunc((mutations) => {
        if (swiper.__preventObserver__) return;
        if (mutations.length === 1) {
          emit("observerUpdate", mutations[0]);
          return;
        }
        const observerUpdate = function observerUpdate2() {
          emit("observerUpdate", mutations[0]);
        };
        if (window2.requestAnimationFrame) {
          window2.requestAnimationFrame(observerUpdate);
        } else {
          window2.setTimeout(observerUpdate, 0);
        }
      });
      observer.observe(target, {
        attributes: typeof options.attributes === "undefined" ? true : options.attributes,
        childList: swiper.isElement || (typeof options.childList === "undefined" ? true : options).childList,
        characterData: typeof options.characterData === "undefined" ? true : options.characterData
      });
      observers.push(observer);
    };
    const init = () => {
      if (!swiper.params.observer) return;
      if (swiper.params.observeParents) {
        const containerParents = elementParents(swiper.hostEl);
        for (let i = 0; i < containerParents.length; i += 1) {
          attach(containerParents[i]);
        }
      }
      attach(swiper.hostEl, {
        childList: swiper.params.observeSlideChildren
      });
      attach(swiper.wrapperEl, {
        attributes: false
      });
    };
    const destroy = () => {
      observers.forEach((observer) => {
        observer.disconnect();
      });
      observers.splice(0, observers.length);
    };
    extendParams({
      observer: false,
      observeParents: false,
      observeSlideChildren: false
    });
    on("init", init);
    on("destroy", destroy);
  }
  var eventsEmitter = {
    on(events2, handler, priority) {
      const self2 = this;
      if (!self2.eventsListeners || self2.destroyed) return self2;
      if (typeof handler !== "function") return self2;
      const method = priority ? "unshift" : "push";
      events2.split(" ").forEach((event2) => {
        if (!self2.eventsListeners[event2]) self2.eventsListeners[event2] = [];
        self2.eventsListeners[event2][method](handler);
      });
      return self2;
    },
    once(events2, handler, priority) {
      const self2 = this;
      if (!self2.eventsListeners || self2.destroyed) return self2;
      if (typeof handler !== "function") return self2;
      function onceHandler(...args) {
        self2.off(events2, onceHandler);
        if (onceHandler.__emitterProxy) {
          delete onceHandler.__emitterProxy;
        }
        handler.apply(self2, args);
      }
      onceHandler.__emitterProxy = handler;
      return self2.on(events2, onceHandler, priority);
    },
    onAny(handler, priority) {
      const self2 = this;
      if (!self2.eventsListeners || self2.destroyed) return self2;
      if (typeof handler !== "function") return self2;
      const method = priority ? "unshift" : "push";
      if (self2.eventsAnyListeners.indexOf(handler) < 0) {
        self2.eventsAnyListeners[method](handler);
      }
      return self2;
    },
    offAny(handler) {
      const self2 = this;
      if (!self2.eventsListeners || self2.destroyed) return self2;
      if (!self2.eventsAnyListeners) return self2;
      const index = self2.eventsAnyListeners.indexOf(handler);
      if (index >= 0) {
        self2.eventsAnyListeners.splice(index, 1);
      }
      return self2;
    },
    off(events2, handler) {
      const self2 = this;
      if (!self2.eventsListeners || self2.destroyed) return self2;
      if (!self2.eventsListeners) return self2;
      events2.split(" ").forEach((event2) => {
        if (typeof handler === "undefined") {
          self2.eventsListeners[event2] = [];
        } else if (self2.eventsListeners[event2]) {
          self2.eventsListeners[event2].forEach((eventHandler, index) => {
            if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
              self2.eventsListeners[event2].splice(index, 1);
            }
          });
        }
      });
      return self2;
    },
    emit(...args) {
      const self2 = this;
      if (!self2.eventsListeners || self2.destroyed) return self2;
      if (!self2.eventsListeners) return self2;
      let events2;
      let data;
      let context;
      if (typeof args[0] === "string" || Array.isArray(args[0])) {
        events2 = args[0];
        data = args.slice(1, args.length);
        context = self2;
      } else {
        events2 = args[0].events;
        data = args[0].data;
        context = args[0].context || self2;
      }
      data.unshift(context);
      const eventsArray = Array.isArray(events2) ? events2 : events2.split(" ");
      eventsArray.forEach((event2) => {
        if (self2.eventsAnyListeners && self2.eventsAnyListeners.length) {
          self2.eventsAnyListeners.forEach((eventHandler) => {
            eventHandler.apply(context, [event2, ...data]);
          });
        }
        if (self2.eventsListeners && self2.eventsListeners[event2]) {
          self2.eventsListeners[event2].forEach((eventHandler) => {
            eventHandler.apply(context, data);
          });
        }
      });
      return self2;
    }
  };
  function updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) {
      width = swiper.params.width;
    } else {
      width = el.clientWidth;
    }
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) {
      height = swiper.params.height;
    } else {
      height = el.clientHeight;
    }
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
      return;
    }
    width = width - parseInt(elementStyle(el, "padding-left") || 0, 10) - parseInt(elementStyle(el, "padding-right") || 0, 10);
    height = height - parseInt(elementStyle(el, "padding-top") || 0, 10) - parseInt(elementStyle(el, "padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
      width,
      height,
      size: swiper.isHorizontal() ? width : height
    });
  }
  function updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
      return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const {
      wrapperEl,
      slidesEl,
      rtlTranslate: rtl,
      wrongRTL
    } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = elementChildren(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") {
      offsetBefore = params.slidesOffsetBefore.call(swiper);
    }
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") {
      offsetAfter = params.slidesOffsetAfter.call(swiper);
    }
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    const swiperSize = swiper.size - offsetBefore - offsetAfter;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === "undefined") {
      return;
    }
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) {
      spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    } else if (typeof spaceBetween === "string") {
      spaceBetween = parseFloat(spaceBetween);
    }
    swiper.virtualSize = -spaceBetween - offsetBefore - offsetAfter;
    slides.forEach((slideEl) => {
      if (rtl) {
        slideEl.style.marginLeft = "";
      } else {
        slideEl.style.marginRight = "";
      }
      slideEl.style.marginBottom = "";
      slideEl.style.marginTop = "";
    });
    if (params.centeredSlides && params.cssMode) {
      setCSSProperty(wrapperEl, "--swiper-centered-offset-before", "");
      setCSSProperty(wrapperEl, "--swiper-centered-offset-after", "");
    }
    if (params.cssMode) {
      setCSSProperty(wrapperEl, "--swiper-slides-offset-before", `${offsetBefore}px`);
      setCSSProperty(wrapperEl, "--swiper-slides-offset-after", `${offsetAfter}px`);
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) {
      swiper.grid.initSlides(slides);
    } else if (swiper.grid) {
      swiper.grid.unsetSlides();
    }
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key) => {
      return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for (let i = 0; i < slidesLength; i += 1) {
      slideSize = 0;
      const slide2 = slides[i];
      if (slide2) {
        if (gridEnabled) {
          swiper.grid.updateSlide(i, slide2, slides);
        }
        if (elementStyle(slide2, "display") === "none") continue;
      }
      if (isVirtual && params.slidesPerView === "auto") {
        if (params.virtual.slidesPerViewAutoSlideSize) {
          slideSize = params.virtual.slidesPerViewAutoSlideSize;
        }
        if (slideSize && slide2) {
          if (params.roundLengths) slideSize = Math.floor(slideSize);
          slide2.style[swiper.getDirectionLabel("width")] = `${slideSize}px`;
        }
      } else if (params.slidesPerView === "auto") {
        if (shouldResetSlideSize) {
          slide2.style[swiper.getDirectionLabel("width")] = ``;
        }
        const slideStyles = getComputedStyle(slide2);
        const currentTransform = slide2.style.transform;
        const currentWebKitTransform = slide2.style.webkitTransform;
        if (currentTransform) {
          slide2.style.transform = "none";
        }
        if (currentWebKitTransform) {
          slide2.style.webkitTransform = "none";
        }
        if (params.roundLengths) {
          slideSize = swiper.isHorizontal() ? elementOuterSize(slide2, "width", true) : elementOuterSize(slide2, "height", true);
        } else {
          const width = getDirectionPropertyValue(slideStyles, "width");
          const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
          const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
          const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
          const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
          const boxSizing = slideStyles.getPropertyValue("box-sizing");
          if (boxSizing && boxSizing === "border-box") {
            slideSize = width + marginLeft + marginRight;
          } else {
            const {
              clientWidth,
              offsetWidth
            } = slide2;
            slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
          }
        }
        if (currentTransform) {
          slide2.style.transform = currentTransform;
        }
        if (currentWebKitTransform) {
          slide2.style.webkitTransform = currentWebKitTransform;
        }
        if (params.roundLengths) slideSize = Math.floor(slideSize);
      } else {
        slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
        if (params.roundLengths) slideSize = Math.floor(slideSize);
        if (slide2) {
          slide2.style[swiper.getDirectionLabel("width")] = `${slideSize}px`;
        }
      }
      if (slide2) {
        slide2.swiperSlideSize = slideSize;
      }
      slidesSizesGrid.push(slideSize);
      if (params.centeredSlides) {
        slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
        if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
        if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
        if (Math.abs(slidePosition) < 1 / 1e3) slidePosition = 0;
        if (params.roundLengths) slidePosition = Math.floor(slidePosition);
        if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
        slidesGrid.push(slidePosition);
      } else {
        if (params.roundLengths) slidePosition = Math.floor(slidePosition);
        if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
        slidesGrid.push(slidePosition);
        slidePosition = slidePosition + slideSize + spaceBetween;
      }
      swiper.virtualSize += slideSize + spaceBetween;
      prevSlideSize = slideSize;
      index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) {
      wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    }
    if (params.setWrapperSize) {
      wrapperEl.style[swiper.getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
    }
    if (gridEnabled) {
      swiper.grid.updateWrapperSize(slideSize, snapGrid);
    }
    if (!params.centeredSlides) {
      const isFractionalSlidesPerView = params.slidesPerView !== "auto" && params.slidesPerView % 1 !== 0;
      const shouldSnapToSlideEdge = params.snapToSlideEdge && !params.loop && (params.slidesPerView === "auto" || isFractionalSlidesPerView);
      let lastAllowedSnapIndex = snapGrid.length;
      if (shouldSnapToSlideEdge) {
        let minVisibleSlides;
        if (params.slidesPerView === "auto") {
          minVisibleSlides = 1;
          let accumulatedSize = 0;
          for (let i = slidesSizesGrid.length - 1; i >= 0; i -= 1) {
            accumulatedSize += slidesSizesGrid[i] + (i < slidesSizesGrid.length - 1 ? spaceBetween : 0);
            if (accumulatedSize <= swiperSize) {
              minVisibleSlides = slidesSizesGrid.length - i;
            } else {
              break;
            }
          }
        } else {
          minVisibleSlides = Math.floor(params.slidesPerView);
        }
        lastAllowedSnapIndex = Math.max(slidesLength - minVisibleSlides, 0);
      }
      const newSlidesGrid = [];
      for (let i = 0; i < snapGrid.length; i += 1) {
        let slidesGridItem = snapGrid[i];
        if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
        if (shouldSnapToSlideEdge) {
          if (i <= lastAllowedSnapIndex) {
            newSlidesGrid.push(slidesGridItem);
          }
        } else if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
          newSlidesGrid.push(slidesGridItem);
        }
      }
      snapGrid = newSlidesGrid;
      if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
        if (!shouldSnapToSlideEdge) {
          snapGrid.push(swiper.virtualSize - swiperSize);
        }
      }
    }
    if (isVirtual && params.loop) {
      const size = slidesSizesGrid[0] + spaceBetween;
      if (params.slidesPerGroup > 1) {
        const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
        const groupSize = size * params.slidesPerGroup;
        for (let i = 0; i < groups; i += 1) {
          snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
      }
      for (let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1) {
        if (params.slidesPerGroup === 1) {
          snapGrid.push(snapGrid[snapGrid.length - 1] + size);
        }
        slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
        swiper.virtualSize += size;
      }
    }
    if (snapGrid.length === 0) snapGrid = [0];
    if (spaceBetween !== 0) {
      const key = swiper.isHorizontal() && rtl ? "marginLeft" : swiper.getDirectionLabel("marginRight");
      slides.filter((_, slideIndex) => {
        if (!params.cssMode || params.loop) return true;
        if (slideIndex === slides.length - 1) {
          return false;
        }
        return true;
      }).forEach((slideEl) => {
        slideEl.style[key] = `${spaceBetween}px`;
      });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
      let allSlidesSize = 0;
      slidesSizesGrid.forEach((slideSizeValue) => {
        allSlidesSize += slideSizeValue + (spaceBetween || 0);
      });
      allSlidesSize -= spaceBetween;
      const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
      snapGrid = snapGrid.map((snap) => {
        if (snap <= 0) return -offsetBefore;
        if (snap > maxSnap) return maxSnap + offsetAfter;
        return snap;
      });
    }
    if (params.centerInsufficientSlides) {
      let allSlidesSize = 0;
      slidesSizesGrid.forEach((slideSizeValue) => {
        allSlidesSize += slideSizeValue + (spaceBetween || 0);
      });
      allSlidesSize -= spaceBetween;
      if (allSlidesSize < swiperSize) {
        const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
        snapGrid.forEach((snap, snapIndex) => {
          snapGrid[snapIndex] = snap - allSlidesOffset;
        });
        slidesGrid.forEach((snap, snapIndex) => {
          slidesGrid[snapIndex] = snap + allSlidesOffset;
        });
      }
    }
    Object.assign(swiper, {
      slides,
      snapGrid,
      slidesGrid,
      slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
      setCSSProperty(wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
      setCSSProperty(wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
      const addToSnapGrid = -swiper.snapGrid[0];
      const addToSlidesGrid = -swiper.slidesGrid[0];
      swiper.snapGrid = swiper.snapGrid.map((v) => v + addToSnapGrid);
      swiper.slidesGrid = swiper.slidesGrid.map((v) => v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) {
      swiper.emit("slidesLengthChange");
    }
    if (snapGrid.length !== previousSnapGridLength) {
      if (swiper.params.watchOverflow) swiper.checkOverflow();
      swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) {
      swiper.emit("slidesGridLengthChange");
    }
    if (params.watchSlidesProgress) {
      swiper.updateSlidesOffset();
    }
    swiper.emit("slidesUpdated");
    if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
      const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
      const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
      if (slidesLength <= params.maxBackfaceHiddenSlides) {
        if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
      } else if (hasClassBackfaceClassAdded) {
        swiper.el.classList.remove(backFaceHiddenClass);
      }
    }
  }
  function updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === "number") {
      swiper.setTransition(speed);
    } else if (speed === true) {
      swiper.setTransition(swiper.params.speed);
    }
    const getSlideByIndex = (index) => {
      if (isVirtual) {
        return swiper.slides[swiper.getSlideIndexByData(index)];
      }
      return swiper.slides[index];
    };
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
      if (swiper.params.centeredSlides) {
        (swiper.visibleSlides || []).forEach((slide2) => {
          activeSlides.push(slide2);
        });
      } else {
        for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
          const index = swiper.activeIndex + i;
          if (index > swiper.slides.length && !isVirtual) break;
          activeSlides.push(getSlideByIndex(index));
        }
      }
    } else {
      activeSlides.push(getSlideByIndex(swiper.activeIndex));
    }
    for (i = 0; i < activeSlides.length; i += 1) {
      if (typeof activeSlides[i] !== "undefined") {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
      }
    }
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
  }
  function updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for (let i = 0; i < slides.length; i += 1) {
      slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
    }
  }
  var toggleSlideClasses$1 = (slideEl, condition, className) => {
    if (condition && !slideEl.classList.contains(className)) {
      slideEl.classList.add(className);
    } else if (!condition && slideEl.classList.contains(className)) {
      slideEl.classList.remove(className);
    }
  };
  function updateSlidesProgress(translate2 = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const {
      slides,
      rtlTranslate: rtl,
      snapGrid
    } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    let offsetCenter = -translate2;
    if (rtl) offsetCenter = translate2;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) {
      spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
    } else if (typeof spaceBetween === "string") {
      spaceBetween = parseFloat(spaceBetween);
    }
    for (let i = 0; i < slides.length; i += 1) {
      const slide2 = slides[i];
      let slideOffset = slide2.swiperSlideOffset;
      if (params.cssMode && params.centeredSlides) {
        slideOffset -= slides[0].swiperSlideOffset;
      }
      const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide2.swiperSlideSize + spaceBetween);
      const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide2.swiperSlideSize + spaceBetween);
      const slideBefore = -(offsetCenter - slideOffset);
      const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
      const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
      const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
      if (isVisible) {
        swiper.visibleSlides.push(slide2);
        swiper.visibleSlidesIndexes.push(i);
      }
      toggleSlideClasses$1(slide2, isVisible, params.slideVisibleClass);
      toggleSlideClasses$1(slide2, isFullyVisible, params.slideFullyVisibleClass);
      slide2.progress = rtl ? -slideProgress : slideProgress;
      slide2.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
  }
  function updateProgress(translate2) {
    const swiper = this;
    if (typeof translate2 === "undefined") {
      const multiplier = swiper.rtlTranslate ? -1 : 1;
      translate2 = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let {
      progress,
      isBeginning,
      isEnd,
      progressLoop
    } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
      progress = 0;
      isBeginning = true;
      isEnd = true;
    } else {
      progress = (translate2 - swiper.minTranslate()) / translatesDiff;
      const isBeginningRounded = Math.abs(translate2 - swiper.minTranslate()) < 1;
      const isEndRounded = Math.abs(translate2 - swiper.maxTranslate()) < 1;
      isBeginning = isBeginningRounded || progress <= 0;
      isEnd = isEndRounded || progress >= 1;
      if (isBeginningRounded) progress = 0;
      if (isEndRounded) progress = 1;
    }
    if (params.loop) {
      const firstSlideIndex = swiper.getSlideIndexByData(0);
      const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
      const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
      const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
      const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
      const translateAbs = Math.abs(translate2);
      if (translateAbs >= firstSlideTranslate) {
        progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
      } else {
        progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
      }
      if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
      progress,
      progressLoop,
      isBeginning,
      isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate2);
    if (isBeginning && !wasBeginning) {
      swiper.emit("reachBeginning toEdge");
    }
    if (isEnd && !wasEnd) {
      swiper.emit("reachEnd toEdge");
    }
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
      swiper.emit("fromEdge");
    }
    swiper.emit("progress", progress);
  }
  var toggleSlideClasses = (slideEl, condition, className) => {
    if (condition && !slideEl.classList.contains(className)) {
      slideEl.classList.add(className);
    } else if (!condition && slideEl.classList.contains(className)) {
      slideEl.classList.remove(className);
    }
  };
  function updateSlidesClasses() {
    const swiper = this;
    const {
      slides,
      params,
      slidesEl,
      activeIndex
    } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector) => {
      return elementChildren(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
      if (params.loop) {
        let slideIndex = activeIndex - swiper.virtual.slidesBefore;
        if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
        if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
        activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
      } else {
        activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
      }
    } else {
      if (gridEnabled) {
        activeSlide = slides.find((slideEl) => slideEl.column === activeIndex);
        nextSlide = slides.find((slideEl) => slideEl.column === activeIndex + 1);
        prevSlide = slides.find((slideEl) => slideEl.column === activeIndex - 1);
      } else {
        activeSlide = slides[activeIndex];
      }
    }
    if (activeSlide) {
      if (!gridEnabled) {
        nextSlide = elementNextAll(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
        if (params.loop && !nextSlide) {
          nextSlide = slides[0];
        }
        prevSlide = elementPrevAll(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
        if (params.loop && !prevSlide === 0) {
          prevSlide = slides[slides.length - 1];
        }
      }
    }
    slides.forEach((slideEl) => {
      toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
      toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
      toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
  }
  var processLazyPreloader = (swiper, imageEl) => {
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = () => swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
      let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
      if (!lazyEl && swiper.isElement) {
        if (slideEl.shadowRoot) {
          lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        } else {
          requestAnimationFrame(() => {
            if (slideEl.shadowRoot) {
              lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
              if (lazyEl && !lazyEl.lazyPreloaderManaged) lazyEl.remove();
            }
          });
        }
      }
      if (lazyEl && !lazyEl.lazyPreloaderManaged) lazyEl.remove();
    }
  };
  var unlazy = (swiper, index) => {
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute("loading");
  };
  var preload = (swiper) => {
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
      const activeColumn = activeIndex;
      const preloadColumns = [activeColumn - amount];
      preloadColumns.push(...Array.from({
        length: amount
      }).map((_, i) => {
        return activeColumn + slidesPerView + i;
      }));
      swiper.slides.forEach((slideEl, i) => {
        if (preloadColumns.includes(slideEl.column)) unlazy(swiper, i);
      });
      return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) {
      for (let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1) {
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) unlazy(swiper, realIndex);
      }
    } else {
      for (let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1) {
        if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) {
          unlazy(swiper, i);
        }
      }
    }
  };
  function getActiveIndexByTranslate(swiper) {
    const {
      slidesGrid,
      params
    } = swiper;
    const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for (let i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== "undefined") {
        if (translate2 >= slidesGrid[i] && translate2 < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
          activeIndex = i;
        } else if (translate2 >= slidesGrid[i] && translate2 < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate2 >= slidesGrid[i]) {
        activeIndex = i;
      }
    }
    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
    }
    return activeIndex;
  }
  function updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const {
      snapGrid,
      params,
      activeIndex: previousIndex,
      realIndex: previousRealIndex,
      snapIndex: previousSnapIndex
    } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex) => {
      let realIndex2 = aIndex - swiper.virtual.slidesBefore;
      if (realIndex2 < 0) {
        realIndex2 = swiper.virtual.slides.length + realIndex2;
      }
      if (realIndex2 >= swiper.virtual.slides.length) {
        realIndex2 -= swiper.virtual.slides.length;
      }
      return realIndex2;
    };
    if (typeof activeIndex === "undefined") {
      activeIndex = getActiveIndexByTranslate(swiper);
    }
    if (snapGrid.indexOf(translate2) >= 0) {
      snapIndex = snapGrid.indexOf(translate2);
    } else {
      const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
      snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
      if (snapIndex !== previousSnapIndex) {
        swiper.snapIndex = snapIndex;
        swiper.emit("snapIndexChange");
      }
      return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
      swiper.realIndex = getVirtualRealIndex(activeIndex);
      return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    let realIndex;
    if (swiper.virtual && params.virtual.enabled) {
      if (params.loop) {
        realIndex = getVirtualRealIndex(activeIndex);
      } else {
        realIndex = activeIndex;
      }
    } else if (gridEnabled) {
      const firstSlideInColumn = swiper.slides.find((slideEl) => slideEl.column === activeIndex);
      let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute("data-swiper-slide-index"), 10);
      if (Number.isNaN(activeSlideIndex)) {
        activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
      }
      realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
      const slideIndex = swiper.slides[activeIndex].getAttribute("data-swiper-slide-index");
      if (slideIndex) {
        realIndex = parseInt(slideIndex, 10);
      } else {
        realIndex = activeIndex;
      }
    } else {
      realIndex = activeIndex;
    }
    Object.assign(swiper, {
      previousSnapIndex,
      snapIndex,
      previousRealIndex,
      realIndex,
      previousIndex,
      activeIndex
    });
    if (swiper.initialized) {
      preload(swiper);
    }
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
      if (previousRealIndex !== realIndex) {
        swiper.emit("realIndexChange");
      }
      swiper.emit("slideChange");
    }
  }
  function updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide2 = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide2 && swiper.isElement && path && path.length > 1 && path.includes(el)) {
      [...path.slice(path.indexOf(el) + 1, path.length)].forEach((pathEl) => {
        if (!slide2 && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) {
          slide2 = pathEl;
        }
      });
    }
    let slideFound = false;
    let slideIndex;
    if (slide2) {
      for (let i = 0; i < swiper.slides.length; i += 1) {
        if (swiper.slides[i] === slide2) {
          slideFound = true;
          slideIndex = i;
          break;
        }
      }
    }
    if (slide2 && slideFound) {
      swiper.clickedSlide = slide2;
      if (swiper.virtual && swiper.params.virtual.enabled) {
        swiper.clickedIndex = parseInt(slide2.getAttribute("data-swiper-slide-index"), 10);
      } else {
        swiper.clickedIndex = slideIndex;
      }
    } else {
      swiper.clickedSlide = void 0;
      swiper.clickedIndex = void 0;
      return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== void 0 && swiper.clickedIndex !== swiper.activeIndex) {
      swiper.slideToClickedSlide();
    }
  }
  var update = {
    updateSize,
    updateSlides,
    updateAutoHeight,
    updateSlidesOffset,
    updateSlidesProgress,
    updateProgress,
    updateSlidesClasses,
    updateActiveIndex,
    updateClickedSlide
  };
  function getSwiperTranslate(axis = this.isHorizontal() ? "x" : "y") {
    const swiper = this;
    const {
      params,
      rtlTranslate: rtl,
      translate: translate2,
      wrapperEl
    } = swiper;
    if (params.virtualTranslate) {
      return rtl ? -translate2 : translate2;
    }
    if (params.cssMode) {
      return translate2;
    }
    let currentTranslate = getTranslate(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
  }
  function setTranslate(translate2, byController) {
    const swiper = this;
    const {
      rtlTranslate: rtl,
      params,
      wrapperEl,
      progress
    } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) {
      x = rtl ? -translate2 : translate2;
    } else {
      y = translate2;
    }
    if (params.roundLengths) {
      x = Math.floor(x);
      y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) {
      wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    } else if (!params.virtualTranslate) {
      if (swiper.isHorizontal()) {
        x -= swiper.cssOverflowAdjustment();
      } else {
        y -= swiper.cssOverflowAdjustment();
      }
      wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) {
      newProgress = 0;
    } else {
      newProgress = (translate2 - swiper.minTranslate()) / translatesDiff;
    }
    if (newProgress !== progress) {
      swiper.updateProgress(translate2);
    }
    swiper.emit("setTranslate", swiper.translate, byController);
  }
  function minTranslate() {
    return -this.snapGrid[0];
  }
  function maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
  }
  function translateTo(translate2 = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const {
      params,
      wrapperEl
    } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return false;
    }
    const minTranslate2 = swiper.minTranslate();
    const maxTranslate2 = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate2 > minTranslate2) newTranslate = minTranslate2;
    else if (translateBounds && translate2 < maxTranslate2) newTranslate = maxTranslate2;
    else newTranslate = translate2;
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
      const isH = swiper.isHorizontal();
      if (speed === 0) {
        wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
      } else {
        if (!swiper.support.smoothScroll) {
          animateCSSModeScroll({
            swiper,
            targetPosition: -newTranslate,
            side: isH ? "left" : "top"
          });
          return true;
        }
        wrapperEl.scrollTo({
          [isH ? "left" : "top"]: -newTranslate,
          behavior: "smooth"
        });
      }
      return true;
    }
    if (speed === 0) {
      swiper.setTransition(0);
      swiper.setTranslate(newTranslate);
      if (runCallbacks) {
        swiper.emit("beforeTransitionStart", speed, internal);
        swiper.emit("transitionEnd");
      }
    } else {
      swiper.setTransition(speed);
      swiper.setTranslate(newTranslate);
      if (runCallbacks) {
        swiper.emit("beforeTransitionStart", speed, internal);
        swiper.emit("transitionStart");
      }
      if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onTranslateToWrapperTransitionEnd) {
          swiper.onTranslateToWrapperTransitionEnd = function transitionEnd2(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
            swiper.onTranslateToWrapperTransitionEnd = null;
            delete swiper.onTranslateToWrapperTransitionEnd;
            swiper.animating = false;
            if (runCallbacks) {
              swiper.emit("transitionEnd");
            }
          };
        }
        swiper.wrapperEl.addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
      }
    }
    return true;
  }
  var translate = {
    getTranslate: getSwiperTranslate,
    setTranslate,
    minTranslate,
    maxTranslate,
    translateTo
  };
  function setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
      swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
      swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : "";
    }
    swiper.emit("setTransition", duration, byController);
  }
  function transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step
  }) {
    const {
      activeIndex,
      previousIndex
    } = swiper;
    let dir = direction;
    if (!dir) {
      if (activeIndex > previousIndex) dir = "next";
      else if (activeIndex < previousIndex) dir = "prev";
      else dir = "reset";
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && dir === "reset") {
      swiper.emit(`slideResetTransition${step}`);
    } else if (runCallbacks && activeIndex !== previousIndex) {
      swiper.emit(`slideChangeTransition${step}`);
      if (dir === "next") {
        swiper.emit(`slideNextTransition${step}`);
      } else {
        swiper.emit(`slidePrevTransition${step}`);
      }
    }
  }
  function transitionStart(runCallbacks = true, direction) {
    const swiper = this;
    const {
      params
    } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
    transitionEmit({
      swiper,
      runCallbacks,
      direction,
      step: "Start"
    });
  }
  function transitionEnd(runCallbacks = true, direction) {
    const swiper = this;
    const {
      params
    } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    transitionEmit({
      swiper,
      runCallbacks,
      direction,
      step: "End"
    });
  }
  var transition = {
    setTransition,
    transitionStart,
    transitionEnd
  };
  function slideTo(index = 0, speed, runCallbacks = true, internal, initial) {
    if (typeof index === "string") {
      index = parseInt(index, 10);
    }
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const {
      params,
      snapGrid,
      slidesGrid,
      previousIndex,
      activeIndex,
      rtlTranslate: rtl,
      wrapperEl,
      enabled
    } = swiper;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) {
      return false;
    }
    if (typeof speed === "undefined") {
      speed = swiper.params.speed;
    }
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate2 = -snapGrid[snapIndex];
    if (params.normalizeSlideIndex) {
      for (let i = 0; i < slidesGrid.length; i += 1) {
        const normalizedTranslate = -Math.floor(translate2 * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
          if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
            slideIndex = i;
          } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
            slideIndex = i + 1;
          }
        } else if (normalizedTranslate >= normalizedGrid) {
          slideIndex = i;
        }
      }
    }
    if (swiper.initialized && slideIndex !== activeIndex) {
      if (!swiper.allowSlideNext && (rtl ? translate2 > swiper.translate && translate2 > swiper.minTranslate() : translate2 < swiper.translate && translate2 < swiper.minTranslate())) {
        return false;
      }
      if (!swiper.allowSlidePrev && translate2 > swiper.translate && translate2 > swiper.maxTranslate()) {
        if ((activeIndex || 0) !== slideIndex) {
          return false;
        }
      }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) {
      swiper.emit("beforeSlideChangeStart");
    }
    swiper.updateProgress(translate2);
    let direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset";
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    const isInitialVirtual = isVirtual && initial;
    if (!isInitialVirtual && (rtl && -translate2 === swiper.translate || !rtl && translate2 === swiper.translate)) {
      swiper.updateActiveIndex(slideIndex);
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
      swiper.updateSlidesClasses();
      if (params.effect !== "slide") {
        swiper.setTranslate(translate2);
      }
      if (direction !== "reset") {
        swiper.transitionStart(runCallbacks, direction);
        swiper.transitionEnd(runCallbacks, direction);
      }
      return false;
    }
    if (params.cssMode) {
      const isH = swiper.isHorizontal();
      const t = rtl ? translate2 : -translate2;
      if (speed === 0) {
        if (isVirtual) {
          swiper.wrapperEl.style.scrollSnapType = "none";
          swiper._immediateVirtual = true;
        }
        if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
          swiper._cssModeVirtualInitialSet = true;
          requestAnimationFrame(() => {
            wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
          });
        } else {
          wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
        }
        if (isVirtual) {
          requestAnimationFrame(() => {
            swiper.wrapperEl.style.scrollSnapType = "";
            swiper._immediateVirtual = false;
          });
        }
      } else {
        if (!swiper.support.smoothScroll) {
          animateCSSModeScroll({
            swiper,
            targetPosition: t,
            side: isH ? "left" : "top"
          });
          return true;
        }
        wrapperEl.scrollTo({
          [isH ? "left" : "top"]: t,
          behavior: "smooth"
        });
      }
      return true;
    }
    const browser2 = getBrowser();
    const isSafari = browser2.isSafari;
    if (isVirtual && !initial && isSafari && swiper.isElement) {
      swiper.virtual.update(false, false, slideIndex);
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate2);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) {
      swiper.transitionEnd(runCallbacks, direction);
    } else if (!swiper.animating) {
      swiper.animating = true;
      if (!swiper.onSlideToWrapperTransitionEnd) {
        swiper.onSlideToWrapperTransitionEnd = function transitionEnd2(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.wrapperEl.removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
          swiper.onSlideToWrapperTransitionEnd = null;
          delete swiper.onSlideToWrapperTransitionEnd;
          swiper.transitionEnd(runCallbacks, direction);
        };
      }
      swiper.wrapperEl.addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
  }
  function slideToLoop(index = 0, speed, runCallbacks = true, internal) {
    if (typeof index === "string") {
      const indexAsNumber = parseInt(index, 10);
      index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") {
      speed = swiper.params.speed;
    }
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
      if (swiper.virtual && swiper.params.virtual.enabled) {
        newIndex = newIndex + swiper.virtual.slidesBefore;
      } else {
        let targetSlideIndex;
        if (gridEnabled) {
          const slideIndex = newIndex * swiper.params.grid.rows;
          targetSlideIndex = swiper.slides.find((slideEl) => slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex).column;
        } else {
          targetSlideIndex = swiper.getSlideIndexByData(newIndex);
        }
        const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
        const {
          centeredSlides,
          slidesOffsetBefore,
          slidesOffsetAfter
        } = swiper.params;
        const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
        let slidesPerView = swiper.params.slidesPerView;
        if (slidesPerView === "auto") {
          slidesPerView = swiper.slidesPerViewDynamic();
        } else {
          slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
          if (bothDirections && slidesPerView % 2 === 0) {
            slidesPerView = slidesPerView + 1;
          }
        }
        let needLoopFix = cols - targetSlideIndex < slidesPerView;
        if (bothDirections) {
          needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
        }
        if (internal && bothDirections && swiper.params.slidesPerView !== "auto" && !gridEnabled) {
          needLoopFix = false;
        }
        if (needLoopFix) {
          const direction = bothDirections ? targetSlideIndex < swiper.activeIndex ? "prev" : "next" : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? "next" : "prev";
          swiper.loopFix({
            direction,
            slideTo: true,
            activeSlideIndex: direction === "next" ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
            slideRealIndex: direction === "next" ? swiper.realIndex : void 0
          });
        }
        if (gridEnabled) {
          const slideIndex = newIndex * swiper.params.grid.rows;
          newIndex = swiper.slides.find((slideEl) => slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex).column;
        } else {
          newIndex = swiper.getSlideIndexByData(newIndex);
        }
      }
    }
    requestAnimationFrame(() => {
      swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
  }
  function slideNext(speed, runCallbacks = true, internal) {
    const swiper = this;
    const {
      enabled,
      params,
      animating
    } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === "undefined") {
      speed = swiper.params.speed;
    }
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    }
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
      if (animating && !isVirtual && params.loopPreventsSliding) return false;
      swiper.loopFix({
        direction: "next"
      });
      swiper._clientLeft = swiper.wrapperEl.clientLeft;
      if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
        requestAnimationFrame(() => {
          swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
        });
        return true;
      }
    }
    if (params.rewind && swiper.isEnd) {
      return swiper.slideTo(0, speed, runCallbacks, internal);
    }
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
  }
  function slidePrev(speed, runCallbacks = true, internal) {
    const swiper = this;
    const {
      params,
      snapGrid,
      slidesGrid,
      rtlTranslate,
      enabled,
      animating
    } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === "undefined") {
      speed = swiper.params.speed;
    }
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
      if (animating && !isVirtual && params.loopPreventsSliding) return false;
      swiper.loopFix({
        direction: "prev"
      });
      swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate2 = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
      if (val < 0) return -Math.floor(Math.abs(val));
      return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate2);
    const normalizedSnapGrid = snapGrid.map((val) => normalize(val));
    const isFreeMode = params.freeMode && params.freeMode.enabled;
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && (params.cssMode || isFreeMode)) {
      let prevSnapIndex;
      snapGrid.forEach((snap, snapIndex) => {
        if (normalizedTranslate >= snap) {
          prevSnapIndex = snapIndex;
        }
      });
      if (typeof prevSnapIndex !== "undefined") {
        prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
      }
    }
    let prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
      prevIndex = slidesGrid.indexOf(prevSnap);
      if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
      if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
        prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
        prevIndex = Math.max(prevIndex, 0);
      }
    }
    if (params.rewind && swiper.isBeginning) {
      const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
      return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
      requestAnimationFrame(() => {
        swiper.slideTo(prevIndex, speed, runCallbacks, internal);
      });
      return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
  }
  function slideReset(speed, runCallbacks = true, internal) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") {
      speed = swiper.params.speed;
    }
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
  }
  function slideToClosest(speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") {
      speed = swiper.params.speed;
    }
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate2 >= swiper.snapGrid[snapIndex]) {
      const currentSnap = swiper.snapGrid[snapIndex];
      const nextSnap = swiper.snapGrid[snapIndex + 1];
      if (translate2 - currentSnap > (nextSnap - currentSnap) * threshold) {
        index += swiper.params.slidesPerGroup;
      }
    } else {
      const prevSnap = swiper.snapGrid[snapIndex - 1];
      const currentSnap = swiper.snapGrid[snapIndex];
      if (translate2 - prevSnap <= (currentSnap - prevSnap) * threshold) {
        index -= swiper.params.slidesPerGroup;
      }
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
  }
  function slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed) return;
    const {
      params,
      slidesEl
    } = swiper;
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.getSlideIndexWhenGrid(swiper.clickedIndex);
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    const isGrid = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    if (params.loop) {
      if (swiper.animating) return;
      realIndex = parseInt(swiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
      if (params.centeredSlides) {
        swiper.slideToLoop(realIndex);
      } else if (slideToIndex > (isGrid ? (swiper.slides.length - slidesPerView) / 2 - (swiper.params.grid.rows - 1) : swiper.slides.length - slidesPerView)) {
        swiper.loopFix();
        slideToIndex = swiper.getSlideIndex(elementChildren(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
        nextTick(() => {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else {
      swiper.slideTo(slideToIndex);
    }
  }
  var slide = {
    slideTo,
    slideToLoop,
    slideNext,
    slidePrev,
    slideReset,
    slideToClosest,
    slideToClickedSlide
  };
  function loopCreate(slideRealIndex, initial) {
    const swiper = this;
    const {
      params,
      slidesEl
    } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const initSlides = () => {
      const slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
      slides.forEach((el, index) => {
        el.setAttribute("data-swiper-slide-index", index);
      });
    };
    const clearBlankSlides = () => {
      const slides = elementChildren(slidesEl, `.${params.slideBlankClass}`);
      slides.forEach((el) => {
        el.remove();
      });
      if (slides.length > 0) {
        swiper.recalcSlides();
        swiper.updateSlides();
      }
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (params.loopAddBlankSlides && (params.slidesPerGroup > 1 || gridEnabled)) {
      clearBlankSlides();
    }
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides) => {
      for (let i = 0; i < amountOfSlides; i += 1) {
        const slideEl = swiper.isElement ? createElement("swiper-slide", [params.slideBlankClass]) : createElement("div", [params.slideClass, params.slideBlankClass]);
        swiper.slidesEl.append(slideEl);
      }
    };
    if (shouldFillGroup) {
      if (params.loopAddBlankSlides) {
        const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
        addBlankSlides(slidesToAdd);
        swiper.recalcSlides();
        swiper.updateSlides();
      } else {
        showWarning("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
      }
      initSlides();
    } else if (shouldFillGrid) {
      if (params.loopAddBlankSlides) {
        const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
        addBlankSlides(slidesToAdd);
        swiper.recalcSlides();
        swiper.updateSlides();
      } else {
        showWarning("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
      }
      initSlides();
    } else {
      initSlides();
    }
    const bothDirections = params.centeredSlides || !!params.slidesOffsetBefore || !!params.slidesOffsetAfter;
    swiper.loopFix({
      slideRealIndex,
      direction: bothDirections ? void 0 : "next",
      initial
    });
  }
  function loopFix({
    slideRealIndex,
    slideTo: slideTo2 = true,
    direction,
    setTranslate: setTranslate2,
    activeSlideIndex,
    initial,
    byController,
    byMousewheel
  } = {}) {
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit("beforeLoopFix");
    const {
      slides,
      allowSlidePrev,
      allowSlideNext,
      slidesEl,
      params
    } = swiper;
    const {
      centeredSlides,
      slidesOffsetBefore,
      slidesOffsetAfter,
      initialSlide
    } = params;
    const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
      if (slideTo2) {
        if (!bothDirections && swiper.snapIndex === 0) {
          swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
        } else if (bothDirections && swiper.snapIndex < params.slidesPerView) {
          swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
        } else if (swiper.snapIndex === swiper.snapGrid.length - 1) {
          swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
      }
      swiper.allowSlidePrev = allowSlidePrev;
      swiper.allowSlideNext = allowSlideNext;
      swiper.emit("loopFix");
      return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === "auto") {
      slidesPerView = swiper.slidesPerViewDynamic();
    } else {
      slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
      if (bothDirections && slidesPerView % 2 === 0) {
        slidesPerView = slidesPerView + 1;
      }
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    let loopedSlides = bothDirections ? Math.max(slidesPerGroup, Math.ceil(slidesPerView / 2)) : slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) {
      loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    }
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === "cards" && slides.length < slidesPerView + loopedSlides * 2) {
      showWarning("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters");
    } else if (gridEnabled && params.grid.fill === "row") {
      showWarning("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
    }
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !bothDirections;
    let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
    if (typeof activeSlideIndex === "undefined") {
      activeSlideIndex = swiper.getSlideIndex(slides.find((el) => el.classList.contains(params.slideActiveClass)));
    } else {
      activeIndex = activeSlideIndex;
    }
    const isNext = direction === "next" || !direction;
    const isPrev = direction === "prev" || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (bothDirections && typeof setTranslate2 === "undefined" ? -slidesPerView / 2 + 0.5 : 0);
    if (activeColIndexWithShift < loopedSlides) {
      slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
      for (let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1) {
        const index = i - Math.floor(i / cols) * cols;
        if (gridEnabled) {
          const colIndexToPrepend = cols - index - 1;
          for (let i2 = slides.length - 1; i2 >= 0; i2 -= 1) {
            if (slides[i2].column === colIndexToPrepend) prependSlidesIndexes.push(i2);
          }
        } else {
          prependSlidesIndexes.push(cols - index - 1);
        }
      }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
      slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
      if (isInitialOverflow) {
        slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
      }
      for (let i = 0; i < slidesAppended; i += 1) {
        const index = i - Math.floor(i / cols) * cols;
        if (gridEnabled) {
          slides.forEach((slide2, slideIndex) => {
            if (slide2.column === index) appendSlidesIndexes.push(slideIndex);
          });
        } else {
          appendSlidesIndexes.push(index);
        }
      }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(() => {
      swiper.__preventObserver__ = false;
    });
    if (swiper.params.effect === "cards" && slides.length < slidesPerView + loopedSlides * 2) {
      if (appendSlidesIndexes.includes(activeSlideIndex)) {
        appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
      }
      if (prependSlidesIndexes.includes(activeSlideIndex)) {
        prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
      }
    }
    if (isPrev) {
      prependSlidesIndexes.forEach((index) => {
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
      });
    }
    if (isNext) {
      appendSlidesIndexes.forEach((index) => {
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
      });
    }
    swiper.recalcSlides();
    if (params.slidesPerView === "auto") {
      swiper.updateSlides();
    } else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) {
      swiper.slides.forEach((slide2, slideIndex) => {
        swiper.grid.updateSlide(slideIndex, slide2, swiper.slides);
      });
    }
    if (params.watchSlidesProgress) {
      swiper.updateSlidesOffset();
    }
    if (slideTo2) {
      if (prependSlidesIndexes.length > 0 && isPrev) {
        if (typeof slideRealIndex === "undefined") {
          const currentSlideTranslate = swiper.slidesGrid[activeIndex];
          const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
          const diff = newSlideTranslate - currentSlideTranslate;
          if (byMousewheel) {
            swiper.setTranslate(swiper.translate - diff);
          } else {
            swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
            if (setTranslate2) {
              swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
              swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
            }
          }
        } else {
          if (setTranslate2) {
            const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
            swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
            swiper.touchEventsData.currentTranslate = swiper.translate;
          }
        }
      } else if (appendSlidesIndexes.length > 0 && isNext) {
        if (typeof slideRealIndex === "undefined") {
          const currentSlideTranslate = swiper.slidesGrid[activeIndex];
          const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
          const diff = newSlideTranslate - currentSlideTranslate;
          if (byMousewheel) {
            swiper.setTranslate(swiper.translate - diff);
          } else {
            swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
            if (setTranslate2) {
              swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
              swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
            }
          }
        } else {
          const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
          swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
        }
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
      const loopParams = {
        slideRealIndex,
        direction,
        setTranslate: setTranslate2,
        activeSlideIndex,
        byController: true
      };
      if (Array.isArray(swiper.controller.control)) {
        swiper.controller.control.forEach((c) => {
          if (!c.destroyed && c.params.loop) c.loopFix({
            ...loopParams,
            slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo2 : false
          });
        });
      } else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) {
        swiper.controller.control.loopFix({
          ...loopParams,
          slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo2 : false
        });
      }
    }
    swiper.emit("loopFix");
  }
  function loopDestroy() {
    const swiper = this;
    const {
      params,
      slidesEl
    } = swiper;
    if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl) => {
      const index = typeof slideEl.swiperSlideIndex === "undefined" ? slideEl.getAttribute("data-swiper-slide-index") * 1 : slideEl.swiperSlideIndex;
      newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl) => {
      slideEl.removeAttribute("data-swiper-slide-index");
    });
    newSlidesOrder.forEach((slideEl) => {
      slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
  }
  var loop = {
    loopCreate,
    loopFix,
    loopDestroy
  };
  function setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) {
      swiper.__preventObserver__ = true;
    }
    el.style.cursor = "move";
    el.style.cursor = moving ? "grabbing" : "grab";
    if (swiper.isElement) {
      requestAnimationFrame(() => {
        swiper.__preventObserver__ = false;
      });
    }
  }
  function unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
      return;
    }
    if (swiper.isElement) {
      swiper.__preventObserver__ = true;
    }
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
    if (swiper.isElement) {
      requestAnimationFrame(() => {
        swiper.__preventObserver__ = false;
      });
    }
  }
  var grabCursor = {
    setGrabCursor,
    unsetGrabCursor
  };
  function closestElement(selector, base = this) {
    function __closestFrom(el) {
      if (!el || el === getDocument() || el === getWindow()) return null;
      if (el.assignedSlot) el = el.assignedSlot;
      const found = el.closest(selector);
      if (!found && !el.getRootNode) {
        return null;
      }
      return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
  }
  function preventEdgeSwipe(swiper, event2, startX) {
    const window2 = getWindow();
    const {
      params
    } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window2.innerWidth - edgeSwipeThreshold)) {
      if (edgeSwipeDetection === "prevent") {
        event2.preventDefault();
        return true;
      }
      return false;
    }
    return true;
  }
  function onTouchStart(event2) {
    const swiper = this;
    if (swiper.destroyed) return;
    const document2 = getDocument();
    let e = event2;
    if (e.originalEvent) e = e.originalEvent;
    const data = swiper.touchEventsData;
    if (e.type === "pointerdown") {
      if (data.pointerId !== null && data.pointerId !== e.pointerId) {
        return;
      }
      data.pointerId = e.pointerId;
    } else if (e.type === "touchstart" && e.targetTouches.length === 1) {
      data.touchId = e.targetTouches[0].identifier;
    }
    if (e.type === "touchstart") {
      preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
      return;
    }
    const {
      params,
      touches,
      enabled
    } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === "mouse") return;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return;
    }
    if (!swiper.animating && params.cssMode && params.loop) {
      swiper.loopFix();
    }
    let targetEl = e.target;
    if (params.touchEventsTarget === "wrapper") {
      if (!elementIsChildOf(targetEl, swiper.wrapperEl)) return;
    }
    if ("which" in e && e.which === 3) return;
    if ("button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
    const eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) {
      targetEl = eventPath[0];
    }
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
      swiper.allowClick = true;
      return;
    }
    if (params.swipeHandler) {
      if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    if (!preventEdgeSwipe(swiper, e, startX)) {
      return;
    }
    Object.assign(data, {
      isTouched: true,
      isMoved: false,
      allowTouchCallbacks: true,
      isScrolling: void 0,
      startMoving: void 0
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = now();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = void 0;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
      preventDefault = false;
      if (targetEl.nodeName === "SELECT") {
        data.isTouched = false;
      }
    }
    if (document2.activeElement && document2.activeElement.matches(data.focusableElements) && document2.activeElement !== targetEl && (e.pointerType === "mouse" || e.pointerType !== "mouse" && !targetEl.matches(data.focusableElements))) {
      document2.activeElement.blur();
    }
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) {
      e.preventDefault();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
      swiper.freeMode.onTouchStart();
    }
    swiper.emit("touchStart", e);
  }
  function onTouchMove(event2) {
    const document2 = getDocument();
    const swiper = this;
    if (swiper.destroyed) return;
    const data = swiper.touchEventsData;
    const {
      params,
      touches,
      rtlTranslate: rtl,
      enabled
    } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event2.pointerType === "mouse") return;
    let e = event2;
    if (e.originalEvent) e = e.originalEvent;
    if (e.type === "pointermove") {
      if (data.touchId !== null) return;
      const id = e.pointerId;
      if (id !== data.pointerId) return;
    }
    let targetTouch;
    if (e.type === "touchmove") {
      targetTouch = [...e.changedTouches].find((t) => t.identifier === data.touchId);
      if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else {
      targetTouch = e;
    }
    if (!data.isTouched) {
      if (data.startMoving && data.isScrolling) {
        swiper.emit("touchMoveOpposite", e);
      }
      return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
      touches.startX = pageX;
      touches.startY = pageY;
      return;
    }
    if (!swiper.allowTouchMove) {
      if (!e.target.matches(data.focusableElements)) {
        swiper.allowClick = false;
      }
      if (data.isTouched) {
        Object.assign(touches, {
          startX: pageX,
          startY: pageY,
          currentX: pageX,
          currentY: pageY
        });
        data.touchStartTime = now();
      }
      return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
      if (swiper.isVertical()) {
        if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
          data.isTouched = false;
          data.isMoved = false;
          return;
        }
      } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) {
        return;
      } else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) {
        return;
      }
    }
    if (document2.activeElement && document2.activeElement.matches(data.focusableElements) && document2.activeElement !== e.target && e.pointerType !== "mouse") {
      document2.activeElement.blur();
    }
    if (document2.activeElement) {
      if (e.target === document2.activeElement && e.target.matches(data.focusableElements)) {
        data.isMoved = true;
        swiper.allowClick = false;
        return;
      }
    }
    if (data.allowTouchCallbacks) {
      swiper.emit("touchMove", e);
    }
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
      let touchAngle;
      if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
        data.isScrolling = false;
      } else {
        if (diffX * diffX + diffY * diffY >= 25) {
          touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
          data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
      }
    }
    if (data.isScrolling) {
      swiper.emit("touchMoveOpposite", e);
    }
    if (typeof data.startMoving === "undefined") {
      if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
        data.startMoving = true;
      }
    }
    if (data.isScrolling || e.type === "touchmove" && data.preventTouchMoveFromPointerMove) {
      data.isTouched = false;
      return;
    }
    if (!data.startMoving) {
      return;
    }
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) {
      e.preventDefault();
    }
    if (params.touchMoveStopPropagation && !params.nested) {
      e.stopPropagation();
    }
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
      diff = Math.abs(diff) * (rtl ? 1 : -1);
      touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
      diff = -diff;
      touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    swiper.touchesDirection = touchesDiff > 0 ? "prev" : "next";
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === "next" && swiper.allowSlideNext || swiper.touchesDirection === "prev" && swiper.allowSlidePrev;
    if (!data.isMoved) {
      if (isLoop && allowLoopFix) {
        swiper.loopFix({
          direction: swiper.swipeDirection
        });
      }
      data.startTranslate = swiper.getTranslate();
      swiper.setTransition(0);
      if (swiper.animating) {
        const evt = new window.CustomEvent("transitionend", {
          bubbles: true,
          cancelable: true,
          detail: {
            bySwiperTouchMove: true
          }
        });
        swiper.wrapperEl.dispatchEvent(evt);
      }
      data.allowMomentumBounce = false;
      if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
        swiper.setGrabCursor(true);
      }
      swiper.emit("sliderFirstMove", e);
    }
    let loopFixed;
    (/* @__PURE__ */ new Date()).getTime();
    if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY,
        startTranslate: data.currentTranslate
      });
      data.loopSwapReset = true;
      data.startTranslate = data.currentTranslate;
      return;
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) {
      resistanceRatio = 0;
    }
    if (diff > 0) {
      if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== "auto" && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) {
        swiper.loopFix({
          direction: "prev",
          setTranslate: true,
          activeSlideIndex: 0
        });
      }
      if (data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) {
          data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
      }
    } else if (diff < 0) {
      if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== "auto" && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) {
        swiper.loopFix({
          direction: "next",
          setTranslate: true,
          activeSlideIndex: swiper.slides.length - (params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
      }
      if (data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) {
          data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
      }
    }
    if (disableParentSwiper) {
      e.preventedByNestedSwiper = true;
    }
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
      data.currentTranslate = data.startTranslate;
    }
    if (params.threshold > 0) {
      if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
        if (!data.allowThresholdMove) {
          data.allowThresholdMove = true;
          touches.startX = touches.currentX;
          touches.startY = touches.currentY;
          data.currentTranslate = data.startTranslate;
          touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
          return;
        }
      } else {
        data.currentTranslate = data.startTranslate;
        return;
      }
    }
    if (!params.followFinger || params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) {
      swiper.freeMode.onTouchMove();
    }
    swiper.updateProgress(data.currentTranslate);
    swiper.setTranslate(data.currentTranslate);
  }
  function onTouchEnd(event2) {
    const swiper = this;
    if (swiper.destroyed) return;
    const data = swiper.touchEventsData;
    let e = event2;
    if (e.originalEvent) e = e.originalEvent;
    let targetTouch;
    const isTouchEvent = e.type === "touchend" || e.type === "touchcancel";
    if (!isTouchEvent) {
      if (data.touchId !== null) return;
      if (e.pointerId !== data.pointerId) return;
      targetTouch = e;
    } else {
      targetTouch = [...e.changedTouches].find((t) => t.identifier === data.touchId);
      if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(e.type)) {
      const proceed = ["pointercancel", "contextmenu"].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
      if (!proceed) {
        return;
      }
    }
    data.pointerId = null;
    data.touchId = null;
    const {
      params,
      touches,
      rtlTranslate: rtl,
      slidesGrid,
      enabled
    } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === "mouse") return;
    if (data.allowTouchCallbacks) {
      swiper.emit("touchEnd", e);
    }
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
      if (data.isMoved && params.grabCursor) {
        swiper.setGrabCursor(false);
      }
      data.isMoved = false;
      data.startMoving = false;
      return;
    }
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(false);
    }
    const touchEndTime = now();
    const timeDiff = touchEndTime - data.touchStartTime;
    if (swiper.allowClick) {
      const pathTree = e.path || e.composedPath && e.composedPath();
      swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
      swiper.emit("tap click", e);
      if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
        swiper.emit("doubleTap doubleClick", e);
      }
    }
    data.lastClickTime = now();
    nextTick(() => {
      if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
      data.isTouched = false;
      data.isMoved = false;
      data.startMoving = false;
      return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) {
      currentPos = rtl ? swiper.translate : -swiper.translate;
    } else {
      currentPos = -data.currentTranslate;
    }
    if (params.cssMode) {
      return;
    }
    if (params.freeMode && params.freeMode.enabled) {
      swiper.freeMode.onTouchEnd({
        currentPos
      });
      return;
    }
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for (let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
      const increment2 = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
      if (typeof slidesGrid[i + increment2] !== "undefined") {
        if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment2]) {
          stopIndex = i;
          groupSize = slidesGrid[i + increment2] - slidesGrid[i];
        }
      } else if (swipeToLast || currentPos >= slidesGrid[i]) {
        stopIndex = i;
        groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
      }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
      if (swiper.isBeginning) {
        rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
      } else if (swiper.isEnd) {
        rewindFirstIndex = 0;
      }
    }
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
      if (!params.longSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (swiper.swipeDirection === "next") {
        if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
        else swiper.slideTo(stopIndex);
      }
      if (swiper.swipeDirection === "prev") {
        if (ratio > 1 - params.longSwipesRatio) {
          swiper.slideTo(stopIndex + increment);
        } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
          swiper.slideTo(rewindLastIndex);
        } else {
          swiper.slideTo(stopIndex);
        }
      }
    } else {
      if (!params.shortSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
      if (!isNavButtonTarget) {
        if (swiper.swipeDirection === "next") {
          swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
        }
        if (swiper.swipeDirection === "prev") {
          swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        }
      } else if (e.target === swiper.navigation.nextEl) {
        swiper.slideTo(stopIndex + increment);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  }
  function onResize() {
    const swiper = this;
    const {
      params,
      el
    } = swiper;
    if (el && el.offsetWidth === 0) return;
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }
    const {
      allowSlideNext,
      allowSlidePrev,
      snapGrid
    } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) {
      const slides = isVirtual ? swiper.virtual.slides : swiper.slides;
      swiper.slideTo(slides.length - 1, 0, false, true);
    } else {
      if (swiper.params.loop && !isVirtual) {
        swiper.slideToLoop(swiper.realIndex, 0, false, true);
      } else {
        swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
    }
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
      clearTimeout(swiper.autoplay.resizeTimeout);
      swiper.autoplay.resizeTimeout = setTimeout(() => {
        if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
          swiper.autoplay.resume();
        }
      }, 500);
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
  }
  function onClick(e) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
      if (swiper.params.preventClicks) e.preventDefault();
      if (swiper.params.preventClicksPropagation && swiper.animating) {
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }
  }
  function onScroll() {
    const swiper = this;
    if (swiper.destroyed) return;
    const {
      wrapperEl,
      rtlTranslate,
      enabled
    } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) {
      swiper.translate = -wrapperEl.scrollLeft;
    } else {
      swiper.translate = -wrapperEl.scrollTop;
    }
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) {
      newProgress = 0;
    } else {
      newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    }
    if (newProgress !== swiper.progress) {
      swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    }
    swiper.emit("setTranslate", swiper.translate, false);
  }
  function onLoad(e) {
    const swiper = this;
    if (swiper.destroyed) return;
    processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== "auto" && !swiper.params.autoHeight) {
      return;
    }
    swiper.update();
  }
  function onDocumentTouchStart() {
    const swiper = this;
    if (swiper.destroyed) return;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) {
      swiper.el.style.touchAction = "auto";
    }
  }
  var events = (swiper, method) => {
    const document2 = getDocument();
    const {
      params,
      el,
      wrapperEl,
      device
    } = swiper;
    const capture = !!params.nested;
    const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    const swiperMethod = method;
    if (!el || typeof el === "string") return;
    document2[domMethod]("touchstart", swiper.onDocumentTouchStart, {
      passive: false,
      capture
    });
    el[domMethod]("touchstart", swiper.onTouchStart, {
      passive: false
    });
    el[domMethod]("pointerdown", swiper.onTouchStart, {
      passive: false
    });
    document2[domMethod]("touchmove", swiper.onTouchMove, {
      passive: false,
      capture
    });
    document2[domMethod]("pointermove", swiper.onTouchMove, {
      passive: false,
      capture
    });
    document2[domMethod]("touchend", swiper.onTouchEnd, {
      passive: true
    });
    document2[domMethod]("pointerup", swiper.onTouchEnd, {
      passive: true
    });
    document2[domMethod]("pointercancel", swiper.onTouchEnd, {
      passive: true
    });
    document2[domMethod]("touchcancel", swiper.onTouchEnd, {
      passive: true
    });
    document2[domMethod]("pointerout", swiper.onTouchEnd, {
      passive: true
    });
    document2[domMethod]("pointerleave", swiper.onTouchEnd, {
      passive: true
    });
    document2[domMethod]("contextmenu", swiper.onTouchEnd, {
      passive: true
    });
    if (params.preventClicks || params.preventClicksPropagation) {
      el[domMethod]("click", swiper.onClick, true);
    }
    if (params.cssMode) {
      wrapperEl[domMethod]("scroll", swiper.onScroll);
    }
    if (params.updateOnWindowResize) {
      swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", onResize, true);
    } else {
      swiper[swiperMethod]("observerUpdate", onResize, true);
    }
    el[domMethod]("load", swiper.onLoad, {
      capture: true
    });
  };
  function attachEvents() {
    const swiper = this;
    const {
      params
    } = swiper;
    swiper.onTouchStart = onTouchStart.bind(swiper);
    swiper.onTouchMove = onTouchMove.bind(swiper);
    swiper.onTouchEnd = onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = onDocumentTouchStart.bind(swiper);
    if (params.cssMode) {
      swiper.onScroll = onScroll.bind(swiper);
    }
    swiper.onClick = onClick.bind(swiper);
    swiper.onLoad = onLoad.bind(swiper);
    events(swiper, "on");
  }
  function detachEvents() {
    const swiper = this;
    events(swiper, "off");
  }
  var events$1 = {
    attachEvents,
    detachEvents
  };
  var isGridEnabled = (swiper, params) => {
    return swiper.grid && params.grid && params.grid.rows > 1;
  };
  function setBreakpoint() {
    const swiper = this;
    const {
      realIndex,
      initialized,
      params,
      el
    } = swiper;
    const breakpoints2 = params.breakpoints;
    if (!breakpoints2 || breakpoints2 && Object.keys(breakpoints2).length === 0) return;
    const document2 = getDocument();
    const breakpointsBase = params.breakpointsBase === "window" || !params.breakpointsBase ? params.breakpointsBase : "container";
    const breakpointContainer = ["window", "container"].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document2.querySelector(params.breakpointsBase);
    const breakpoint = swiper.getBreakpoint(breakpoints2, breakpointsBase, breakpointContainer);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints2 ? breakpoints2[breakpoint] : void 0;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = isGridEnabled(swiper, params);
    const isMultiRow = isGridEnabled(swiper, breakpointParams);
    const wasGrabCursor = swiper.params.grabCursor;
    const isGrabCursor = breakpointParams.grabCursor;
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
      el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
      swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
      el.classList.add(`${params.containerModifierClass}grid`);
      if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") {
        el.classList.add(`${params.containerModifierClass}grid-column`);
      }
      swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) {
      swiper.unsetGrabCursor();
    } else if (!wasGrabCursor && isGrabCursor) {
      swiper.setGrabCursor();
    }
    ["navigation", "pagination", "scrollbar"].forEach((prop) => {
      if (typeof breakpointParams[prop] === "undefined") return;
      const wasModuleEnabled = params[prop] && params[prop].enabled;
      const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
      if (wasModuleEnabled && !isModuleEnabled) {
        swiper[prop].disable();
      }
      if (!wasModuleEnabled && isModuleEnabled) {
        swiper[prop].enable();
      }
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) {
      swiper.changeDirection();
    }
    extend2(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
      allowTouchMove: swiper.params.allowTouchMove,
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) {
      swiper.disable();
    } else if (!wasEnabled && isEnabled) {
      swiper.enable();
    }
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (initialized) {
      if (needsReLoop) {
        swiper.loopDestroy();
        swiper.loopCreate(realIndex);
        swiper.updateSlides();
      } else if (!wasLoop && hasLoop) {
        swiper.loopCreate(realIndex);
        swiper.updateSlides();
      } else if (wasLoop && !hasLoop) {
        swiper.loopDestroy();
      }
    }
    swiper.emit("breakpoint", breakpointParams);
  }
  function getBreakpoint(breakpoints2, base = "window", containerEl) {
    if (!breakpoints2 || base === "container" && !containerEl) return void 0;
    let breakpoint = false;
    const window2 = getWindow();
    const currentHeight = base === "window" ? window2.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints2).map((point) => {
      if (typeof point === "string" && point.indexOf("@") === 0) {
        const minRatio = parseFloat(point.substr(1));
        const value = currentHeight * minRatio;
        return {
          value,
          point
        };
      }
      return {
        value: point,
        point
      };
    });
    points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));
    for (let i = 0; i < points.length; i += 1) {
      const {
        point,
        value
      } = points[i];
      if (base === "window") {
        if (window2.matchMedia(`(min-width: ${value}px)`).matches) {
          breakpoint = point;
        }
      } else if (value <= containerEl.clientWidth) {
        breakpoint = point;
      }
    }
    return breakpoint || "max";
  }
  var breakpoints = {
    setBreakpoint,
    getBreakpoint
  };
  function prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item) => {
      if (typeof item === "object") {
        Object.keys(item).forEach((classNames) => {
          if (item[classNames]) {
            resultClasses.push(prefix + classNames);
          }
        });
      } else if (typeof item === "string") {
        resultClasses.push(prefix + item);
      }
    });
    return resultClasses;
  }
  function addClasses() {
    const swiper = this;
    const {
      classNames,
      params,
      rtl,
      el,
      device
    } = swiper;
    const suffixes = prepareClasses(["initialized", params.direction, {
      "free-mode": swiper.params.freeMode && params.freeMode.enabled
    }, {
      "autoheight": params.autoHeight
    }, {
      "rtl": rtl
    }, {
      "grid": params.grid && params.grid.rows > 1
    }, {
      "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
    }, {
      "android": device.android
    }, {
      "ios": device.ios
    }, {
      "css-mode": params.cssMode
    }, {
      "centered": params.cssMode && params.centeredSlides
    }, {
      "watch-progress": params.watchSlidesProgress
    }], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
  }
  function removeClasses() {
    const swiper = this;
    const {
      el,
      classNames
    } = swiper;
    if (!el || typeof el === "string") return;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
  }
  var classes = {
    addClasses,
    removeClasses
  };
  function checkOverflow() {
    const swiper = this;
    const {
      isLocked: wasLocked,
      params
    } = swiper;
    const {
      slidesOffsetBefore
    } = params;
    if (slidesOffsetBefore) {
      const lastSlideIndex = swiper.slides.length - 1;
      const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
      swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else {
      swiper.isLocked = swiper.snapGrid.length === 1;
    }
    if (params.allowSlideNext === true) {
      swiper.allowSlideNext = !swiper.isLocked;
    }
    if (params.allowSlidePrev === true) {
      swiper.allowSlidePrev = !swiper.isLocked;
    }
    if (wasLocked && wasLocked !== swiper.isLocked) {
      swiper.isEnd = false;
    }
    if (wasLocked !== swiper.isLocked) {
      swiper.emit(swiper.isLocked ? "lock" : "unlock");
    }
  }
  var checkOverflow$1 = {
    checkOverflow
  };
  var defaults = {
    init: true,
    direction: "horizontal",
    oneWayMovement: false,
    swiperElementNodeName: "SWIPER-CONTAINER",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: "swiper",
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: void 0,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    snapToSlideEdge: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-blank",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideFullyVisibleClass: "swiper-slide-fully-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
  };
  function moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj = {}) {
      const moduleParamName = Object.keys(obj)[0];
      const moduleParams = obj[moduleParamName];
      if (typeof moduleParams !== "object" || moduleParams === null) {
        extend2(allModulesParams, obj);
        return;
      }
      if (params[moduleParamName] === true) {
        params[moduleParamName] = {
          enabled: true
        };
      }
      if (moduleParamName === "navigation" && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) {
        params[moduleParamName].auto = true;
      }
      if (["pagination", "scrollbar"].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) {
        params[moduleParamName].auto = true;
      }
      if (!(moduleParamName in params && "enabled" in moduleParams)) {
        extend2(allModulesParams, obj);
        return;
      }
      if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) {
        params[moduleParamName].enabled = true;
      }
      if (!params[moduleParamName]) params[moduleParamName] = {
        enabled: false
      };
      extend2(allModulesParams, obj);
    };
  }
  var prototypes = {
    eventsEmitter,
    update,
    translate,
    transition,
    slide,
    loop,
    grabCursor,
    events: events$1,
    breakpoints,
    checkOverflow: checkOverflow$1,
    classes
  };
  var extendedDefaults = {};
  var Swiper = class _Swiper {
    constructor(...args) {
      let el;
      let params;
      if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") {
        params = args[0];
      } else {
        [el, params] = args;
      }
      if (!params) params = {};
      params = extend2({}, params);
      if (el && !params.el) params.el = el;
      const document2 = getDocument();
      if (params.el && typeof params.el === "string" && document2.querySelectorAll(params.el).length > 1) {
        const swipers = [];
        document2.querySelectorAll(params.el).forEach((containerEl) => {
          const newParams = extend2({}, params, {
            el: containerEl
          });
          swipers.push(new _Swiper(newParams));
        });
        return swipers;
      }
      const swiper = this;
      swiper.__swiper__ = true;
      swiper.support = getSupport();
      swiper.device = getDevice({
        userAgent: params.userAgent
      });
      swiper.browser = getBrowser();
      swiper.eventsListeners = {};
      swiper.eventsAnyListeners = [];
      swiper.modules = [...swiper.__modules__];
      if (params.modules && Array.isArray(params.modules)) {
        params.modules.forEach((mod) => {
          if (typeof mod === "function" && swiper.modules.indexOf(mod) < 0) {
            swiper.modules.push(mod);
          }
        });
      }
      const allModulesParams = {};
      swiper.modules.forEach((mod) => {
        mod({
          params,
          swiper,
          extendParams: moduleExtendParams(params, allModulesParams),
          on: swiper.on.bind(swiper),
          once: swiper.once.bind(swiper),
          off: swiper.off.bind(swiper),
          emit: swiper.emit.bind(swiper)
        });
      });
      const swiperParams = extend2({}, defaults, allModulesParams);
      swiper.params = extend2({}, swiperParams, extendedDefaults, params);
      swiper.originalParams = extend2({}, swiper.params);
      swiper.passedParams = extend2({}, params);
      if (swiper.params && swiper.params.on) {
        Object.keys(swiper.params.on).forEach((eventName) => {
          swiper.on(eventName, swiper.params.on[eventName]);
        });
      }
      if (swiper.params && swiper.params.onAny) {
        swiper.onAny(swiper.params.onAny);
      }
      Object.assign(swiper, {
        enabled: swiper.params.enabled,
        el,
        // Classes
        classNames: [],
        // Slides
        slides: [],
        slidesGrid: [],
        snapGrid: [],
        slidesSizesGrid: [],
        // isDirection
        isHorizontal() {
          return swiper.params.direction === "horizontal";
        },
        isVertical() {
          return swiper.params.direction === "vertical";
        },
        // Indexes
        activeIndex: 0,
        realIndex: 0,
        //
        isBeginning: true,
        isEnd: false,
        // Props
        translate: 0,
        previousTranslate: 0,
        progress: 0,
        velocity: 0,
        animating: false,
        cssOverflowAdjustment() {
          return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
        },
        // Locks
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,
        // Touch Events
        touchEventsData: {
          isTouched: void 0,
          isMoved: void 0,
          allowTouchCallbacks: void 0,
          touchStartTime: void 0,
          isScrolling: void 0,
          currentTranslate: void 0,
          startTranslate: void 0,
          allowThresholdMove: void 0,
          // Form elements to match
          focusableElements: swiper.params.focusableElements,
          // Last click time
          lastClickTime: 0,
          clickTimeout: void 0,
          // Velocities
          velocities: [],
          allowMomentumBounce: void 0,
          startMoving: void 0,
          pointerId: null,
          touchId: null
        },
        // Clicks
        allowClick: true,
        // Touches
        allowTouchMove: swiper.params.allowTouchMove,
        touches: {
          startX: 0,
          startY: 0,
          currentX: 0,
          currentY: 0,
          diff: 0
        },
        // Images
        imagesToLoad: [],
        imagesLoaded: 0
      });
      swiper.emit("_swiper");
      if (swiper.params.init) {
        swiper.init();
      }
      return swiper;
    }
    getDirectionLabel(property) {
      if (this.isHorizontal()) {
        return property;
      }
      return {
        "width": "height",
        "margin-top": "margin-left",
        "margin-bottom ": "margin-right",
        "margin-left": "margin-top",
        "margin-right": "margin-bottom",
        "padding-left": "padding-top",
        "padding-right": "padding-bottom",
        "marginRight": "marginBottom"
      }[property];
    }
    getSlideIndex(slideEl) {
      const {
        slidesEl,
        params
      } = this;
      const slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
      const firstSlideIndex = elementIndex(slides[0]);
      return elementIndex(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
      return this.getSlideIndex(this.slides.find((slideEl) => slideEl.getAttribute("data-swiper-slide-index") * 1 === index));
    }
    getSlideIndexWhenGrid(index) {
      if (this.grid && this.params.grid && this.params.grid.rows > 1) {
        if (this.params.grid.fill === "column") {
          index = Math.floor(index / this.params.grid.rows);
        } else if (this.params.grid.fill === "row") {
          index = index % Math.ceil(this.slides.length / this.params.grid.rows);
        }
      }
      return index;
    }
    recalcSlides() {
      const swiper = this;
      const {
        slidesEl,
        params
      } = swiper;
      swiper.slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
      const swiper = this;
      if (swiper.enabled) return;
      swiper.enabled = true;
      if (swiper.params.grabCursor) {
        swiper.setGrabCursor();
      }
      swiper.emit("enable");
    }
    disable() {
      const swiper = this;
      if (!swiper.enabled) return;
      swiper.enabled = false;
      if (swiper.params.grabCursor) {
        swiper.unsetGrabCursor();
      }
      swiper.emit("disable");
    }
    setProgress(progress, speed) {
      const swiper = this;
      progress = Math.min(Math.max(progress, 0), 1);
      const min = swiper.minTranslate();
      const max = swiper.maxTranslate();
      const current = (max - min) * progress + min;
      swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
      const swiper = this;
      if (!swiper.params._emitClasses || !swiper.el) return;
      const cls = swiper.el.className.split(" ").filter((className) => {
        return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
      });
      swiper.emit("_containerClasses", cls.join(" "));
    }
    getSlideClasses(slideEl) {
      const swiper = this;
      if (swiper.destroyed) return "";
      return slideEl.className.split(" ").filter((className) => {
        return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
      }).join(" ");
    }
    emitSlidesClasses() {
      const swiper = this;
      if (!swiper.params._emitClasses || !swiper.el) return;
      const updates = [];
      swiper.slides.forEach((slideEl) => {
        const classNames = swiper.getSlideClasses(slideEl);
        updates.push({
          slideEl,
          classNames
        });
        swiper.emit("_slideClass", slideEl, classNames);
      });
      swiper.emit("_slideClasses", updates);
    }
    slidesPerViewDynamic(view = "current", exact = false) {
      const swiper = this;
      const {
        params,
        slides,
        slidesGrid,
        slidesSizesGrid,
        size: swiperSize,
        activeIndex
      } = swiper;
      let spv = 1;
      if (typeof params.slidesPerView === "number") return params.slidesPerView;
      if (params.centeredSlides) {
        let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
        let breakLoop;
        for (let i = activeIndex + 1; i < slides.length; i += 1) {
          if (slides[i] && !breakLoop) {
            slideSize += Math.ceil(slides[i].swiperSlideSize);
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }
        for (let i = activeIndex - 1; i >= 0; i -= 1) {
          if (slides[i] && !breakLoop) {
            slideSize += slides[i].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }
      } else {
        if (view === "current") {
          for (let i = activeIndex + 1; i < slides.length; i += 1) {
            const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
            if (slideInView) {
              spv += 1;
            }
          }
        } else {
          for (let i = activeIndex - 1; i >= 0; i -= 1) {
            const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
            if (slideInView) {
              spv += 1;
            }
          }
        }
      }
      return spv;
    }
    update() {
      const swiper = this;
      if (!swiper || swiper.destroyed) return;
      const {
        snapGrid,
        params
      } = swiper;
      if (params.breakpoints) {
        swiper.setBreakpoint();
      }
      [...swiper.el.querySelectorAll('[loading="lazy"]')].forEach((imageEl) => {
        if (imageEl.complete) {
          processLazyPreloader(swiper, imageEl);
        }
      });
      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();
      function setTranslate2() {
        const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
        const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      let translated;
      if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
        setTranslate2();
        if (params.autoHeight) {
          swiper.updateAutoHeight();
        }
      } else {
        if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
          const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
          translated = swiper.slideTo(slides.length - 1, 0, false, true);
        } else {
          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
        }
        if (!translated) {
          setTranslate2();
        }
      }
      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
      swiper.emit("update");
    }
    changeDirection(newDirection, needUpdate = true) {
      const swiper = this;
      const currentDirection = swiper.params.direction;
      if (!newDirection) {
        newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
      }
      if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") {
        return swiper;
      }
      swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
      swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
      swiper.emitContainerClasses();
      swiper.params.direction = newDirection;
      swiper.slides.forEach((slideEl) => {
        if (newDirection === "vertical") {
          slideEl.style.width = "";
        } else {
          slideEl.style.height = "";
        }
      });
      swiper.emit("changeDirection");
      if (needUpdate) swiper.update();
      return swiper;
    }
    changeLanguageDirection(direction) {
      const swiper = this;
      if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
      swiper.rtl = direction === "rtl";
      swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
      if (swiper.rtl) {
        swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
        swiper.el.dir = "rtl";
      } else {
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
        swiper.el.dir = "ltr";
      }
      swiper.update();
    }
    mount(element) {
      const swiper = this;
      if (swiper.mounted) return true;
      let el = element || swiper.params.el;
      if (typeof el === "string") {
        el = document.querySelector(el);
      }
      if (!el) {
        return false;
      }
      el.swiper = swiper;
      if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) {
        swiper.isElement = true;
      }
      const getWrapperSelector = () => {
        return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
      };
      const getWrapper = () => {
        if (el && el.shadowRoot && el.shadowRoot.querySelector) {
          const res = el.shadowRoot.querySelector(getWrapperSelector());
          return res;
        }
        return elementChildren(el, getWrapperSelector())[0];
      };
      let wrapperEl = getWrapper();
      if (!wrapperEl && swiper.params.createElements) {
        wrapperEl = createElement("div", swiper.params.wrapperClass);
        el.append(wrapperEl);
        elementChildren(el, `.${swiper.params.slideClass}`).forEach((slideEl) => {
          wrapperEl.append(slideEl);
        });
      }
      Object.assign(swiper, {
        el,
        wrapperEl,
        slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
        hostEl: swiper.isElement ? el.parentNode.host : el,
        mounted: true,
        // RTL
        rtl: el.dir.toLowerCase() === "rtl" || elementStyle(el, "direction") === "rtl",
        rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || elementStyle(el, "direction") === "rtl"),
        wrongRTL: elementStyle(wrapperEl, "display") === "-webkit-box"
      });
      return true;
    }
    init(el) {
      const swiper = this;
      if (swiper.initialized) return swiper;
      const mounted = swiper.mount(el);
      if (mounted === false) return swiper;
      swiper.emit("beforeInit");
      if (swiper.params.breakpoints) {
        swiper.setBreakpoint();
      }
      swiper.addClasses();
      swiper.updateSize();
      swiper.updateSlides();
      if (swiper.params.watchOverflow) {
        swiper.checkOverflow();
      }
      if (swiper.params.grabCursor && swiper.enabled) {
        swiper.setGrabCursor();
      }
      if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
      } else {
        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
      }
      if (swiper.params.loop) {
        swiper.loopCreate(void 0, true);
      }
      swiper.attachEvents();
      const lazyElements = [...swiper.el.querySelectorAll('[loading="lazy"]')];
      if (swiper.isElement) {
        lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
      }
      lazyElements.forEach((imageEl) => {
        if (imageEl.complete) {
          processLazyPreloader(swiper, imageEl);
        } else {
          imageEl.addEventListener("load", (e) => {
            processLazyPreloader(swiper, e.target);
          });
        }
      });
      preload(swiper);
      swiper.initialized = true;
      preload(swiper);
      swiper.emit("init");
      swiper.emit("afterInit");
      return swiper;
    }
    destroy(deleteInstance = true, cleanStyles = true) {
      const swiper = this;
      const {
        params,
        el,
        wrapperEl,
        slides
      } = swiper;
      if (typeof swiper.params === "undefined" || swiper.destroyed) {
        return null;
      }
      swiper.emit("beforeDestroy");
      swiper.initialized = false;
      swiper.detachEvents();
      if (params.loop) {
        swiper.loopDestroy();
      }
      if (cleanStyles) {
        swiper.removeClasses();
        if (el && typeof el !== "string") {
          el.removeAttribute("style");
        }
        if (wrapperEl) {
          wrapperEl.removeAttribute("style");
        }
        if (slides && slides.length) {
          slides.forEach((slideEl) => {
            slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
            slideEl.removeAttribute("style");
            slideEl.removeAttribute("data-swiper-slide-index");
          });
        }
      }
      swiper.emit("destroy");
      Object.keys(swiper.eventsListeners).forEach((eventName) => {
        swiper.off(eventName);
      });
      if (deleteInstance !== false) {
        if (swiper.el && typeof swiper.el !== "string") {
          swiper.el.swiper = null;
        }
        deleteProps(swiper);
      }
      swiper.destroyed = true;
      return null;
    }
    static extendDefaults(newDefaults) {
      extend2(extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
      return extendedDefaults;
    }
    static get defaults() {
      return defaults;
    }
    static installModule(mod) {
      if (!_Swiper.prototype.__modules__) _Swiper.prototype.__modules__ = [];
      const modules = _Swiper.prototype.__modules__;
      if (typeof mod === "function" && modules.indexOf(mod) < 0) {
        modules.push(mod);
      }
    }
    static use(module) {
      if (Array.isArray(module)) {
        module.forEach((m) => _Swiper.installModule(m));
        return _Swiper;
      }
      _Swiper.installModule(module);
      return _Swiper;
    }
  };
  Object.keys(prototypes).forEach((prototypeGroup) => {
    Object.keys(prototypes[prototypeGroup]).forEach((protoMethod) => {
      Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
    });
  });
  Swiper.use([Resize, Observer]);

  // node_modules/swiper/shared/create-element-if-not-defined.mjs
  function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) {
      Object.keys(checkProps).forEach((key) => {
        if (!params[key] && params.auto === true) {
          let element = elementChildren(swiper.el, `.${checkProps[key]}`)[0];
          if (!element) {
            element = createElement("div", checkProps[key]);
            element.className = checkProps[key];
            swiper.el.append(element);
          }
          params[key] = element;
          originalParams[key] = element;
        }
      });
    }
    return params;
  }

  // node_modules/swiper/modules/navigation.mjs
  var arrowSvg = `<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>`;
  function Navigation({
    swiper,
    extendParams,
    on,
    emit
  }) {
    extendParams({
      navigation: {
        nextEl: null,
        prevEl: null,
        addIcons: true,
        hideOnClick: false,
        disabledClass: "swiper-button-disabled",
        hiddenClass: "swiper-button-hidden",
        lockClass: "swiper-button-lock",
        navigationDisabledClass: "swiper-navigation-disabled"
      }
    });
    swiper.navigation = {
      nextEl: null,
      prevEl: null,
      arrowSvg
    };
    function getEl(el) {
      let res;
      if (el && typeof el === "string" && swiper.isElement) {
        res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
        if (res) return res;
      }
      if (el) {
        if (typeof el === "string") res = [...document.querySelectorAll(el)];
        if (swiper.params.uniqueNavElements && typeof el === "string" && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) {
          res = swiper.el.querySelector(el);
        } else if (res && res.length === 1) {
          res = res[0];
        }
      }
      if (el && !res) return el;
      return res;
    }
    function toggleEl(el, disabled) {
      const params = swiper.params.navigation;
      el = makeElementsArray(el);
      el.forEach((subEl) => {
        if (subEl) {
          subEl.classList[disabled ? "add" : "remove"](...params.disabledClass.split(" "));
          if (subEl.tagName === "BUTTON") subEl.disabled = disabled;
          if (swiper.params.watchOverflow && swiper.enabled) {
            subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
          }
        }
      });
    }
    function update2() {
      const {
        nextEl,
        prevEl
      } = swiper.navigation;
      if (swiper.params.loop) {
        toggleEl(prevEl, false);
        toggleEl(nextEl, false);
        return;
      }
      toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
      toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
      e.preventDefault();
      if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
      swiper.slidePrev();
      emit("navigationPrev");
    }
    function onNextClick(e) {
      e.preventDefault();
      if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
      swiper.slideNext();
      emit("navigationNext");
    }
    function init() {
      const params = swiper.params.navigation;
      swiper.params.navigation = createElementIfNotDefined(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
        nextEl: "swiper-button-next",
        prevEl: "swiper-button-prev"
      });
      if (!(params.nextEl || params.prevEl)) return;
      let nextEl = getEl(params.nextEl);
      let prevEl = getEl(params.prevEl);
      Object.assign(swiper.navigation, {
        nextEl,
        prevEl
      });
      nextEl = makeElementsArray(nextEl);
      prevEl = makeElementsArray(prevEl);
      const initButton = (el, dir) => {
        if (el) {
          if (params.addIcons && el.matches(".swiper-button-next,.swiper-button-prev") && !el.querySelector("svg")) {
            const tempEl = document.createElement("div");
            setInnerHTML(tempEl, arrowSvg);
            el.appendChild(tempEl.querySelector("svg"));
            tempEl.remove();
          }
          el.addEventListener("click", dir === "next" ? onNextClick : onPrevClick);
        }
        if (!swiper.enabled && el) {
          el.classList.add(...params.lockClass.split(" "));
        }
      };
      nextEl.forEach((el) => initButton(el, "next"));
      prevEl.forEach((el) => initButton(el, "prev"));
    }
    function destroy() {
      let {
        nextEl,
        prevEl
      } = swiper.navigation;
      nextEl = makeElementsArray(nextEl);
      prevEl = makeElementsArray(prevEl);
      const destroyButton = (el, dir) => {
        el.removeEventListener("click", dir === "next" ? onNextClick : onPrevClick);
        el.classList.remove(...swiper.params.navigation.disabledClass.split(" "));
      };
      nextEl.forEach((el) => destroyButton(el, "next"));
      prevEl.forEach((el) => destroyButton(el, "prev"));
    }
    on("init", () => {
      if (swiper.params.navigation.enabled === false) {
        disable();
      } else {
        init();
        update2();
      }
    });
    on("toEdge fromEdge lock unlock", () => {
      update2();
    });
    on("destroy", () => {
      destroy();
    });
    on("enable disable", () => {
      let {
        nextEl,
        prevEl
      } = swiper.navigation;
      nextEl = makeElementsArray(nextEl);
      prevEl = makeElementsArray(prevEl);
      if (swiper.enabled) {
        update2();
        return;
      }
      [...nextEl, ...prevEl].filter((el) => !!el).forEach((el) => el.classList.add(swiper.params.navigation.lockClass));
    });
    on("click", (_s, e) => {
      let {
        nextEl,
        prevEl
      } = swiper.navigation;
      nextEl = makeElementsArray(nextEl);
      prevEl = makeElementsArray(prevEl);
      const targetEl = e.target;
      let targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
      if (swiper.isElement && !targetIsButton) {
        const path = e.path || e.composedPath && e.composedPath();
        if (path) {
          targetIsButton = path.find((pathEl) => nextEl.includes(pathEl) || prevEl.includes(pathEl));
        }
      }
      if (swiper.params.navigation.hideOnClick && !targetIsButton) {
        if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
        let isHidden;
        if (nextEl.length) {
          isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
        } else if (prevEl.length) {
          isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
        }
        if (isHidden === true) {
          emit("navigationShow");
        } else {
          emit("navigationHide");
        }
        [...nextEl, ...prevEl].filter((el) => !!el).forEach((el) => el.classList.toggle(swiper.params.navigation.hiddenClass));
      }
    });
    const enable = () => {
      swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(" "));
      init();
      update2();
    };
    const disable = () => {
      swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(" "));
      destroy();
    };
    Object.assign(swiper.navigation, {
      enable,
      disable,
      update: update2,
      init,
      destroy
    });
  }

  // node_modules/swiper/modules/free-mode.mjs
  function freeMode({
    swiper,
    extendParams,
    emit,
    once
  }) {
    extendParams({
      freeMode: {
        enabled: false,
        momentum: true,
        momentumRatio: 1,
        momentumBounce: true,
        momentumBounceRatio: 1,
        momentumVelocityRatio: 1,
        sticky: false,
        minimumVelocity: 0.02
      }
    });
    function onTouchStart2() {
      if (swiper.params.cssMode) return;
      const translate2 = swiper.getTranslate();
      swiper.setTranslate(translate2);
      swiper.setTransition(0);
      swiper.touchEventsData.velocities.length = 0;
      swiper.freeMode.onTouchEnd({
        currentPos: swiper.rtl ? swiper.translate : -swiper.translate
      });
    }
    function onTouchMove2() {
      if (swiper.params.cssMode) return;
      const {
        touchEventsData: data,
        touches
      } = swiper;
      if (data.velocities.length === 0) {
        data.velocities.push({
          position: touches[swiper.isHorizontal() ? "startX" : "startY"],
          time: data.touchStartTime
        });
      }
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
        time: now()
      });
    }
    function onTouchEnd2({
      currentPos
    }) {
      if (swiper.params.cssMode) return;
      const {
        params,
        wrapperEl,
        rtlTranslate: rtl,
        snapGrid,
        touchEventsData: data
      } = swiper;
      const touchEndTime = now();
      const timeDiff = touchEndTime - data.touchStartTime;
      if (currentPos < -swiper.minTranslate()) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (currentPos > -swiper.maxTranslate()) {
        if (swiper.slides.length < snapGrid.length) {
          swiper.slideTo(snapGrid.length - 1);
        } else {
          swiper.slideTo(swiper.slides.length - 1);
        }
        return;
      }
      if (params.freeMode.momentum) {
        if (data.velocities.length > 1) {
          const lastMoveEvent = data.velocities.pop();
          const velocityEvent = data.velocities.pop();
          const distance = lastMoveEvent.position - velocityEvent.position;
          const time = lastMoveEvent.time - velocityEvent.time;
          swiper.velocity = distance / time;
          swiper.velocity /= 2;
          if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) {
            swiper.velocity = 0;
          }
          if (time > 150 || now() - lastMoveEvent.time > 300) {
            swiper.velocity = 0;
          }
        } else {
          swiper.velocity = 0;
        }
        swiper.velocity *= params.freeMode.momentumVelocityRatio;
        data.velocities.length = 0;
        let momentumDuration = 1e3 * params.freeMode.momentumRatio;
        const momentumDistance = swiper.velocity * momentumDuration;
        let newPosition = swiper.translate + momentumDistance;
        if (rtl) newPosition = -newPosition;
        let doBounce = false;
        let afterBouncePosition;
        const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
        let needsLoopFix;
        if (newPosition < swiper.maxTranslate()) {
          if (params.freeMode.momentumBounce) {
            if (newPosition + swiper.maxTranslate() < -bounceAmount) {
              newPosition = swiper.maxTranslate() - bounceAmount;
            }
            afterBouncePosition = swiper.maxTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.maxTranslate();
          }
          if (params.loop && params.centeredSlides) needsLoopFix = true;
        } else if (newPosition > swiper.minTranslate()) {
          if (params.freeMode.momentumBounce) {
            if (newPosition - swiper.minTranslate() > bounceAmount) {
              newPosition = swiper.minTranslate() + bounceAmount;
            }
            afterBouncePosition = swiper.minTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.minTranslate();
          }
          if (params.loop && params.centeredSlides) needsLoopFix = true;
        } else if (params.freeMode.sticky) {
          let nextSlide;
          for (let j = 0; j < snapGrid.length; j += 1) {
            if (snapGrid[j] > -newPosition) {
              nextSlide = j;
              break;
            }
          }
          if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next") {
            newPosition = snapGrid[nextSlide];
          } else {
            newPosition = snapGrid[nextSlide - 1];
          }
          newPosition = -newPosition;
        }
        if (needsLoopFix) {
          once("transitionEnd", () => {
            swiper.loopFix();
          });
        }
        if (swiper.velocity !== 0) {
          if (rtl) {
            momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
          } else {
            momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
          }
          if (params.freeMode.sticky) {
            const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
            const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
            if (moveDistance < currentSlideSize) {
              momentumDuration = params.speed;
            } else if (moveDistance < 2 * currentSlideSize) {
              momentumDuration = params.speed * 1.5;
            } else {
              momentumDuration = params.speed * 2.5;
            }
          }
        } else if (params.freeMode.sticky) {
          swiper.slideToClosest();
          return;
        }
        if (params.freeMode.momentumBounce && doBounce) {
          swiper.updateProgress(afterBouncePosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);
          swiper.animating = true;
          elementTransitionEnd(wrapperEl, () => {
            if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
            emit("momentumBounce");
            swiper.setTransition(params.speed);
            setTimeout(() => {
              swiper.setTranslate(afterBouncePosition);
              elementTransitionEnd(wrapperEl, () => {
                if (!swiper || swiper.destroyed) return;
                swiper.transitionEnd();
              });
            }, 0);
          });
        } else if (swiper.velocity) {
          emit("_freeModeNoMomentumRelease");
          swiper.updateProgress(newPosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);
          if (!swiper.animating) {
            swiper.animating = true;
            elementTransitionEnd(wrapperEl, () => {
              if (!swiper || swiper.destroyed) return;
              swiper.transitionEnd();
            });
          }
        } else {
          swiper.updateProgress(newPosition);
        }
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      } else if (params.freeMode.sticky) {
        swiper.slideToClosest();
        return;
      } else if (params.freeMode) {
        emit("_freeModeNoMomentumRelease");
      }
      if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
        emit("_freeModeStaticRelease");
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
    }
    Object.assign(swiper, {
      freeMode: {
        onTouchStart: onTouchStart2,
        onTouchMove: onTouchMove2,
        onTouchEnd: onTouchEnd2
      }
    });
  }

  // src/js/featured-collection-swiper.js
  function parseSlidesPerView(value, fallback) {
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
  }
  function updateFeaturedCollectionNav(swiper) {
    swiper.navigation?.update?.();
  }
  function initFeaturedCollectionSwipers(root = document) {
    root.querySelectorAll("[data-hygge-featured-collection]").forEach((carousel) => {
      if (carousel.swiper) {
        carousel.swiper.destroy(true, true);
        carousel.swiper = null;
      }
      const section = carousel.closest(".hygge-featured-collection");
      if (!section) return;
      const prevButton = section.querySelector("[data-hygge-featured-collection-prev]");
      const nextButton = section.querySelector("[data-hygge-featured-collection-next]");
      const mobileSlides = parseSlidesPerView(carousel.dataset.slidesMobile, 1.8);
      const desktopSlides = parseSlidesPerView(carousel.dataset.slidesDesktop, 4);
      const swiper = new Swiper(carousel, {
        modules: [Navigation],
        loop: false,
        spaceBetween: 8,
        slidesPerView: mobileSlides,
        watchOverflow: false,
        navigation: {
          prevEl: prevButton,
          nextEl: nextButton,
          disabledClass: "swiper-button-disabled"
        },
        breakpoints: {
          1050: {
            slidesPerView: desktopSlides,
            spaceBetween: 20
          }
        },
        on: {
          init: updateFeaturedCollectionNav,
          resize: updateFeaturedCollectionNav,
          lock: updateFeaturedCollectionNav,
          unlock: updateFeaturedCollectionNav,
          slideChange: updateFeaturedCollectionNav,
          toEdge: updateFeaturedCollectionNav,
          fromEdge: updateFeaturedCollectionNav
        }
      });
      carousel.swiper = swiper;
      requestAnimationFrame(() => {
        updateFeaturedCollectionNav(swiper);
      });
    });
  }
  function observeFeaturedCollectionSwipers() {
    document.addEventListener("shopify:section:load", (event2) => {
      initFeaturedCollectionSwipers(event2.target);
    });
  }

  // src/js/gallery-carousel-swiper.js
  function updateGalleryCarouselNav(swiper) {
    swiper.navigation?.update?.();
  }
  function initGalleryCarouselSwipers(root = document) {
    root.querySelectorAll("[data-hygge-gallery-carousel]").forEach((carousel) => {
      if (carousel.swiper) {
        carousel.swiper.destroy(true, true);
        carousel.swiper = null;
      }
      const section = carousel.closest(".hygge-gallery-carousel");
      if (!section) return;
      const prevButton = section.querySelector("[data-hygge-gallery-carousel-prev]");
      const nextButton = section.querySelector("[data-hygge-gallery-carousel-next]");
      const handleSlideMedia = () => {
        carousel.dispatchEvent(new CustomEvent("hygge-gallery-carousel:slide-change", { bubbles: true }));
      };
      const swiper = new Swiper(carousel, {
        modules: [Navigation],
        loop: false,
        spaceBetween: 10,
        slidesPerView: 2.1,
        watchOverflow: true,
        watchSlidesProgress: true,
        navigation: {
          prevEl: prevButton,
          nextEl: nextButton,
          disabledClass: "swiper-button-disabled"
        },
        breakpoints: {
          1050: {
            slidesPerView: 4,
            spaceBetween: 20
          }
        },
        on: {
          init: (instance) => {
            updateGalleryCarouselNav(instance);
            handleSlideMedia();
          },
          resize: (instance) => {
            updateGalleryCarouselNav(instance);
            handleSlideMedia();
          },
          lock: updateGalleryCarouselNav,
          unlock: updateGalleryCarouselNav,
          slideChange: (instance) => {
            updateGalleryCarouselNav(instance);
            handleSlideMedia();
          },
          slideChangeTransitionEnd: handleSlideMedia,
          toEdge: updateGalleryCarouselNav,
          fromEdge: updateGalleryCarouselNav
        }
      });
      carousel.swiper = swiper;
      requestAnimationFrame(() => {
        updateGalleryCarouselNav(swiper);
        handleSlideMedia();
      });
    });
  }
  function observeGalleryCarouselSwipers() {
    document.addEventListener("shopify:section:load", (event2) => {
      initGalleryCarouselSwipers(event2.target);
    });
  }

  // src/js/hygge-gallery-carousel.js
  var import_glightbox = __toESM(require_glightbox_min());
  var lightboxInstances = /* @__PURE__ */ new WeakMap();
  function getVisibleGallerySlides(carousel) {
    const visible = [...carousel.querySelectorAll(".swiper-slide-visible")];
    if (visible.length) return visible;
    const active = carousel.querySelector(".swiper-slide-active");
    return active ? [active] : [];
  }
  function pauseGalleryCarouselVideos(carousel, exceptSlides = []) {
    const keepPlaying = new Set(exceptSlides);
    carousel.querySelectorAll(".swiper-slide").forEach((slide2) => {
      if (keepPlaying.has(slide2)) return;
      slide2.querySelectorAll("video").forEach((video) => {
        video.pause();
      });
      slide2.querySelectorAll("video-component").forEach((component) => {
        component.pause?.();
      });
    });
  }
  function playVisibleGalleryCarouselVideos(carousel) {
    getVisibleGallerySlides(carousel).forEach((slide2) => {
      slide2.querySelectorAll("[data-gallery-video-autoplay] video").forEach((video) => {
        video.muted = true;
        video.playsInline = true;
        video.play().catch(() => {
        });
      });
      slide2.querySelectorAll("[data-gallery-video-autoplay] video-component").forEach((component) => {
        component.pausedByUser = false;
        component.play?.();
      });
    });
  }
  function syncGalleryCarouselVideos(carousel) {
    const visibleSlides = getVisibleGallerySlides(carousel);
    pauseGalleryCarouselVideos(carousel, visibleSlides);
    playVisibleGalleryCarouselVideos(carousel);
  }
  function initGalleryCarouselLightbox(section) {
    const existing = lightboxInstances.get(section);
    existing?.destroy?.();
    if (!section.querySelector(".glightbox")) return;
    const lightbox = (0, import_glightbox.default)({
      selector: `#${CSS.escape(section.id)} .glightbox`,
      autoplayVideos: true,
      touchNavigation: true,
      loop: false
    });
    lightboxInstances.set(section, lightbox);
  }
  function initHyggeGalleryCarouselVideos(root = document) {
    root.querySelectorAll(".hygge-gallery-carousel").forEach((section) => {
      if (section.dataset.hyggeGalleryVideosReady === "true") return;
      section.dataset.hyggeGalleryVideosReady = "true";
      const carousel = section.querySelector("[data-hygge-gallery-carousel]");
      initGalleryCarouselLightbox(section);
      if (carousel) {
        carousel.addEventListener("hygge-gallery-carousel:slide-change", () => {
          syncGalleryCarouselVideos(carousel);
        });
        syncGalleryCarouselVideos(carousel);
      }
    });
  }
  function observeHyggeGalleryCarouselVideos() {
    document.addEventListener("shopify:section:load", (event2) => {
      event2.target.querySelectorAll?.(".hygge-gallery-carousel").forEach((section) => {
        delete section.dataset.hyggeGalleryVideosReady;
      });
      if (event2.target.classList?.contains("hygge-gallery-carousel")) {
        delete event2.target.dataset.hyggeGalleryVideosReady;
      }
      initHyggeGalleryCarouselVideos(event2.target);
    });
  }

  // src/js/feature-columns-swiper.js
  var DESKTOP_BP = 768;
  function updateFeatureColumnsNav(swiper) {
    swiper.navigation?.update?.();
  }
  function initFeatureColumnsSwipers(root = document) {
    root.querySelectorAll("[data-hygge-feature-columns]").forEach((carousel) => {
      if (carousel.swiper) {
        carousel.swiper.destroy(true, true);
        carousel.swiper = null;
      }
      const section = carousel.closest(".hygge-feature-columns");
      if (!section) return;
      const prevButton = section.querySelector("[data-hygge-feature-columns-prev]");
      const nextButton = section.querySelector("[data-hygge-feature-columns-next]");
      const textOnly = carousel.hasAttribute("data-hygge-feature-columns-text-only");
      const mobileGap = textOnly ? 24 : 50;
      const desktopGap = textOnly ? 32 : 65;
      const swiper = new Swiper(carousel, {
        modules: [Navigation],
        loop: false,
        spaceBetween: mobileGap,
        slidesPerView: 1.15,
        watchOverflow: true,
        navigation: {
          prevEl: prevButton,
          nextEl: nextButton,
          disabledClass: "swiper-button-disabled"
        },
        breakpoints: {
          [DESKTOP_BP]: {
            slidesPerView: 3,
            spaceBetween: desktopGap
          }
        },
        on: {
          init: updateFeatureColumnsNav,
          resize: updateFeatureColumnsNav,
          lock: updateFeatureColumnsNav,
          unlock: updateFeatureColumnsNav,
          slideChange: updateFeatureColumnsNav,
          toEdge: updateFeatureColumnsNav,
          fromEdge: updateFeatureColumnsNav
        }
      });
      carousel.swiper = swiper;
      requestAnimationFrame(() => {
        updateFeatureColumnsNav(swiper);
      });
    });
  }
  function observeFeatureColumnsSwipers() {
    let resizeTimer;
    window.addEventListener("resize", () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        initFeatureColumnsSwipers();
      }, 150);
    });
    document.addEventListener("shopify:section:load", (event2) => {
      initFeatureColumnsSwipers(event2.target);
    });
  }

  // src/js/product-gallery-swiper.js
  var DESKTOP_BP2 = 1050;
  var mediaGalleryChangeBound = false;
  function syncThumbSwiper(gallery, swiper) {
    const active = gallery.querySelector(".thumbnails .slider__item.is-active");
    if (!active || !swiper) return;
    const slides = [...active.parentElement.children];
    const index = slides.indexOf(active);
    if (index >= 0) {
      swiper.slideTo(index);
    }
  }
  function createThumbSwiper(thumbsRoot, gallery) {
    const swiperEl = thumbsRoot.querySelector(".hygge-product-gallery__thumbs-swiper");
    if (!swiperEl) return null;
    const isDesktop = window.innerWidth >= DESKTOP_BP2;
    const swiper = new Swiper(swiperEl, {
      modules: [freeMode],
      direction: isDesktop ? "vertical" : "horizontal",
      spaceBetween: isDesktop ? 10 : 6,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true
    });
    thumbsRoot.swiper = swiper;
    thumbsRoot.galleryRef = gallery;
    syncThumbSwiper(gallery, swiper);
    return swiper;
  }
  function handleMediaGalleryChange() {
    document.querySelectorAll("[data-hygge-product-gallery-thumbs]").forEach((thumbsRoot) => {
      if (thumbsRoot.swiper && thumbsRoot.galleryRef) {
        syncThumbSwiper(thumbsRoot.galleryRef, thumbsRoot.swiper);
      }
    });
  }
  function initProductGallerySwipers(root = document) {
    root.querySelectorAll("[data-hygge-product-gallery-thumbs]").forEach((thumbsRoot) => {
      const gallery = thumbsRoot.closest("media-gallery");
      if (!gallery) return;
      if (thumbsRoot.swiper) {
        thumbsRoot.swiper.destroy(true, true);
        thumbsRoot.swiper = null;
      }
      createThumbSwiper(thumbsRoot, gallery);
      gallery.addEventListener("click", (event2) => {
        if (event2.target.closest(".thumbnail")) {
          requestAnimationFrame(() => syncThumbSwiper(gallery, thumbsRoot.swiper));
        }
      });
    });
    if (!mediaGalleryChangeBound) {
      document.addEventListener("on:media-gallery:change", handleMediaGalleryChange);
      mediaGalleryChangeBound = true;
    }
  }
  function observeProductGallerySwipers() {
    let resizeTimer;
    window.addEventListener("resize", () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        initProductGallerySwipers();
      }, 150);
    });
    document.addEventListener("shopify:section:load", (event2) => {
      initProductGallerySwipers(event2.target);
    });
  }

  // src/js/product-details-accordion.js
  function closeToggleTarget(toggler) {
    const target = document.querySelector(toggler.dataset.toggleTarget);
    if (!target || target.classList.contains("toggle-target--hidden") || target.classList.contains("toggle-target--in-transition")) {
      return;
    }
    toggler.click();
  }
  function initProductDetailsAccordions() {
    document.querySelectorAll("[data-exclusive-accordion]").forEach((group) => {
      if (group.dataset.exclusiveAccordionInit === "true") return;
      group.dataset.exclusiveAccordionInit = "true";
      group.addEventListener(
        "click",
        (event2) => {
          const toggler = event2.target.closest("toggle-target");
          if (!toggler || !group.contains(toggler)) return;
          const target = document.querySelector(toggler.dataset.toggleTarget);
          const willOpen = target?.classList.contains("toggle-target--hidden");
          if (!willOpen) return;
          group.querySelectorAll("toggle-target").forEach((otherToggler) => {
            if (otherToggler === toggler) return;
            closeToggleTarget(otherToggler);
          });
        },
        true
      );
    });
  }
  function initProductDetailsAccordion() {
    initProductDetailsAccordions();
  }
  function observeProductDetailsAccordions() {
    if (!window.MutationObserver) return;
    const observer = new MutationObserver(() => {
      initProductDetailsAccordions();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // src/js/hygge-size-select.js
  function initHyggeSizeSelects(root = document) {
    root.querySelectorAll("[data-hygge-size-select]").forEach((select) => {
      if (select.dataset.hyggeSizeSelectInit === "true") return;
      select.dataset.hyggeSizeSelectInit = "true";
      select.addEventListener("change", () => {
        const { value } = select;
        if (!value) return;
        const selectedUrl = new URL(value, window.location.origin);
        if (selectedUrl.pathname === window.location.pathname) return;
        window.location.assign(value);
      });
    });
  }
  function observeHyggeSizeSelects() {
    if (!("MutationObserver" in window)) return;
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches("[data-hygge-size-select]")) {
            initHyggeSizeSelects(node.parentElement || document);
          } else {
            initHyggeSizeSelects(node);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // src/js/hygge-delivery-stock.js
  function updateDeliveryStockBlock(block, variant) {
    const inStock = Boolean(variant?.available);
    const delivery = block.querySelector("[data-hygge-delivery-stock-delivery]");
    const stock = block.querySelector("[data-hygge-delivery-stock-stock]");
    const stockText = block.querySelector("[data-hygge-delivery-stock-stock-text]");
    const stockIcon = block.querySelector("[data-hygge-delivery-stock-stock-icon]");
    const stockDot = block.querySelector("[data-hygge-delivery-stock-stock-dot]");
    if (delivery) {
      delivery.hidden = !inStock;
    }
    if (stock) {
      stock.classList.toggle("hygge-product-page__delivery-stock-item--out", !inStock);
    }
    if (stockText) {
      stockText.textContent = inStock ? stockText.dataset.inStockText || "" : stockText.dataset.outOfStockText || "";
    }
    if (stockIcon) {
      stockIcon.hidden = !inStock;
    }
    if (stockDot) {
      stockDot.hidden = inStock;
    }
  }
  function updateDeliveryStock(root, variant) {
    root.querySelectorAll("[data-hygge-delivery-stock]").forEach((block) => {
      updateDeliveryStockBlock(block, variant);
    });
  }
  function initHyggeDeliveryStock() {
    document.addEventListener("on:variant:change", (event2) => {
      const productRoot = event2.target?.closest?.(".js-product") || event2.detail?.form?.closest?.(".js-product");
      if (!productRoot) return;
      updateDeliveryStock(productRoot, event2.detail?.variant || null);
    });
  }

  // src/js/hygge-simple-bundles-ui.js
  var HyggeSelectChevronSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none" aria-hidden="true"><path d="M20 1.77502L10 11.775L-4.37114e-07 1.77502L1.775 2.37643e-05L10 8.22502L18.225 2.30452e-05L20 1.77502Z" fill="currentColor"/></svg>';
  var imageCache = /* @__PURE__ */ new Map();
  function squareProductImageUrl(url, size = 400) {
    if (!url) return url;
    try {
      const parsed = new URL(url, window.location.origin);
      parsed.searchParams.set("width", String(size));
      parsed.searchParams.set("height", String(size));
      parsed.searchParams.set("crop", "center");
      return parsed.toString();
    } catch {
      const base = url.split("?")[0];
      return `${base}?width=${size}&height=${size}&crop=center`;
    }
  }
  function getBundleSettings() {
    const form = document.querySelector(".hygge-product-page .product-form");
    const cleanLabel = (value) => (value || "").replace(/🔥|🤝/g, "").trim();
    const text = (key, fallback) => {
      const value = form?.dataset?.[key];
      return value == null || value === "" ? fallback : value;
    };
    return {
      showPercent: form?.dataset.bundleTierPercentShow !== "false",
      tierLabel1: cleanLabel(form?.dataset.bundleTierLabel1 || "Popular!"),
      tierLabel2: cleanLabel(form?.dataset.bundleTierLabel2 || "Best Value"),
      sheetHeading: text("bundleSheetHeading", "Sheet design"),
      sheetSubtext: text("bundleSheetSubtext", "Choose your sheet design"),
      sheetNote: text("bundleSheetNote", ""),
      packHeading: text("bundlePackHeading", "Sheet pack size"),
      packSubtext: text("bundlePackSubtext", "Select the pack size for your sheet"),
      duvetHeading: text("bundleDuvetHeading", "Duvet colour"),
      duvetSubtext: text("bundleDuvetSubtext", "Choose your duvet colour"),
      duvetSizeHeading: text("bundleDuvetSizeHeading", "Duvet size"),
      duvetSizeSubtext: text("bundleDuvetSizeSubtext", "Select duvet size"),
      duvetPackHeading: text("bundleDuvetPackHeading", "Duvet pack size"),
      duvetPackSubtext: text("bundleDuvetPackSubtext", "Select the pack size for your duvet"),
      carSeatHeading: text("bundleCarSeatHeading", "Car Seat Protector design"),
      carSeatSubtext: text("bundleCarSeatSubtext", "Choose your car seat protector design"),
      carSeatPackHeading: text("bundleCarSeatPackHeading", "Car Seat Protector pack size"),
      carSeatPackSubtext: text("bundleCarSeatPackSubtext", "Select the pack size for your car seat protector"),
      nightlightHeading: text("bundleNightlightHeading", "Nightlight"),
      nightlightSubtext: text("bundleNightlightSubtext", "Choose your nightlight"),
      bookHeading: text("bundleBookHeading", "Book"),
      bookSubtext: text("bundleBookSubtext", "Keeping Bed Dry paperback"),
      bookYesLabel: text("bundleBookYesLabel", "Yes"),
      bookNoLabel: text("bundleBookNoLabel", "No")
    };
  }
  function escapeHtml(value) {
    return String(value || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }
  function buildSheetDesignHeader(settings) {
    return buildDesignPackHeader(settings, "sheet");
  }
  function buildDesignPackHeader(settings, productKind = "sheet") {
    const isCarSeat = productKind === "car-seat";
    const heading = isCarSeat ? settings.carSeatHeading : settings.sheetHeading;
    const subtext = isCarSeat ? settings.carSeatSubtext : settings.sheetSubtext;
    const note = !isCarSeat && settings.sheetNote ? `<p class="hygge-product-page__design-note">${escapeHtml(settings.sheetNote)}</p>` : "";
    return `
    <h2 class="hygge-product-page__design-heading">${escapeHtml(heading)}</h2>
    <p class="hygge-product-page__design-subtext">${escapeHtml(subtext)}</p>
    ${note}
  `;
  }
  function getSelectLabel(select, container) {
    const selectId = select.id;
    if (selectId) {
      const label = container.querySelector(`label[for="${CSS.escape(selectId)}"]`);
      if (label) return label;
    }
    const prev = select.previousElementSibling;
    return prev instanceof HTMLLabelElement ? prev : null;
  }
  function selectLooksLikeNightlight(select) {
    const values = [...select.options].map((option) => option.value).filter(Boolean);
    if (values.length < 2) return false;
    return values.every((value) => /nightlight/i.test(value));
  }
  function selectLooksLikeCarSeat(select) {
    return [...select.options].some((option) => /Car\s*&\s*Pushchair Protector|Car Seat Protector|Pushchair Protector/i.test(option.value || ""));
  }
  function selectLooksLikeDesignPack(select) {
    const values = [...select.options].map((option) => option.value).filter(Boolean);
    if (values.length < 2) return false;
    const packs = new Set(
      values.map((value) => (value.match(/ - (\d+ Pack)$/i) || [])[1]).filter(Boolean)
    );
    if (packs.size < 2) return false;
    return values.some((value) => parseDesignPackOption(value) && /Mattress Protector|Car\s*&\s*Pushchair Protector|Car Seat Protector|Pushchair Protector/i.test(value));
  }
  function getSelectKind(select, label) {
    const labelText = (label?.textContent || "").toLowerCase();
    const name = (select.name || "").toLowerCase();
    const id = (select.id || "").toLowerCase();
    if (labelText.includes("duvet") || id === "duvet" || name.includes("duvet")) return "duvet";
    if (labelText.includes("car seat") || id.includes("car-seat") || id.includes("car_seat") || name.includes("car seat") || selectLooksLikeCarSeat(select)) {
      return "car-seat";
    }
    if (labelText.includes("nightlight") || id.includes("nightlight") || name.includes("nightlight") || selectLooksLikeNightlight(select)) {
      return "nightlight";
    }
    if (labelText.includes("book") || id === "book" || name.includes("book")) return "book";
    if (labelText.includes("design") && labelText.includes("pack") || id.includes("design") && id.includes("pack") || name.includes("design") && name.includes("pack") || selectLooksLikeDesignPack(select)) {
      return "design-pack";
    }
    if (labelText.includes("bed/pack") || labelText.includes("sheet") || id.includes("sheet") || name.includes("sheet")) return "sheet";
    if (labelText.includes("design") || id === "design" || name.includes("design")) return "design";
    return "default";
  }
  function parseDesignOption(value) {
    if (!value) return null;
    const mattressMatch = value.match(/^(.+?)\s*-\s*Kids Waterproof Mattress Protector\b/i);
    if (mattressMatch) {
      return {
        value,
        design: mattressMatch[1].trim()
      };
    }
    const parts = value.split(" - ");
    if (parts.length < 2) return null;
    return {
      value,
      design: parts[0].trim()
    };
  }
  function parseNightlightOption(value) {
    if (!value || !/nightlight/i.test(value)) return null;
    const dashMatch = value.match(/^(.+?)\s*-\s*.*nightlight.*$/i);
    if (dashMatch) {
      return {
        value,
        design: dashMatch[1].trim()
      };
    }
    const design = value.replace(/\s*animal\s+character\s+nightlight$/i, "").replace(/\s*character\s+nightlight$/i, "").replace(/\s*nightlight$/i, "").trim();
    if (!design) return null;
    return {
      value,
      design
    };
  }
  function parseDesignPackOption(value) {
    if (!value) return null;
    const packMatch = value.match(/ - (\d+ Pack)$/i);
    if (!packMatch) return null;
    const pack = packMatch[1];
    const withoutPack = value.slice(0, -packMatch[0].length).trim();
    const parts = withoutPack.split(" - ").map((part) => part.trim()).filter(Boolean);
    if (parts.length < 2) return null;
    const design = parts[0];
    const productTitle = parts[1];
    const size = parts.length >= 3 ? parts.slice(2).join(" - ") : null;
    return {
      value,
      design,
      productTitle,
      size,
      pack,
      packCount: parseInt(pack, 10) || 0,
      packDisplay: pack.replace(/\s*Pack$/i, "").trim()
    };
  }
  function isNoneBundleOption(value, labelText = "") {
    const haystack = `${value || ""} ${labelText || ""}`.trim().toLowerCase();
    if (!haystack) return true;
    return /^(none|no\b|without|not included|no thanks|no thank you|no book|exclude)/i.test(haystack);
  }
  function parseSheetOption(value) {
    const packMatch = value.match(/ - (\d+ Pack)$/i);
    if (!packMatch) return null;
    const pack = packMatch[1];
    const withoutPack = value.slice(0, -packMatch[0].length);
    const sizeMatch = withoutPack.match(/ - (Single|Double|Twin|King|Super King|Queen)(?:\s*\/.*)?$/i);
    if (!sizeMatch) return null;
    const size = sizeMatch[1];
    return {
      value,
      size,
      pack,
      packCount: parseInt(pack, 10) || 0,
      packDisplay: pack.replace(/\s*Pack$/i, "").trim()
    };
  }
  function parseDuvetOption(value) {
    if (!value) return null;
    const match = value.match(/^(.+?)\s*-\s*Kids Coverless Duvet\s*-\s*(.+)$/i);
    if (!match) {
      const parts = value.split(" - ");
      if (parts.length < 2) return null;
      return {
        value,
        design: parts[0].trim(),
        size: null,
        pack: null,
        packCount: 0,
        packDisplay: ""
      };
    }
    const design = match[1].trim();
    let rest = match[2].trim();
    let pack = null;
    let packCount = 0;
    const packMatch = rest.match(/(?:\/|-)\s*(\d+)\s*Pack$/i);
    if (packMatch) {
      pack = `${packMatch[1]} Pack`;
      packCount = parseInt(packMatch[1], 10) || 0;
      rest = rest.slice(0, -packMatch[0].length).trim().replace(/[/-]\s*$/, "").trim();
    }
    const sizeMatch = rest.match(/^(Toddler|Single|Double|Twin|King|Super King|Queen)/i);
    const size = sizeMatch ? sizeMatch[1] : rest.split("/")[0].trim() || null;
    return {
      value,
      design,
      size,
      pack,
      packCount,
      packDisplay: pack ? pack.replace(/\s*Pack$/i, "").trim() : ""
    };
  }
  function hideNativeSelect(select) {
    select.classList.add("hygge-product-page__bundle-native-select");
    select.tabIndex = -1;
    select.setAttribute("aria-hidden", "true");
    select.style.display = "none";
  }
  function getOptionEntries(select) {
    return [...select.options].filter((option) => option.value && !option.disabled);
  }
  function syncSelectValue(select, value) {
    if (!value || select.value === value) return;
    select.value = value;
    select.dispatchEvent(new Event("change", { bubbles: true }));
  }
  function calcPercentSaved(baselinePrice, packPrice, packCount) {
    if (!baselinePrice || !packPrice || packCount <= 1) return 0;
    const baselineTotal = baselinePrice * packCount;
    const percent = Math.round((1 - packPrice / baselineTotal) * 100);
    return percent > 0 ? percent : 0;
  }
  function ensureOptionGroup(select, modifierClass) {
    let group = select.closest(".hygge-product-page__bundle-option");
    if (!group) {
      group = document.createElement("div");
      group.className = `hygge-product-page__bundle-option ${modifierClass}`;
      select.before(group);
      group.append(select);
    }
    group.classList.add(modifierClass);
    const sizeWrapper = select.closest(".hygge-size-select");
    if (sizeWrapper) {
      sizeWrapper.before(select);
      sizeWrapper.remove();
    }
    hideNativeSelect(select);
    group.append(select);
    return group;
  }
  function buildSizeDropdown({
    sizes,
    selectedSize,
    heading,
    subtext,
    placeholder,
    dataAttr,
    onChange
  }) {
    const wrapper = document.createElement("div");
    wrapper.className = "hygge-product-page__bundle-size";
    wrapper.innerHTML = `
    <div class="hygge-pack-size__header">
      <p class="hygge-pack-size__heading">${heading}</p>
      <p class="hygge-pack-size__subtext">${subtext}</p>
    </div>
  `;
    const selectWrap = document.createElement("div");
    selectWrap.className = "hygge-size-select";
    const select = document.createElement("select");
    select.className = "hygge-size-select__field";
    select.setAttribute(dataAttr, "true");
    const placeholderOption = document.createElement("option");
    placeholderOption.value = "";
    placeholderOption.textContent = placeholder;
    placeholderOption.disabled = true;
    if (!selectedSize) placeholderOption.selected = true;
    select.append(placeholderOption);
    sizes.forEach((size) => {
      const option = document.createElement("option");
      option.value = size;
      option.textContent = size;
      if (size === selectedSize) option.selected = true;
      select.append(option);
    });
    const chevron = document.createElement("span");
    chevron.className = "hygge-size-select__chevron";
    chevron.setAttribute("aria-hidden", "true");
    chevron.innerHTML = HyggeSelectChevronSvg;
    select.addEventListener("change", () => onChange(select.value));
    selectWrap.append(select, chevron);
    wrapper.append(selectWrap);
    return { wrapper, select };
  }
  function buildPackSizeGrid(packs, resolvePackOption, selectedPack, settings, onChange) {
    const block = document.createElement("div");
    block.className = "hygge-pack-size hygge-product-page__bundle-pack-size";
    block.dataset.selectorType = "listed";
    block.innerHTML = `
    <div class="hygge-pack-size__header">
      <p class="hygge-pack-size__heading">${escapeHtml(settings.packHeading || "Sheet pack size")}</p>
      <p class="hygge-pack-size__subtext">${escapeHtml(settings.packSubtext || "Select the pack size for your sheet")}</p>
    </div>
  `;
    const fieldset = document.createElement("fieldset");
    fieldset.className = "option-selector-fieldset hygge-pack-size__fieldset";
    const grid = document.createElement("div");
    grid.className = "hygge-pack-size__grid option-selector__btns";
    grid.dataset.variantName = "Pack Size";
    const groupName = `hygge-bundle-pack-${Math.random().toString(36).slice(2)}`;
    const baselinePrice = parseFloat(resolvePackOption("1 Pack")?.dataset.price);
    packs.forEach((pack, index) => {
      const option = resolvePackOption(pack);
      const packCount = parseInt(pack, 10) || parseInt(pack.replace(/\D/g, ""), 10) || 0;
      const packDisplay = pack.replace(/\s*Pack$/i, "").trim();
      const packPrice = parseFloat(option?.dataset.price);
      const percentSaved = settings.showPercent ? calcPercentSaved(baselinePrice, packPrice, packCount) : 0;
      let tierLabel = "";
      if (index === 2) tierLabel = settings.tierLabel1;
      if (index === 3) tierLabel = settings.tierLabel2;
      const item = document.createElement("div");
      item.className = "hygge-pack-size__item option-selector__btns__ps";
      const isChecked = pack === selectedPack;
      const isDisabled = !option;
      item.innerHTML = `
      <div class="hygge-pack-size__option option-selector__btns__ps--option">
        <input
          class="opt-btn js-option"
          type="radio"
          name="${groupName}"
          id="${groupName}-${index}"
          value="${pack}"
          ${isChecked ? "checked" : ""}
          ${isDisabled ? "disabled" : ""}
        >
        <label class="opt-label hygge-pack-size__btn" for="${groupName}-${index}">
          <span class="opt-label__text">${packDisplay}</span>
        </label>
      </div>
      ${index > 0 && percentSaved > 0 ? `<div class="hygge-pack-size__percent option-selector__btns__ps--percent">
              <span class="ps--percent--label"><strong>${percentSaved}%</strong></span>
              <span class="hygge-pack-size__percent-suffix">off</span>
            </div>` : ""}
      ${tierLabel ? `<div class="hygge-pack-size__tag option-selector__btns__ps--label has-label">${tierLabel}</div>` : ""}
    `;
      const input = item.querySelector("input");
      input.addEventListener("change", () => {
        if (input.checked) onChange(pack);
      });
      grid.append(item);
    });
    fieldset.append(grid);
    block.append(fieldset);
    return block;
  }
  function enhanceSheetSelect(select, container, label) {
    if (select.dataset.hyggeBundleUiInit === "true") return;
    const entries = getOptionEntries(select).map((option) => {
      const parsed = parseSheetOption(option.value);
      return parsed ? { option, ...parsed } : null;
    }).filter(Boolean);
    if (!entries.length) return;
    select.dataset.hyggeBundleUiInit = "true";
    if (label) label.remove();
    const sheetGroup = ensureOptionGroup(select, "hygge-product-page__bundle-option--sheet");
    const settings = getBundleSettings();
    const optionMap = new Map(
      entries.map((entry) => [`${entry.size}|${entry.pack}`, entry.option])
    );
    const sizes = [...new Set(entries.map((entry) => entry.size))];
    const packs = [...new Set(entries.map((entry) => entry.pack))].sort(
      (a, b) => (parseInt(a, 10) || 0) - (parseInt(b, 10) || 0)
    );
    const current = parseSheetOption(select.value);
    let selectedSize = current?.size || entries[0].size;
    let selectedPack = current?.pack || entries[0].pack;
    if (!select.value && entries[0]?.option) {
      syncSelectValue(select, entries[0].option.value);
      selectedSize = entries[0].size;
      selectedPack = entries[0].pack;
    }
    const ui = document.createElement("div");
    ui.className = "hygge-product-page__bundle-sheet-ui";
    sheetGroup.prepend(ui);
    const render = () => {
      ui.replaceChildren();
      const syncFromSelection = () => {
        const option = optionMap.get(`${selectedSize}|${selectedPack}`) || entries.find((entry) => entry.size === selectedSize)?.option || entries[0]?.option;
        if (!option) return;
        selectedPack = parseSheetOption(option.value)?.pack || selectedPack;
        syncSelectValue(select, option.value);
      };
      if (sizes.length > 1) {
        const { wrapper: sizeUi, select: sizeSelect } = buildSizeDropdown({
          sizes,
          selectedSize,
          heading: "Sheet size",
          subtext: "Select bed size",
          placeholder: "Please select a size",
          dataAttr: "data-hygge-bundle-sheet-size",
          onChange: (size) => {
            selectedSize = size;
            const packsForSize = packs.filter((pack) => optionMap.has(`${size}|${pack}`));
            if (!packsForSize.includes(selectedPack)) {
              selectedPack = packsForSize[0];
            }
            render();
            syncFromSelection();
          }
        });
        ui.append(sizeUi);
        sizeSelect.value = selectedSize;
      }
      const packUi = buildPackSizeGrid(
        packs,
        (pack) => optionMap.get(`${selectedSize}|${pack}`),
        selectedPack,
        settings,
        (pack) => {
          selectedPack = pack;
          syncFromSelection();
        }
      );
      ui.append(packUi);
    };
    render();
  }
  function getProductMediaCatalog() {
    const script = document.querySelector("[data-hygge-product-media]");
    if (!script) return [];
    try {
      const parsed = JSON.parse(script.textContent || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  function normalizeDesignKey(value) {
    return (value || "").toLowerCase().replace(/\(.*?\)/g, " ").replace(/[^a-z0-9]+/g, " ").trim().replace(/\s+/g, " ");
  }
  function formatDesignLabel(design) {
    return (design || "").replace(/\s*\(.*?\)\s*/g, " ").replace(/\s+/g, " ").trim();
  }
  function formatDuvetLabel(design) {
    let label = formatDesignLabel(design).replace(/^reversible\s+/i, "").replace(/^pastel\s+/i, "").replace(/\s+duvet$/i, "").trim();
    if (!label) return formatDesignLabel(design);
    const colour = label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();
    return `${colour} duvet`;
  }
  function formatSwatchLabel(design, kind = "sheet") {
    return kind === "duvet" ? formatDuvetLabel(design) : formatDesignLabel(design);
  }
  function findProductMediaForDesign(design, catalog = getProductMediaCatalog(), kind = "sheet") {
    if (!design || !catalog.length) return null;
    const key = normalizeDesignKey(design);
    if (!key) return null;
    const keyCompact = key.replace(/\s+/g, "");
    let best = null;
    let bestScore = 0;
    catalog.forEach((item, index) => {
      const alt = item.alt || "";
      const fileName = (item.src || item.thumb || "").split("/").pop()?.split("?")[0] || "";
      const haystack = `${alt} ${fileName}`;
      const isDuvetMedia = /duvet|coverless/i.test(haystack);
      const isSheetMedia = /mattress|protector|sheet/i.test(haystack) && !/car|pushchair/i.test(haystack);
      const isCarSeatMedia = /car|pushchair/i.test(haystack);
      const isNightlightMedia = /nightlight|night\s*light|bobo|cleo|dino|unicorn|football|cloud/i.test(haystack);
      const isBookMedia = /book|keeping\s*bed\s*dry|paperback|story/i.test(haystack);
      if (kind === "duvet" && isSheetMedia && !isDuvetMedia) return;
      if (kind === "sheet" && isDuvetMedia && !isSheetMedia) return;
      if (kind === "sheet" && isCarSeatMedia && !isSheetMedia) return;
      if (kind === "car-seat" && (isDuvetMedia || isSheetMedia && !isCarSeatMedia)) return;
      if (kind === "nightlight" && (isDuvetMedia || isSheetMedia || isCarSeatMedia) && !isNightlightMedia) return;
      if (kind === "book" && (isDuvetMedia || isSheetMedia || isCarSeatMedia || isNightlightMedia) && !isBookMedia) return;
      const altKey = normalizeDesignKey(alt);
      const srcKey = normalizeDesignKey(fileName.replace(/\.[a-z0-9]+$/i, ""));
      const srcCompact = srcKey.replace(/\s+/g, "");
      let score = 0;
      if (altKey === key) score = 100;
      else if (altKey.includes(key) && key.length >= 3) score = 80;
      else if (key.includes(altKey) && altKey.length >= 3) score = 70;
      else if (srcCompact.includes(keyCompact) || keyCompact.includes(srcCompact)) score = 45;
      if (kind === "duvet" && isDuvetMedia) score += 15;
      if (kind === "sheet" && isSheetMedia) score += 15;
      if (kind === "car-seat" && isCarSeatMedia) score += 15;
      if (kind === "nightlight" && isNightlightMedia) score += 15;
      if (kind === "book" && isBookMedia) score += 15;
      if (index === 0 && score < 70) return;
      if (score > bestScore) {
        bestScore = score;
        best = item;
      }
    });
    return bestScore >= 45 ? best : null;
  }
  var GALLERY_SLOT_IDS = {
    sheet: "hygge-slot-sheet",
    duvet: "hygge-slot-duvet",
    "car-seat": "hygge-slot-car-seat",
    nightlight: "hygge-slot-nightlight",
    book: "hygge-slot-book"
  };
  function setActiveGalleryMedia(mediaId) {
    if (!mediaId) return;
    const gallery = getProductGallery();
    if (!gallery) return;
    const id = String(mediaId);
    const mainSlide = gallery.querySelector(`.main-image .slider__item[data-media-id="${CSS.escape(id)}"]`);
    if (!mainSlide) return;
    gallery.querySelectorAll(".main-image .slider__item, .thumbnails .slider__item").forEach((item) => {
      const isMatch = item.dataset.mediaId === id;
      item.classList.toggle("is-active", isMatch);
      if (item.closest(".main-image")) {
        if (isMatch) {
          item.removeAttribute("tabindex");
        } else {
          item.tabIndex = -1;
        }
      }
    });
    const mainSlider = gallery.querySelector(".hygge-product-gallery__main .slider");
    if (mainSlider) {
      try {
        mainSlider.scrollTo({ left: mainSlide.offsetLeft, behavior: "auto" });
      } catch {
        mainSlider.scrollLeft = mainSlide.offsetLeft;
      }
    }
    const thumbsRoot = gallery.querySelector("[data-hygge-product-gallery-thumbs]");
    if (thumbsRoot?.swiper) {
      const activeThumb = thumbsRoot.querySelector(`.slider__item[data-media-id="${CSS.escape(id)}"]`);
      const slides = activeThumb ? [...activeThumb.parentElement.children] : [];
      const index = slides.indexOf(activeThumb);
      if (index >= 0) {
        thumbsRoot.swiper.slideTo(index);
      }
    }
    refreshGalleryMediaLists(gallery);
    document.dispatchEvent(new CustomEvent("on:media-gallery:change", { bubbles: true, cancelable: false }));
  }
  function getProductGallery() {
    return document.querySelector("media-gallery.hygge-product-page__gallery") || document.querySelector(".hygge-product-page media-gallery");
  }
  function escapeAttr(value) {
    return String(value).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");
  }
  function refreshGalleryMediaLists(gallery) {
    if (!gallery) return;
    gallery.mediaLists = [
      gallery.querySelectorAll(".main-image .slider__item"),
      gallery.querySelectorAll(".product-media-collage__item"),
      gallery.querySelectorAll(".thumbnails .slider__item")
    ];
    if (gallery.galleryModal) {
      gallery.mediaLists.push(gallery.galleryModal.querySelectorAll(".gallery-viewer__thumb"));
    }
  }
  function createGalleryThumbItem(mediaId, imageUrl, isActive = false) {
    const li = document.createElement("li");
    li.className = `slider__item swiper-slide${isActive ? " is-active" : ""}`;
    li.dataset.mediaId = String(mediaId);
    if (imageUrl) {
      const thumbUrl = squareProductImageUrl(imageUrl, 162);
      li.innerHTML = `
      <a class="thumbnail thumbnail--media-image" href="#">
        <div class="img-ar img-ar--cover" style="--aspect-ratio: 1">
          <img src="${escapeAttr(thumbUrl)}" alt="" class="theme-img" loading="lazy" width="81" height="81">
        </div>
      </a>
    `;
    } else {
      li.classList.add("hygge-gallery-slot--empty");
      li.innerHTML = `
      <a class="thumbnail thumbnail--media-image" href="#">
        <div class="img-ar img-ar--cover hygge-gallery-slot__placeholder" style="--aspect-ratio: 1"></div>
      </a>
    `;
    }
    return li;
  }
  function createGalleryMainSlide(mediaId, imageUrl, label, index, total, zoomEnabled) {
    const slide2 = document.createElement("div");
    slide2.className = "slider__item";
    slide2.dataset.mediaId = String(mediaId);
    slide2.setAttribute("role", "group");
    slide2.setAttribute("aria-roledescription", "slide");
    slide2.setAttribute("aria-label", `${index} of ${total}`);
    slide2.tabIndex = -1;
    if (!imageUrl) {
      slide2.classList.add("hygge-gallery-slot--empty");
      slide2.innerHTML = `
      <div class="product-media-wrapper" data-media-id="${escapeAttr(String(mediaId))}" tabindex="-1">
        <div class="product-media product-media--image">
          <div class="img-ar hygge-gallery-slot__placeholder"></div>
        </div>
      </div>
    `;
      return slide2;
    }
    const largeUrl = squareProductImageUrl(imageUrl, 1080);
    const mediaHtml = `
    <div class="product-media-wrapper" data-media-id="${escapeAttr(String(mediaId))}" tabindex="-1">
      <div class="product-media product-media--image">
        <div class="img-ar">
          <img src="${escapeAttr(largeUrl)}" alt="${escapeAttr(label)}" class="theme-img" loading="lazy" width="1080" height="1080">
        </div>
      </div>
    </div>
  `;
    if (zoomEnabled) {
      slide2.innerHTML = `
      <a class="block show-gallery hygge-product-gallery__zoom-link" href="${escapeAttr(largeUrl)}" aria-label="${escapeAttr(label)}">
        ${mediaHtml}
      </a>
    `;
    } else {
      slide2.innerHTML = mediaHtml;
    }
    return slide2;
  }
  function ensureGalleryThumbs(gallery) {
    let thumbs = gallery.querySelector("[data-hygge-product-gallery-thumbs]");
    if (thumbs) return thumbs;
    const grid = gallery.querySelector(".hygge-product-gallery__grid");
    const main = gallery.querySelector(".hygge-product-gallery__main");
    if (!grid || !main) return null;
    thumbs = document.createElement("div");
    thumbs.className = "thumbnails hygge-product-gallery__thumbs";
    thumbs.setAttribute("data-hygge-product-gallery-thumbs", "");
    thumbs.innerHTML = `
    <div class="swiper hygge-product-gallery__thumbs-swiper">
      <ul class="slider__grid swiper-wrapper"></ul>
    </div>
  `;
    grid.insertBefore(thumbs, main);
    grid.classList.remove("hygge-product-gallery__grid--single");
    gallery.classList.add("has-thumbnails");
    const thumbList = thumbs.querySelector(".slider__grid");
    gallery.querySelectorAll(".hygge-product-gallery__main .slider__item").forEach((slide2) => {
      const mediaId = slide2.dataset.mediaId;
      const img = slide2.querySelector("img");
      const src = img?.currentSrc || img?.src;
      if (!mediaId || !src) return;
      thumbList.append(createGalleryThumbItem(mediaId, src, slide2.classList.contains("is-active")));
    });
    return thumbs;
  }
  function galleryHasMedia(gallery, mediaId) {
    if (!mediaId) return false;
    return Boolean(gallery.querySelector(`.main-image [data-media-id="${CSS.escape(String(mediaId))}"]`));
  }
  function bindDesignGalleryThumbClicks(gallery) {
    if (!gallery || gallery.dataset.hyggeDesignThumbBound === "true") return;
    gallery.dataset.hyggeDesignThumbBound = "true";
    gallery.addEventListener("click", (event2) => {
      const thumb = event2.target.closest(".hygge-product-gallery__thumbs .thumbnail");
      if (!thumb) return;
      const item = thumb.closest(".slider__item");
      const mediaId = item?.dataset.mediaId;
      if (!mediaId) return;
      event2.preventDefault();
      event2.stopPropagation();
      setActiveGalleryMedia(mediaId);
    }, true);
  }
  function ensureOptionGallerySlots(kinds = null) {
    const gallery = getProductGallery();
    if (!gallery) return null;
    const thumbs = ensureGalleryThumbs(gallery);
    const mainGrid = gallery.querySelector(".hygge-product-gallery__main .slider__grid");
    const thumbList = thumbs?.querySelector(".slider__grid");
    if (!mainGrid || !thumbList) return null;
    const zoomEnabled = gallery.hasAttribute("data-zoom-enabled");
    let didInject = false;
    const kindsToEnsure = Array.isArray(kinds) ? kinds : [];
    kindsToEnsure.forEach((kind) => {
      const mediaId = GALLERY_SLOT_IDS[kind];
      if (!mediaId || galleryHasMedia(gallery, mediaId)) return;
      const label = kind === "duvet" ? "Duvet colour" : kind === "car-seat" ? "Car Seat Protector" : kind === "nightlight" ? "Nightlight" : kind === "book" ? "Book" : "Sheet design";
      const nextIndex = mainGrid.children.length + 1;
      mainGrid.append(
        createGalleryMainSlide(mediaId, null, label, nextIndex, nextIndex, zoomEnabled)
      );
      thumbList.append(createGalleryThumbItem(mediaId, null, false));
      didInject = true;
    });
    const slides = [...mainGrid.querySelectorAll(".slider__item")];
    slides.forEach((slide2, index) => {
      slide2.setAttribute("aria-label", `${index + 1} of ${slides.length}`);
    });
    refreshGalleryMediaLists(gallery);
    bindDesignGalleryThumbClicks(gallery);
    if (didInject || !thumbs.swiper) {
      initProductGallerySwipers(gallery);
    }
    return gallery;
  }
  function pruneUnusedBundleGallerySlots(activeKinds = []) {
    const gallery = getProductGallery();
    if (!gallery) return;
    let removed = false;
    Object.entries(GALLERY_SLOT_IDS).forEach(([kind, mediaId]) => {
      if (activeKinds.includes(kind)) return;
      const mainSlide = gallery.querySelector(`.main-image .slider__item[data-media-id="${CSS.escape(mediaId)}"]`);
      const thumb = gallery.querySelector(`.thumbnails .slider__item[data-media-id="${CSS.escape(mediaId)}"]`);
      if (!mainSlide && !thumb) return;
      mainSlide?.remove();
      thumb?.remove();
      removed = true;
    });
    if (!removed) return;
    const mainGrid = gallery.querySelector(".hygge-product-gallery__main .slider__grid");
    const slides = [...mainGrid?.querySelectorAll(".slider__item") || []];
    slides.forEach((slide2, index) => {
      slide2.setAttribute("aria-label", `${index + 1} of ${slides.length}`);
    });
    refreshGalleryMediaLists(gallery);
    initProductGallerySwipers(gallery);
  }
  function updateSlotSlideImage(slide2, imageUrl, label, zoomEnabled) {
    if (!slide2 || !imageUrl) return;
    const largeUrl = squareProductImageUrl(imageUrl, 1080);
    slide2.classList.remove("hygge-gallery-slot--empty");
    const mediaHtml = `
    <div class="product-media-wrapper" data-media-id="${escapeAttr(slide2.dataset.mediaId)}" tabindex="-1">
      <div class="product-media product-media--image">
        <div class="img-ar">
          <img src="${escapeAttr(largeUrl)}" alt="${escapeAttr(label)}" class="theme-img" loading="lazy" width="1080" height="1080">
        </div>
      </div>
    </div>
  `;
    if (zoomEnabled) {
      slide2.innerHTML = `
      <a class="block show-gallery hygge-product-gallery__zoom-link" href="${escapeAttr(largeUrl)}" aria-label="${escapeAttr(label)}">
        ${mediaHtml}
      </a>
    `;
    } else {
      slide2.innerHTML = mediaHtml;
    }
  }
  function updateSlotThumbImage(thumb, imageUrl) {
    if (!thumb || !imageUrl) return;
    thumb.classList.remove("hygge-gallery-slot--empty");
    const thumbUrl = squareProductImageUrl(imageUrl, 162);
    thumb.innerHTML = `
    <a class="thumbnail thumbnail--media-image" href="#">
      <div class="img-ar img-ar--cover" style="--aspect-ratio: 1">
        <img src="${escapeAttr(thumbUrl)}" alt="" class="theme-img" loading="lazy" width="81" height="81">
      </div>
    </a>
  `;
  }
  async function setGalleryOptionImage(kind, { design, optionValue, activate = true } = {}) {
    const mediaId = GALLERY_SLOT_IDS[kind];
    if (!mediaId || !design) return;
    const gallery = ensureOptionGallerySlots([kind]);
    if (!gallery) return;
    const imageUrl = await fetchComponentImage(design, optionValue, kind, 1080);
    if (!imageUrl) return;
    const zoomEnabled = gallery.hasAttribute("data-zoom-enabled");
    const label = formatDesignLabel(design);
    const mainSlide = gallery.querySelector(`.main-image .slider__item[data-media-id="${CSS.escape(mediaId)}"]`);
    const thumb = gallery.querySelector(`.thumbnails .slider__item[data-media-id="${CSS.escape(mediaId)}"]`);
    updateSlotSlideImage(mainSlide, imageUrl, label, zoomEnabled);
    updateSlotThumbImage(thumb, imageUrl);
    if (activate) {
      setActiveGalleryMedia(mediaId);
    }
  }
  function setSwatchImage(mediaEl, imageUrl) {
    if (!mediaEl || !imageUrl) return;
    mediaEl.innerHTML = `
    <div class="img-ar img-ar--cover">
      <img src="${imageUrl.replace(/"/g, "&quot;")}" alt="" class="theme-img" loading="lazy" width="400" height="400">
    </div>
  `;
  }
  async function fetchComponentImage(design, optionValue, kind = "sheet", size = 400) {
    const cacheOptionKey = kind === "sheet" ? String(optionValue || "").replace(/\s*-\s*\d+\s*Pack$/i, "") : optionValue;
    const cacheKey = `${kind}|${design}|${cacheOptionKey}|${size}`;
    if (imageCache.has(cacheKey)) return imageCache.get(cacheKey);
    const productMedia = findProductMediaForDesign(design, getProductMediaCatalog(), kind);
    if (productMedia?.thumb || productMedia?.src) {
      const source = size > 400 ? productMedia.src || productMedia.thumb : productMedia.thumb || productMedia.src;
      const squareUrl = squareProductImageUrl(source, size);
      imageCache.set(cacheKey, squareUrl);
      return squareUrl;
    }
    const cleanDesign = formatDesignLabel(design);
    const sheetSizeMatch = String(optionValue || "").match(
      /\b(Single|Double|Twin|King|Super King|Queen|Toddler)\b/i
    );
    const sheetSize = sheetSizeMatch?.[1] || "Single";
    const queries = kind === "duvet" ? [
      optionValue,
      `${cleanDesign} Kids Coverless Duvet`,
      `${design} Kids Coverless Duvet`,
      `${cleanDesign} Coverless Duvet`,
      cleanDesign
    ] : kind === "car-seat" ? [
      optionValue,
      `${cleanDesign} Potty Training Car & Pushchair Protector`,
      `${design} Potty Training Car & Pushchair Protector`,
      `${cleanDesign} car seat protector`,
      `${cleanDesign} pushchair protector`,
      cleanDesign
    ] : kind === "nightlight" ? [
      optionValue,
      `${cleanDesign} Nightlight`,
      `${design} Nightlight`,
      `${cleanDesign} Character Nightlight`,
      cleanDesign
    ] : kind === "book" ? [
      optionValue,
      `${cleanDesign} Keeping Bed Dry`,
      "Keeping Bed Dry: A Story to Support Night-Time Potty Training",
      "Keeping Bed Dry paperback",
      cleanDesign
    ] : [
      `${cleanDesign} Kids Waterproof Mattress Protector - ${sheetSize}`,
      `${cleanDesign} Kids Waterproof Mattress Protector ${sheetSize}`,
      `${design} Kids Waterproof Mattress Protector - ${sheetSize}`,
      `${cleanDesign} Kids Waterproof Mattress Protector`,
      `${design} Kids Waterproof Mattress Protector`,
      cleanDesign
    ];
    for (const query of queries) {
      if (!query) continue;
      try {
        const url = new URL("/search/suggest.json", window.location.origin);
        url.searchParams.set("q", query);
        url.searchParams.set("resources[type]", "product");
        url.searchParams.set("resources[limit]", "5");
        const response = await fetch(url.toString());
        if (!response.ok) continue;
        const data = await response.json();
        const products = data?.resources?.results?.products || [];
        for (const product of products) {
          const title = product?.title || "";
          const handle = product?.handle || "";
          const haystack = `${title} ${handle}`;
          if (kind === "duvet" && !/duvet|coverless/i.test(haystack)) continue;
          if (kind === "car-seat" && !/car|pushchair/i.test(haystack)) continue;
          if (kind === "nightlight" && !/nightlight|night-light|night_light/i.test(haystack)) continue;
          if (kind === "book" && !/book|keeping.?bed.?dry|paperback|story/i.test(haystack)) continue;
          if (kind === "sheet" && /duvet|coverless/i.test(haystack) && !/mattress|protector|sheet/i.test(haystack)) {
            continue;
          }
          if (kind === "sheet" && /car|pushchair/i.test(haystack) && !/mattress/i.test(haystack)) continue;
          if (kind === "sheet" && !/mattress|protector|sheet|hygge/i.test(haystack)) continue;
          if (kind === "sheet") {
            if (/single/i.test(sheetSize) && /\bdouble\b/i.test(haystack)) continue;
            if (/double/i.test(sheetSize) && /\bsingle\b/i.test(haystack) && !/\bdouble\b/i.test(haystack)) continue;
            if (sheetSize && !new RegExp(sheetSize.replace(/\s+/g, "\\s+"), "i").test(haystack)) {
              if (/\b(Single|Double|Twin|King|Queen|Toddler)\b/i.test(haystack)) continue;
            }
          }
          const imageUrl = product?.featured_image?.url || product?.image;
          if (imageUrl) {
            const squareUrl = squareProductImageUrl(imageUrl, size);
            imageCache.set(cacheKey, squareUrl);
            return squareUrl;
          }
        }
      } catch {
      }
    }
    imageCache.set(cacheKey, null);
    return null;
  }
  function buildDesignSwatch(design, optionValue, isActive, onSelect, mediaInfo = null, kind = "sheet") {
    const button = document.createElement("button");
    button.type = "button";
    button.className = `hygge-design-swatch${isActive ? " hygge-design-swatch--active" : ""}`;
    button.dataset.bundleValue = optionValue;
    button.setAttribute("aria-pressed", isActive ? "true" : "false");
    const displayLabel = formatSwatchLabel(design, kind);
    button.title = displayLabel;
    if (mediaInfo?.id) {
      button.dataset.mediaId = String(mediaInfo.id);
    }
    const media = document.createElement("span");
    media.className = "hygge-design-swatch__media";
    const placeholder = document.createElement("span");
    placeholder.className = "hygge-design-swatch__media-placeholder";
    placeholder.dataset.designImage = "";
    media.append(placeholder);
    const label = document.createElement("span");
    label.className = "hygge-design-swatch__label";
    const labelText = document.createElement("span");
    labelText.className = "hygge-design-swatch__label-text";
    labelText.textContent = displayLabel;
    label.append(labelText);
    button.append(media, label);
    button.addEventListener("click", () => onSelect(optionValue));
    const localThumb = mediaInfo?.thumb || mediaInfo?.src;
    if (localThumb) {
      setSwatchImage(media, squareProductImageUrl(localThumb, 400));
    } else {
      fetchComponentImage(design, optionValue, kind).then((imageUrl) => {
        if (!imageUrl || !button.isConnected) return;
        setSwatchImage(button.querySelector(".hygge-design-swatch__media"), imageUrl);
      });
    }
    return button;
  }
  function enhanceDesignSelect(select, container, label) {
    if (select.dataset.hyggeBundleUiInit === "true") return;
    const entries = getOptionEntries(select).map((option) => {
      const parsed = parseDesignOption(option.value);
      return parsed ? { option, ...parsed } : null;
    }).filter(Boolean);
    if (!entries.length) return;
    select.dataset.hyggeBundleUiInit = "true";
    if (label) label.remove();
    const designGroup = ensureOptionGroup(select, "hygge-product-page__bundle-option--design");
    const mediaCatalog = getProductMediaCatalog();
    const designs = [...new Map(entries.map((entry) => [entry.design, entry])).values()].map((entry) => ({
      ...entry,
      media: findProductMediaForDesign(entry.design, mediaCatalog, "sheet")
    }));
    const current = parseDesignOption(select.value);
    let selectedDesign = current?.design || designs[0]?.design;
    const resolveOption = () => designs.find((entry) => entry.design === selectedDesign)?.option || entries[0]?.option;
    const initialOption = resolveOption();
    if (initialOption && select.value !== initialOption.value) {
      syncSelectValue(select, initialOption.value);
    }
    const ui = document.createElement("div");
    ui.className = "hygge-product-page__bundle-design-ui";
    designGroup.prepend(ui);
    const showSheetImage = (entry, activate = true) => {
      if (!entry) return;
      setGalleryOptionImage("sheet", {
        design: entry.design,
        optionValue: entry.option?.value,
        activate
      });
    };
    const activateDesign = (entry) => {
      selectedDesign = entry.design;
      const option = resolveOption();
      if (option) syncSelectValue(select, option.value);
      showSheetImage(entry, true);
      render();
    };
    const render = () => {
      ui.replaceChildren();
      const colourBlock = document.createElement("div");
      colourBlock.className = "hygge-product-page__design hygge-product-page__bundle-design";
      colourBlock.innerHTML = buildSheetDesignHeader(getBundleSettings());
      const grid = document.createElement("div");
      grid.className = "hygge-product-page__design-grid";
      grid.setAttribute("role", "listbox");
      grid.setAttribute("aria-label", "Sheet design");
      designs.forEach((entry) => {
        const swatch = buildDesignSwatch(
          entry.design,
          entry.option.value,
          entry.design === selectedDesign,
          () => activateDesign(entry),
          entry.media,
          "sheet"
        );
        grid.append(swatch);
      });
      colourBlock.append(grid);
      ui.append(colourBlock);
    };
    render();
    const selectedEntry = designs.find((entry) => entry.design === selectedDesign) || designs[0];
    showSheetImage(selectedEntry, false);
  }
  function enhanceNightlightSelect(select, container, label) {
    if (select.dataset.hyggeBundleUiInit === "true") return;
    const entries = getOptionEntries(select).map((option) => {
      const parsed = parseNightlightOption(option.value);
      return parsed ? { option, ...parsed } : null;
    }).filter(Boolean);
    if (!entries.length) return;
    select.dataset.hyggeBundleUiInit = "true";
    if (label) label.remove();
    const group = ensureOptionGroup(select, "hygge-product-page__bundle-option--nightlight");
    const settings = getBundleSettings();
    const mediaCatalog = getProductMediaCatalog();
    const designs = [...new Map(entries.map((entry) => [entry.design, entry])).values()].map((entry) => ({
      ...entry,
      media: findProductMediaForDesign(entry.design, mediaCatalog, "nightlight")
    }));
    const current = parseNightlightOption(select.value);
    let selectedDesign = current?.design || designs[0]?.design;
    const resolveOption = () => designs.find((entry) => entry.design === selectedDesign)?.option || entries[0]?.option;
    const initialOption = resolveOption();
    if (initialOption && select.value !== initialOption.value) {
      syncSelectValue(select, initialOption.value);
    }
    const ui = document.createElement("div");
    ui.className = "hygge-product-page__bundle-nightlight-ui";
    group.prepend(ui);
    const showNightlightImage = (entry, activate = true) => {
      if (!entry) return;
      setGalleryOptionImage("nightlight", {
        design: entry.design,
        optionValue: entry.option?.value,
        activate
      });
    };
    const activateDesign = (entry) => {
      selectedDesign = entry.design;
      const option = resolveOption();
      if (option) syncSelectValue(select, option.value);
      showNightlightImage(entry, true);
      render();
    };
    const render = () => {
      ui.replaceChildren();
      const colourBlock = document.createElement("div");
      colourBlock.className = "hygge-product-page__design hygge-product-page__bundle-design hygge-product-page__bundle-nightlight";
      colourBlock.innerHTML = `
      <h2 class="hygge-product-page__design-heading">${escapeHtml(settings.nightlightHeading)}</h2>
      <p class="hygge-product-page__design-subtext">${escapeHtml(settings.nightlightSubtext)}</p>
    `;
      const grid = document.createElement("div");
      grid.className = "hygge-product-page__design-grid";
      grid.setAttribute("role", "listbox");
      grid.setAttribute("aria-label", settings.nightlightHeading);
      designs.forEach((entry) => {
        const swatch = buildDesignSwatch(
          entry.design,
          entry.option.value,
          entry.design === selectedDesign,
          () => activateDesign(entry),
          entry.media,
          "nightlight"
        );
        grid.append(swatch);
      });
      colourBlock.append(grid);
      ui.append(colourBlock);
    };
    render();
    const selectedEntry = designs.find((entry) => entry.design === selectedDesign) || designs[0];
    showNightlightImage(selectedEntry, false);
  }
  function enhanceDesignPackSelect(select, container, label, productKind = "sheet") {
    if (select.dataset.hyggeBundleUiInit === "true") return;
    const entries = getOptionEntries(select).map((option) => {
      const parsed = parseDesignPackOption(option.value);
      return parsed ? { option, ...parsed } : null;
    }).filter(Boolean);
    if (!entries.length) return;
    select.dataset.hyggeBundleUiInit = "true";
    if (label) label.remove();
    const isCarSeat = productKind === "car-seat";
    const groupModifier = isCarSeat ? "hygge-product-page__bundle-option--car-seat" : "hygge-product-page__bundle-option--design-pack";
    const group = ensureOptionGroup(select, groupModifier);
    const settings = getBundleSettings();
    const mediaCatalog = getProductMediaCatalog();
    const packSettings = {
      ...settings,
      packHeading: isCarSeat ? settings.carSeatPackHeading : settings.packHeading,
      packSubtext: isCarSeat ? settings.carSeatPackSubtext : settings.packSubtext
    };
    const optionMap = new Map(
      entries.map((entry) => [`${entry.design}|${entry.pack}`, entry.option])
    );
    const packs = [...new Set(entries.map((entry) => entry.pack))].sort(
      (a, b) => (parseInt(a, 10) || 0) - (parseInt(b, 10) || 0)
    );
    const designs = [...new Map(
      entries.slice().sort((a, b) => (a.packCount || 0) - (b.packCount || 0)).map((entry) => [entry.design, entry])
    ).values()].map((entry) => ({
      ...entry,
      media: findProductMediaForDesign(entry.design, mediaCatalog, productKind)
    }));
    const current = parseDesignPackOption(select.value);
    let selectedDesign = current?.design || designs[0]?.design;
    let selectedPack = current?.pack || packs[0];
    const resolveOption = () => optionMap.get(`${selectedDesign}|${selectedPack}`) || entries.find((entry) => entry.design === selectedDesign)?.option || entries[0]?.option;
    const initialOption = resolveOption();
    if (initialOption && select.value !== initialOption.value) {
      syncSelectValue(select, initialOption.value);
      const parsed = parseDesignPackOption(initialOption.value);
      if (parsed?.pack) selectedPack = parsed.pack;
    }
    const ui = document.createElement("div");
    ui.className = isCarSeat ? "hygge-product-page__bundle-design-pack-ui hygge-product-page__bundle-design-pack-ui--car-seat" : "hygge-product-page__bundle-design-pack-ui";
    group.prepend(ui);
    const syncFromSelection = () => {
      const option = resolveOption();
      if (!option) return;
      const parsed = parseDesignPackOption(option.value);
      if (parsed?.pack) selectedPack = parsed.pack;
      if (parsed?.design) selectedDesign = parsed.design;
      syncSelectValue(select, option.value);
    };
    const showProductImage = (entry, activate = true) => {
      if (!entry) return;
      const option = optionMap.get(`${entry.design}|1 Pack`) || optionMap.get(`${entry.design}|${selectedPack}`) || entry.option;
      setGalleryOptionImage(productKind, {
        design: entry.design,
        optionValue: option?.value,
        activate
      });
    };
    const activateDesign = (entry) => {
      selectedDesign = entry.design;
      const packsForDesign = packs.filter((pack) => optionMap.has(`${entry.design}|${pack}`));
      if (!packsForDesign.includes(selectedPack)) {
        selectedPack = packsForDesign[0] || selectedPack;
      }
      syncFromSelection();
      showProductImage(entry, true);
      render();
    };
    const render = () => {
      ui.replaceChildren();
      const colourBlock = document.createElement("div");
      colourBlock.className = isCarSeat ? "hygge-product-page__design hygge-product-page__bundle-design hygge-product-page__bundle-car-seat" : "hygge-product-page__design hygge-product-page__bundle-design";
      colourBlock.innerHTML = buildDesignPackHeader(getBundleSettings(), productKind);
      const grid = document.createElement("div");
      grid.className = "hygge-product-page__design-grid";
      grid.setAttribute("role", "listbox");
      grid.setAttribute("aria-label", isCarSeat ? "Car Seat Protector design" : "Sheet design");
      designs.forEach((entry) => {
        const sampleOption = optionMap.get(`${entry.design}|1 Pack`) || optionMap.get(`${entry.design}|${selectedPack}`) || entry.option;
        const swatch = buildDesignSwatch(
          entry.design,
          sampleOption.value,
          entry.design === selectedDesign,
          () => activateDesign(entry),
          entry.media,
          productKind
        );
        grid.append(swatch);
      });
      colourBlock.append(grid);
      ui.append(colourBlock);
      const packsForDesign = packs.filter((pack) => optionMap.has(`${selectedDesign}|${pack}`));
      const packUi = buildPackSizeGrid(
        packsForDesign.length ? packsForDesign : packs,
        (pack) => optionMap.get(`${selectedDesign}|${pack}`),
        selectedPack,
        packSettings,
        (pack) => {
          selectedPack = pack;
          syncFromSelection();
          render();
        }
      );
      if (isCarSeat) {
        packUi.classList.add("hygge-product-page__bundle-pack-size--car-seat");
      }
      ui.append(packUi);
    };
    render();
    const selectedEntry = designs.find((entry) => entry.design === selectedDesign) || designs[0];
    showProductImage(selectedEntry, false);
  }
  function enhanceBookSelect(select, container, label) {
    if (select.dataset.hyggeBundleUiInit === "true") return;
    const entries = getOptionEntries(select);
    if (!entries.length) return;
    const bookOption = entries.find((option) => !isNoneBundleOption(option.value, option.textContent)) || entries[0];
    select.dataset.hyggeBundleUiInit = "true";
    if (label) label.remove();
    const group = ensureOptionGroup(select, "hygge-product-page__bundle-option--book");
    if (bookOption && select.value !== bookOption.value) {
      syncSelectValue(select, bookOption.value);
    }
    group.hidden = true;
    group.setAttribute("aria-hidden", "true");
    group.style.display = "none";
    if (bookOption?.value) {
      const design = bookOption.value.replace(/\s*\(paperback\)\s*$/i, "").replace(/\s*:\s*.*$/, "").trim() || "Keeping Bed Dry";
      setGalleryOptionImage("book", {
        design,
        optionValue: bookOption.value,
        activate: false
      });
    }
  }
  function enhanceDuvetSelect(select, container, label) {
    if (select.dataset.hyggeBundleUiInit === "true") return;
    const entries = getOptionEntries(select).map((option) => {
      const parsed = parseDuvetOption(option.value);
      return parsed ? { option, ...parsed } : null;
    }).filter(Boolean);
    if (!entries.length) return;
    select.dataset.hyggeBundleUiInit = "true";
    if (label) label.remove();
    const duvetGroup = ensureOptionGroup(select, "hygge-product-page__bundle-option--duvet");
    const mediaCatalog = getProductMediaCatalog();
    const settings = getBundleSettings();
    const designs = [...new Map(entries.map((entry) => [entry.design, entry])).values()].map((entry) => ({
      ...entry,
      media: findProductMediaForDesign(entry.design, mediaCatalog, "duvet")
    }));
    const sizes = [...new Set(entries.map((entry) => entry.size).filter(Boolean))];
    const packs = [...new Set(entries.map((entry) => entry.pack).filter(Boolean))].sort(
      (a, b) => (parseInt(a, 10) || 0) - (parseInt(b, 10) || 0)
    );
    const optionMap = new Map(
      entries.map((entry) => [`${entry.design}|${entry.size || ""}|${entry.pack || ""}`, entry.option])
    );
    const current = parseDuvetOption(select.value);
    let selectedDesign = current?.design || designs[0]?.design;
    let selectedSize = current?.size || sizes[0] || null;
    let selectedPack = current?.pack || packs[0] || null;
    const resolveOption = () => {
      if (selectedSize && selectedPack) {
        const exact = optionMap.get(`${selectedDesign}|${selectedSize}|${selectedPack}`);
        if (exact) return exact;
      }
      if (selectedSize) {
        const sized = optionMap.get(`${selectedDesign}|${selectedSize}|`) || optionMap.get(`${selectedDesign}|${selectedSize}|${selectedPack || ""}`) || entries.find((entry) => entry.design === selectedDesign && entry.size === selectedSize && (!selectedPack || entry.pack === selectedPack))?.option || entries.find((entry) => entry.design === selectedDesign && entry.size === selectedSize)?.option;
        if (sized) return sized;
      }
      return entries.find((entry) => entry.design === selectedDesign)?.option || entries[0]?.option;
    };
    const ensureValidPackForSelection = () => {
      if (!packs.length) {
        selectedPack = null;
        return;
      }
      const packsForCombo = packs.filter((pack) => optionMap.has(`${selectedDesign}|${selectedSize}|${pack}`));
      if (!packsForCombo.includes(selectedPack)) {
        selectedPack = packsForCombo[0] || packs[0] || null;
      }
    };
    ensureValidPackForSelection();
    const initialOption = resolveOption();
    if (initialOption && select.value !== initialOption.value) {
      syncSelectValue(select, initialOption.value);
    }
    const ui = document.createElement("div");
    ui.className = "hygge-product-page__bundle-duvet-ui";
    duvetGroup.prepend(ui);
    const showDuvetImage = (designName, option, activate = true) => {
      if (!designName) return;
      setGalleryOptionImage("duvet", {
        design: designName,
        optionValue: option?.value,
        activate
      });
    };
    const render = () => {
      ui.replaceChildren();
      const syncFromSelection = () => {
        ensureValidPackForSelection();
        const option = resolveOption();
        if (!option) return;
        const parsed = parseDuvetOption(option.value);
        if (parsed?.size) selectedSize = parsed.size;
        if (parsed?.pack) selectedPack = parsed.pack;
        syncSelectValue(select, option.value);
      };
      const colourBlock = document.createElement("div");
      colourBlock.className = "hygge-product-page__design hygge-product-page__bundle-duvet";
      colourBlock.innerHTML = `
      <h2 class="hygge-product-page__design-heading">${escapeHtml(settings.duvetHeading)}</h2>
      <p class="hygge-product-page__design-subtext">${escapeHtml(settings.duvetSubtext)}</p>
    `;
      const grid = document.createElement("div");
      grid.className = "hygge-product-page__design-grid";
      grid.setAttribute("role", "listbox");
      grid.setAttribute("aria-label", "Duvet colour");
      designs.forEach((entry) => {
        const sampleOption = optionMap.get(`${entry.design}|${selectedSize || ""}|${selectedPack || ""}`) || optionMap.get(`${entry.design}|${selectedSize || ""}|1 Pack`) || optionMap.get(`${entry.design}|${selectedSize || ""}|`) || entry.option;
        const swatch = buildDesignSwatch(
          entry.design,
          sampleOption.value,
          entry.design === selectedDesign,
          () => {
            selectedDesign = entry.design;
            const sizesForDesign = sizes.filter((size) => packs.length ? packs.some((pack) => optionMap.has(`${entry.design}|${size}|${pack}`)) : optionMap.has(`${entry.design}|${size}|`));
            if (selectedSize && !sizesForDesign.includes(selectedSize)) {
              selectedSize = sizesForDesign[0] || null;
            }
            ensureValidPackForSelection();
            render();
            syncFromSelection();
            showDuvetImage(entry.design, resolveOption(), true);
          },
          entry.media,
          "duvet"
        );
        grid.append(swatch);
      });
      colourBlock.append(grid);
      ui.append(colourBlock);
      if (sizes.length > 1) {
        const sizesForDesign = sizes.filter((size) => packs.length ? packs.some((pack) => optionMap.has(`${selectedDesign}|${size}|${pack}`)) : optionMap.has(`${selectedDesign}|${size}|`) || entries.some((entry) => entry.design === selectedDesign && entry.size === size));
        const { wrapper: sizeUi, select: sizeSelect } = buildSizeDropdown({
          sizes: sizesForDesign.length ? sizesForDesign : sizes,
          selectedSize,
          heading: settings.duvetSizeHeading,
          subtext: settings.duvetSizeSubtext,
          placeholder: "Please select a size",
          dataAttr: "data-hygge-bundle-duvet-size",
          onChange: (size) => {
            selectedSize = size;
            ensureValidPackForSelection();
            syncFromSelection();
            render();
          }
        });
        sizeUi.classList.add("hygge-product-page__bundle-size--duvet");
        ui.append(sizeUi);
        sizeSelect.value = selectedSize || "";
      }
      if (packs.length > 1) {
        const packsForCombo = packs.filter((pack) => optionMap.has(`${selectedDesign}|${selectedSize}|${pack}`));
        const packUi = buildPackSizeGrid(
          packsForCombo.length ? packsForCombo : packs,
          (pack) => optionMap.get(`${selectedDesign}|${selectedSize}|${pack}`),
          selectedPack,
          {
            ...settings,
            packHeading: settings.duvetPackHeading,
            packSubtext: settings.duvetPackSubtext
          },
          (pack) => {
            selectedPack = pack;
            syncFromSelection();
            render();
          }
        );
        packUi.classList.add("hygge-product-page__bundle-pack-size--duvet");
        ui.append(packUi);
      }
    };
    render();
    showDuvetImage(selectedDesign, resolveOption(), false);
  }
  function initHyggeSimpleBundlesUi(root = document) {
    root.querySelectorAll("#simple-bundles-io-options").forEach((container) => {
      if (container.dataset.hyggeBundleUiReady === "true") return;
      container.dataset.hyggeBundleUiReady = "true";
      const activeGalleryKinds = [];
      container.querySelectorAll("select").forEach((select) => {
        const label = getSelectLabel(select, container);
        const kind = getSelectKind(select, label);
        if (kind === "sheet") {
          enhanceSheetSelect(select, container, label);
          activeGalleryKinds.push("sheet");
        } else if (kind === "design-pack") {
          enhanceDesignPackSelect(select, container, label, "sheet");
          activeGalleryKinds.push("sheet");
        } else if (kind === "car-seat") {
          enhanceDesignPackSelect(select, container, label, "car-seat");
          activeGalleryKinds.push("car-seat");
        } else if (kind === "nightlight") {
          enhanceNightlightSelect(select, container, label);
          activeGalleryKinds.push("nightlight");
        } else if (kind === "design") {
          enhanceDesignSelect(select, container, label);
          activeGalleryKinds.push("sheet");
        } else if (kind === "duvet") {
          enhanceDuvetSelect(select, container, label);
          activeGalleryKinds.push("duvet");
        } else if (kind === "book") {
          enhanceBookSelect(select, container, label);
          activeGalleryKinds.push("book");
        }
      });
      pruneUnusedBundleGallerySlots([...new Set(activeGalleryKinds)]);
    });
  }

  // src/js/hygge-simple-bundles-select.js
  var HyggeSelectChevronSvg2 = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none" aria-hidden="true"><path d="M20 1.77502L10 11.775L-4.37114e-07 1.77502L1.775 2.37643e-05L10 8.22502L18.225 2.30452e-05L20 1.77502Z" fill="currentColor"/></svg>';
  var HYGGE_BUNDLE_SHOW_NATIVE_SELECTS = false;
  var bundleObserverPaused = false;
  function getBundlePage(root = document) {
    if (root instanceof Element) {
      return root.closest(".hygge-product-page") || root.querySelector(".hygge-product-page");
    }
    return document.querySelector(".hygge-product-page");
  }
  function getProductForm(page) {
    const form = page?.querySelector("form.js-product-form");
    return form instanceof HTMLFormElement ? form : null;
  }
  function dedupeBundleContainers(page) {
    const containers = [...page.querySelectorAll("#simple-bundles-io-options")];
    if (containers.length <= 1) return containers[0] || null;
    const [primary, ...duplicates] = containers;
    duplicates.forEach((container) => container.remove());
    return primary;
  }
  function suppressBundleInjectionPoint(productForm) {
    const injectionPoint = productForm.querySelector("[data-simple-bundles-options]");
    if (!injectionPoint || injectionPoint.dataset.hyggeBundleInjectionSuppressed === "true") return;
    injectionPoint.dataset.hyggeBundleInjectionSuppressed = "true";
    injectionPoint.setAttribute("hidden", "hidden");
    injectionPoint.style.display = "none";
  }
  function associateNativeBundleFields(container, productForm) {
    if (!productForm.id) return;
    container.querySelectorAll('select[name*="properties"], input[name*="properties"], .hygge-product-page__bundle-native-select').forEach((field) => {
      field.setAttribute("form", productForm.id);
    });
  }
  function bindPackSizeProducts(page) {
    page.querySelectorAll("[data-hygge-pack-size-products]").forEach((block) => {
      if (block.dataset.hyggePackSizeBound === "true") return;
      block.dataset.hyggePackSizeBound = "true";
      const navigate = (url) => {
        if (!url) return;
        try {
          const next = new URL(url, window.location.origin);
          if (next.pathname !== window.location.pathname) {
            window.location.href = next.href;
          }
        } catch {
          window.location.href = url;
        }
      };
      block.querySelectorAll("input[data-hygge-pack-size-url]").forEach((input) => {
        input.disabled = false;
        input.addEventListener("change", () => {
          if (!input.checked) return;
          navigate(input.dataset.hyggePackSizeUrl);
        });
        const label = block.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        label?.addEventListener("click", (event2) => {
          if (input.checked) return;
          event2.preventDefault();
          navigate(input.dataset.hyggePackSizeUrl);
        });
      });
    });
  }
  function repositionBundleOptions(container, page, productForm) {
    if (container.dataset.hyggeBundleRepositioned === "true") return;
    const slot = page.querySelector("#hygge-bundle-options-slot");
    if (slot) {
      slot.insertAdjacentElement("afterend", container);
    } else {
      const insertBefore = page.querySelector(".hygge-product-page__delivery-stock") || page.querySelector(".hygge-product-page__price");
      if (!insertBefore) return;
      insertBefore.before(container);
    }
    associateNativeBundleFields(container, productForm);
    suppressBundleInjectionPoint(productForm);
    container.dataset.hyggeBundleRepositioned = "true";
  }
  function enhanceSimpleBundlesSelect(select, container) {
    if (select.closest(".hygge-size-select")) return;
    if (select.dataset.hyggeBundleUiInit === "true") return;
    const selectId = select.id;
    const label = selectId ? container.querySelector(`label[for="${CSS.escape(selectId)}"]`) : select.previousElementSibling;
    const labelText = (label?.textContent || "").toLowerCase();
    const name = (select.name || "").toLowerCase();
    const id = (select.id || "").toLowerCase();
    const isCustomUi = !HYGGE_BUNDLE_SHOW_NATIVE_SELECTS && (labelText.includes("duvet") || id === "duvet" || name.includes("duvet") || labelText.includes("design") || id === "design" || name.includes("design") || labelText.includes("pack") || id.includes("pack") || name.includes("pack") || labelText.includes("bed/pack") || labelText.includes("sheet") || id.includes("sheet") || name.includes("sheet") || labelText.includes("car seat") || id.includes("car-seat") || id.includes("car_seat") || name.includes("car seat") || labelText.includes("nightlight") || id.includes("nightlight") || name.includes("nightlight") || labelText.includes("book") || id === "book" || name.includes("book"));
    if (isCustomUi) return;
    const group = select.closest(".hygge-product-page__bundle-option") || (() => {
      const optionGroup = document.createElement("div");
      optionGroup.className = "hygge-product-page__bundle-option";
      const labelForSelect = selectId ? container.querySelector(`label[for="${CSS.escape(selectId)}"]`) : select.previousElementSibling;
      if (labelForSelect instanceof HTMLLabelElement) {
        labelForSelect.classList.add("hygge-product-page__bundle-option-label");
        optionGroup.append(labelForSelect);
      }
      select.before(optionGroup);
      return optionGroup;
    })();
    select.classList.add("hygge-size-select__field");
    const wrapper = document.createElement("div");
    wrapper.className = "hygge-size-select";
    const chevron = document.createElement("span");
    chevron.className = "hygge-size-select__chevron";
    chevron.setAttribute("aria-hidden", "true");
    chevron.innerHTML = HyggeSelectChevronSvg2;
    wrapper.append(select, chevron);
    group.append(wrapper);
  }
  function formatBundlePrice(amount, withCurrency = true) {
    const format = withCurrency ? window.theme?.settings?.moneyWithCurrencyFormat || "\xA3{{amount}}" : window.theme?.settings?.moneyFormat || "\xA3{{amount}}";
    const value = amount.toFixed(2);
    if (/\{\{\s*amount_with_comma_separator\s*\}\}/.test(format)) {
      return format.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace(".", ","));
    }
    return format.replace(/\{\{\s*amount[^}]*\}\}/, value);
  }
  var retailPriceCache = /* @__PURE__ */ new Map();
  var bundlePriceUpdateToken = 0;
  function getDesignPackSelect(container = document) {
    const root = container instanceof Element ? container : document;
    const selects = [...root.querySelectorAll("#simple-bundles-io-options select, select")];
    return selects.find((select) => {
      const id = (select.id || "").toLowerCase();
      const name = (select.name || "").toLowerCase();
      if (id.includes("design") && id.includes("pack") || name.includes("design") && name.includes("pack")) {
        return true;
      }
      const label = select.id ? root.querySelector(`label[for="${CSS.escape(select.id)}"]`) : select.previousElementSibling;
      const labelText = (label?.textContent || "").toLowerCase();
      return labelText.includes("design") && labelText.includes("pack");
    }) || null;
  }
  function getPackSavingsFromDesignPackSelect(container) {
    const select = getDesignPackSelect(container);
    if (!select?.value) return 0;
    const packMatch = select.value.match(/ - (\d+)\s*Pack$/i);
    if (!packMatch) return 0;
    const packCount = parseInt(packMatch[1], 10) || 0;
    if (packCount <= 1) return 0;
    const design = select.value.split(" - ")[0]?.trim();
    if (!design) return 0;
    const onePack = [...select.options].find((option) => option.value && option.value.startsWith(`${design} -`) && / - 1 Pack$/i.test(option.value));
    const current = select.selectedOptions[0];
    const baseline = parseFloat(onePack?.dataset.price);
    const packPrice = parseFloat(current?.dataset.price || current?.dataset.hyggeImpliedPrice);
    if (Number.isNaN(baseline) || Number.isNaN(packPrice) || baseline <= 0 || packPrice <= 0) {
      return 0;
    }
    const savings = baseline * packCount - packPrice;
    return savings > 0 ? savings : 0;
  }
  function getPackSavingsAmount(container) {
    const fromSelect = getPackSavingsFromDesignPackSelect(container);
    if (fromSelect > 0) return fromSelect;
    const packBlock = document.querySelector("[data-hygge-pack-size-products]");
    if (!packBlock) return 0;
    const savingsCents = parseFloat(packBlock.dataset.hyggePackSavingsCents || "");
    if (!Number.isNaN(savingsCents) && savingsCents > 0) {
      return savingsCents / 100;
    }
    const baselineCents = parseFloat(packBlock.dataset.hyggePackBaselineCents || "");
    const packCents = parseFloat(packBlock.dataset.hyggePackPriceCents || "");
    const packCount = parseInt(packBlock.dataset.hyggePackCount || "1", 10);
    if (Number.isNaN(baselineCents) || Number.isNaN(packCents) || packCount <= 1) return 0;
    const savings = baselineCents * packCount - packCents;
    return savings > 0 ? savings / 100 : 0;
  }
  function getShopifyCompareSavings() {
    const form = document.querySelector(".hygge-product-page .product-form");
    if (!form) return 0;
    const priceCents = parseFloat(form.dataset.priceCents || "");
    const compareCents = parseFloat(form.dataset.compareAtCents || "");
    if (Number.isNaN(priceCents) || Number.isNaN(compareCents) || compareCents <= priceCents) {
      return 0;
    }
    return (compareCents - priceCents) / 100;
  }
  function isNoneBundleOption2(value, labelText = "") {
    const haystack = `${value || ""} ${labelText || ""}`.trim().toLowerCase();
    if (!haystack) return true;
    return /^(none|no\b|without|not included|no thanks|no thank you|no book|exclude)/i.test(haystack);
  }
  function parseBundleOptionMeta(optionValue) {
    if (!optionValue || isNoneBundleOption2(optionValue)) {
      return { queries: [], size: null, pack: null };
    }
    const queries = [optionValue];
    let size = null;
    let pack = null;
    const dashPackMatch = optionValue.match(/ - (\d+)\s*Pack$/i);
    const slashPackMatch = optionValue.match(/\/\s*(\d+)\s*Pack$/i);
    if (dashPackMatch) {
      pack = `${dashPackMatch[1]} Pack`;
    } else if (slashPackMatch) {
      pack = `${slashPackMatch[1]} Pack`;
    }
    const duvetMatch = optionValue.match(
      /^(.+?)\s*-\s*Kids Coverless Duvet\s*-\s*(.+)$/i
    );
    if (duvetMatch) {
      let rest = duvetMatch[2].trim().replace(/(?:\/|-)\s*\d+\s*Pack$/i, "").trim().replace(/[/-]\s*$/, "").trim();
      const sizeMatch = rest.match(/^(Toddler|Single|Double|Twin|King|Super King|Queen)/i);
      size = sizeMatch ? sizeMatch[1] : rest.split("/")[0].trim();
      queries.push(`${duvetMatch[1].trim()} - Kids Coverless Duvet`);
      queries.push(`${duvetMatch[1].trim()} Kids Coverless Duvet`);
    }
    const sheetMatch = optionValue.match(
      /^(.+?)\s*-\s*Kids Waterproof Mattress Protector(?:\s*-\s*(Single|Double|Twin|King|Super King|Queen))?/i
    );
    if (sheetMatch) {
      size = sheetMatch[2] || size;
      const withoutPack = optionValue.replace(/\s*-\s*\d+\s*Pack$/i, "");
      queries.push(withoutPack);
      queries.push(`${sheetMatch[1].trim()} Kids Waterproof Mattress Protector`);
    }
    if (!size) {
      const sizeMatch = optionValue.match(/\b(Single|Double|Twin|King|Super King|Queen|Toddler)\b/i);
      if (sizeMatch) size = sizeMatch[1];
    }
    return { queries: [...new Set(queries)], size, pack };
  }
  function getProductBasePrice() {
    const form = document.querySelector(".hygge-product-page .product-form");
    const cents = parseFloat(form?.dataset.priceCents || "");
    if (!Number.isNaN(cents) && cents > 0) return cents / 100;
    const packCents = parseFloat(
      document.querySelector("[data-hygge-pack-size-products]")?.dataset.hyggePackPriceCents || ""
    );
    if (!Number.isNaN(packCents) && packCents > 0) return packCents / 100;
    return 0;
  }
  function ensureImpliedZeroOptionPrices(container) {
    if (container.dataset.hyggeImpliedPricesReady === "true") return;
    const selects = [...container.querySelectorAll(".hygge-product-page__bundle-native-select")];
    const productPrice = getProductBasePrice();
    if (!productPrice || !selects.length) {
      container.dataset.hyggeImpliedPricesReady = "true";
      return;
    }
    let knownSelectedSum = 0;
    selects.forEach((select) => {
      const option = select.selectedOptions[0];
      if (!option?.value || isNoneBundleOption2(option.value, option.textContent)) return;
      const price = parseFloat(option.dataset.price);
      if (!Number.isNaN(price) && price > 0) knownSelectedSum += price;
    });
    const impliedForZero = productPrice - knownSelectedSum;
    if (impliedForZero > 0) {
      selects.forEach((select) => {
        [...select.options].forEach((option) => {
          if (!option.value || isNoneBundleOption2(option.value, option.textContent)) return;
          const price = parseFloat(option.dataset.price);
          if (Number.isNaN(price) || price <= 0) {
            option.dataset.hyggeImpliedPrice = String(impliedForZero);
          }
        });
      });
    }
    container.dataset.hyggeImpliedPricesReady = "true";
  }
  function getOptionPrice(option) {
    if (!option?.value || isNoneBundleOption2(option.value, option.textContent)) return 0;
    const price = parseFloat(option.dataset.price);
    if (!Number.isNaN(price) && price > 0) return price;
    const implied = parseFloat(option.dataset.hyggeImpliedPrice || "");
    if (!Number.isNaN(implied) && implied > 0) return implied;
    return 0;
  }
  function getSelectedBundleTotal(container) {
    ensureImpliedZeroOptionPrices(container);
    let total = 0;
    container.querySelectorAll(".hygge-product-page__bundle-native-select").forEach((select) => {
      total += getOptionPrice(select.selectedOptions[0]);
    });
    return total > 0 ? total : getProductBasePrice();
  }
  function matchVariant(product, { size, pack }) {
    const variants = product?.variants || [];
    if (!variants.length) return null;
    const normalize = (value) => String(value || "").toLowerCase().trim();
    const sizeKey = normalize(size);
    const packKey = normalize(pack);
    const scored = variants.map((variant) => {
      const title = normalize(variant.title);
      const options = (variant.options || []).map(normalize);
      let score = 0;
      if (sizeKey && (title.includes(sizeKey) || options.includes(sizeKey))) score += 2;
      if (packKey && (title.includes(packKey) || options.includes(packKey))) score += 2;
      if (packKey) {
        const packNumber = packKey.replace(/[^0-9]/g, "");
        if (packNumber && options.some((option) => option.includes(packNumber) && option.includes("pack"))) {
          score += 2;
        }
      }
      return { variant, score };
    });
    scored.sort((a, b) => b.score - a.score);
    return scored[0]?.score > 0 ? scored[0].variant : variants[0];
  }
  async function fetchComponentRetailPrice(optionValue) {
    if (!optionValue || isNoneBundleOption2(optionValue)) return null;
    if (retailPriceCache.has(optionValue)) return retailPriceCache.get(optionValue);
    const meta = parseBundleOptionMeta(optionValue);
    const packCount = meta.pack ? parseInt(meta.pack, 10) || 1 : 1;
    for (const query of meta.queries) {
      try {
        const url = new URL("/search/suggest.json", window.location.origin);
        url.searchParams.set("q", query);
        url.searchParams.set("resources[type]", "product");
        url.searchParams.set("resources[limit]", "5");
        const response = await fetch(url.toString());
        if (!response.ok) continue;
        const data = await response.json();
        const products = data?.resources?.results?.products || [];
        for (const product of products) {
          if (!product?.handle) continue;
          const fullProduct = await fetch(`/products/${product.handle}.js`).then((res) => {
            if (!res.ok) return null;
            return res.json();
          });
          if (!fullProduct) continue;
          const variant = matchVariant(fullProduct, meta);
          if (!variant) continue;
          let retail = Math.max(
            (variant.price || 0) / 100,
            (variant.compare_at_price || 0) / 100
          );
          if (packCount > 1 && (/mattress protector/i.test(optionValue) || /coverless duvet/i.test(optionValue))) {
            const onePack = matchVariant(fullProduct, { size: meta.size, pack: "1 Pack" });
            if (onePack?.price) {
              retail = Math.max(retail, onePack.price / 100 * packCount);
            }
          }
          if (retail > 0) {
            retailPriceCache.set(optionValue, retail);
            return retail;
          }
        }
      } catch {
      }
    }
    retailPriceCache.set(optionValue, null);
    return null;
  }
  async function getComponentRetailWasTotal(container) {
    let wasTotal = 0;
    let resolved = 0;
    const selects = [...container.querySelectorAll(".hygge-product-page__bundle-native-select")];
    for (const select of selects) {
      const option = select.selectedOptions[0];
      if (!option?.value || isNoneBundleOption2(option.value, option.textContent)) continue;
      const bundlePrice = getOptionPrice(option);
      const retail = await fetchComponentRetailPrice(option.value);
      if (retail != null && retail > 0) {
        wasTotal += Math.max(retail, bundlePrice);
        resolved += 1;
      } else if (bundlePrice > 0) {
        wasTotal += bundlePrice;
      }
    }
    const packBlock = document.querySelector("[data-hygge-pack-size-products]");
    const packWasCents = parseFloat(packBlock?.dataset.hyggePackWasCents || "");
    if (!Number.isNaN(packWasCents) && packWasCents > 0) {
      return Math.max(wasTotal, packWasCents / 100);
    }
    return resolved > 0 ? wasTotal : 0;
  }
  function ensureWasPriceElements(priceRoot) {
    let wasWrap = priceRoot.querySelector(".price__was");
    if (wasWrap) return wasWrap;
    const defaultWrap = priceRoot.querySelector(".price__default") || priceRoot;
    wasWrap = document.createElement("span");
    wasWrap.className = "price__was";
    wasWrap.innerHTML = `
    <span class="visually-hidden js-label"></span>
    <span class="js-value"></span>
  `;
    defaultWrap.append(wasWrap);
    return wasWrap;
  }
  function applyWasPriceDisplay(priceRoot, total, wasAmount) {
    const wasWrap = ensureWasPriceElements(priceRoot);
    const wasValue = wasWrap.querySelector(".js-value");
    const wasLabel = wasWrap.querySelector(".js-label");
    const currentLabel = priceRoot.querySelector(".price__current .js-label");
    if (wasAmount > total + 9e-3 && wasValue) {
      priceRoot.classList.add("price--on-sale");
      wasValue.textContent = formatBundlePrice(wasAmount, false);
      if (wasLabel) {
        wasLabel.textContent = window.theme?.strings?.regularPrice || "Regular price";
      }
      if (currentLabel) {
        currentLabel.textContent = window.theme?.strings?.salePrice || "Sale price";
      }
      return;
    }
    priceRoot.classList.remove("price--on-sale");
    if (wasValue) wasValue.textContent = "";
    if (wasLabel) wasLabel.textContent = "";
    if (currentLabel) {
      currentLabel.textContent = window.theme?.strings?.regularPrice || "Regular price";
    }
  }
  function applyBundleSavingsDisplay(total, wasAmount) {
    const page = document.querySelector(".hygge-product-page");
    if (!page) return;
    const price = page.querySelector(".hygge-product-page__price") || page.querySelector(".product-info__price")?.closest(".price-container") || page.querySelector(".product-info__price");
    const buy = page.querySelector(".hygge-product-page__buy") || page.querySelector("buy-buttons.buy-buttons-row") || page.querySelector("buy-buttons");
    if (!price && !buy) return;
    let el = page.querySelector("[data-hygge-bundle-savings]");
    if (!el) {
      el = document.createElement("div");
      el.className = "hygge-product-page__bundle-savings product-info-block with-icon text-box";
      el.dataset.hyggeBundleSavings = "";
      el.style.setProperty("--box-color", "#CED1FC");
      el.style.setProperty("--box-text-color", "0, 10, 152");
      el.innerHTML = `
      <svg class="icon icon--small icon--type-price_tag" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M7.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path><path d="M3 6v5.172a2 2 0 0 0 .586 1.414l7.71 7.71a2.41 2.41 0 0 0 3.408 0l5.592 -5.592a2.41 2.41 0 0 0 0 -3.408l-7.71 -7.71a2 2 0 0 0 -1.414 -.586h-5.172a3 3 0 0 0 -3 3z"></path></svg>
      <span class="with-icon__beside hygge-product-page__bundle-savings-text"></span>
    `;
    }
    if (price && el.previousElementSibling !== price) {
      price.insertAdjacentElement("afterend", el);
    } else if (!price && buy && el.nextElementSibling !== buy) {
      buy.insertAdjacentElement("beforebegin", el);
    }
    const label = el.querySelector(".hygge-product-page__bundle-savings-text") || el;
    const saveAmount = wasAmount - total;
    if (saveAmount > 9e-3) {
      el.hidden = false;
      label.innerHTML = `Save <strong>${formatBundlePrice(saveAmount, false)}</strong>`;
    } else {
      el.hidden = true;
      label.textContent = "";
    }
  }
  async function updateBundlePrice(container) {
    const token = ++bundlePriceUpdateToken;
    const total = getSelectedBundleTotal(container);
    if (!total) return;
    const priceRoot = document.querySelector(".product-info__price .price");
    const priceEl = document.querySelector(".product-info__price .price__current .js-value");
    if (!priceEl || !priceRoot) return;
    priceEl.textContent = formatBundlePrice(total, false);
    const packSavings = getPackSavingsAmount(container);
    const shopifySavings = getShopifyCompareSavings();
    let wasAmount = total + Math.max(packSavings, shopifySavings);
    const retailWas = await getComponentRetailWasTotal(container);
    if (token !== bundlePriceUpdateToken) return;
    if (retailWas > wasAmount) {
      wasAmount = retailWas;
    }
    if (packSavings > 0) {
      wasAmount = Math.max(wasAmount, total + packSavings);
    }
    applyWasPriceDisplay(priceRoot, total, wasAmount);
    applyBundleSavingsDisplay(total, wasAmount);
  }
  function bindBundlePrice(container) {
    if (container.dataset.hyggePriceBound === "true") return;
    container.dataset.hyggePriceBound = "true";
    container.addEventListener("change", () => {
      updateBundlePrice(container);
    });
    updateBundlePrice(container);
  }
  function hideSeparatePackSizeProducts(page) {
    page.querySelectorAll("[data-hygge-pack-size-products]").forEach((block) => {
      block.hidden = true;
      block.style.display = "none";
    });
  }
  function initBundleContainer(container, page) {
    if (container.dataset.hyggeBundleInit === "true") return;
    const productForm = getProductForm(page);
    if (!productForm) return;
    bundleObserverPaused = true;
    repositionBundleOptions(container, page, productForm);
    hideSeparatePackSizeProducts(page);
    if (HYGGE_BUNDLE_SHOW_NATIVE_SELECTS) {
      container.querySelectorAll("select").forEach((select) => {
        enhanceSimpleBundlesSelect(select, container);
      });
    } else {
      initHyggeSimpleBundlesUi(page);
      bindPackSizeProducts(page);
      container.querySelectorAll("select").forEach((select) => {
        enhanceSimpleBundlesSelect(select, container);
      });
    }
    associateNativeBundleFields(container, productForm);
    bindBundlePrice(container);
    container.dataset.hyggeBundleInit = "true";
    bundleObserverPaused = false;
  }
  function initHyggeSimpleBundlesSelects(root = document) {
    const page = getBundlePage(root);
    if (!page) return;
    const container = dedupeBundleContainers(page);
    if (!container) return;
    initBundleContainer(container, page);
  }
  function observeHyggeSimpleBundlesSelects() {
    if (!("MutationObserver" in window)) return;
    const observer = new MutationObserver((mutations) => {
      if (bundleObserverPaused) return;
      const addedBundleNode = mutations.some((mutation) => [...mutation.addedNodes].some((node) => node instanceof Element && (node.id === "simple-bundles-io-options" || !!node.querySelector?.("#simple-bundles-io-options"))));
      if (!addedBundleNode) return;
      initHyggeSimpleBundlesSelects();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    initHyggeSimpleBundlesSelects();
  }

  // src/js/hygge-collection-filters.js
  function navigateCollectionFilter(select) {
    const option = select.options[select.selectedIndex];
    if (!option) return;
    if (!option.value) {
      const clearUrl2 = option.dataset.url;
      if (clearUrl2) window.location.assign(clearUrl2);
      return;
    }
    const paramName = select.dataset.paramName;
    const clearUrl = select.dataset.clearUrl;
    if (paramName && clearUrl) {
      const url = new URL(clearUrl, window.location.origin);
      url.searchParams.delete(paramName);
      url.searchParams.append(paramName, option.value);
      window.location.assign(`${url.pathname}${url.search}`);
      return;
    }
    const fallbackUrl = option.dataset.url;
    if (fallbackUrl) window.location.assign(fallbackUrl);
  }
  function bindCollectionFilter(select) {
    if (select.dataset.hyggeCollectionFilterBound === "true") return;
    select.dataset.hyggeCollectionFilterBound = "true";
    select.addEventListener("change", () => {
      navigateCollectionFilter(select);
    });
  }
  function initHyggeCollectionFilters(root = document) {
    root.querySelectorAll("[data-hygge-collection-filter]").forEach(bindCollectionFilter);
  }
  function observeHyggeCollectionFilters() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches("[data-hygge-collection-filter]")) {
            bindCollectionFilter(node);
          }
          node.querySelectorAll?.("[data-hygge-collection-filter]").forEach(bindCollectionFilter);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // src/js/hygge-collection-cards.js
  function setCardSubtextHeight(card) {
    const subtext = card.querySelector(".hygge-collection-cards__subtext");
    if (!subtext) return;
    const animated = subtext.querySelector("p + p");
    if (!animated) {
      card.style.setProperty("--hygge-collection-card-subtext-height", "0px");
      return;
    }
    const { maxHeight } = animated.style;
    animated.style.maxHeight = "none";
    const height = Math.ceil(animated.getBoundingClientRect().height);
    animated.style.maxHeight = maxHeight;
    card.style.setProperty("--hygge-collection-card-subtext-height", `${height}px`);
  }
  function initCard(card) {
    setCardSubtextHeight(card);
    if (card.dataset.hyggeSubtextObserved) return;
    card.dataset.hyggeSubtextObserved = "true";
    if ("ResizeObserver" in window) {
      const observer = new ResizeObserver(() => setCardSubtextHeight(card));
      observer.observe(card);
    }
  }
  function initHyggeCollectionCards(root = document) {
    root.querySelectorAll(".hygge-collection-cards__card--has-subtext").forEach(initCard);
  }
  function observeHyggeCollectionCards() {
    let resizeTimer;
    window.addEventListener("resize", () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => initHyggeCollectionCards(), 150);
    });
    document.addEventListener("shopify:section:load", (event2) => {
      initHyggeCollectionCards(event2.target);
    });
    if (document.fonts?.ready) {
      document.fonts.ready.then(() => initHyggeCollectionCards());
    }
  }

  // src/js/hygge-comparison-table.js
  function syncComparisonRowState(group) {
    const row = group.querySelector("[data-comparison-row]");
    const toggler = group.querySelector("toggle-target");
    if (!row || !toggler) return;
    const panel = document.querySelector(toggler.dataset.toggleTarget);
    const isOpen = panel && !panel.classList.contains("toggle-target--hidden");
    row.setAttribute("aria-expanded", isOpen ? "true" : "false");
  }
  function initComparisonAccordionGroup(group) {
    const row = group.querySelector("[data-comparison-row]");
    const toggler = group.querySelector("toggle-target");
    if (!row || !toggler || group.dataset.comparisonRowInit === "true") return;
    group.dataset.comparisonRowInit = "true";
    row.addEventListener("click", () => {
      toggler.click();
      window.setTimeout(() => syncComparisonRowState(group), 400);
    });
    row.addEventListener("keydown", (event2) => {
      if (event2.key !== "Enter" && event2.key !== " ") return;
      event2.preventDefault();
      toggler.click();
      window.setTimeout(() => syncComparisonRowState(group), 400);
    });
  }
  function initHyggeComparisonTable(root = document) {
    root.querySelectorAll("[data-comparison-accordion-group]").forEach(initComparisonAccordionGroup);
  }
  function observeHyggeComparisonTable() {
    document.addEventListener("shopify:section:load", (event2) => {
      initHyggeComparisonTable(event2.target);
    });
  }

  // src/js/cart-drawer-fbt-swiper.js
  function updateCartFbtNav(swiper) {
    swiper.navigation?.update?.();
  }
  function initCartDrawerFbtSwipers(root = document) {
    root.querySelectorAll("[data-hygge-cart-fbt-swiper]").forEach((carousel) => {
      if (carousel.swiper) {
        carousel.swiper.destroy(true, true);
        carousel.swiper = null;
      }
      const section = carousel.closest(".hygge-cart-drawer__fbt");
      if (!section) return;
      const prevButton = section.querySelector("[data-hygge-cart-fbt-prev]");
      const nextButton = section.querySelector("[data-hygge-cart-fbt-next]");
      const swiper = new Swiper(carousel, {
        modules: [Navigation],
        loop: false,
        spaceBetween: 11,
        slidesPerView: "auto",
        watchOverflow: true,
        navigation: {
          prevEl: prevButton,
          nextEl: nextButton,
          disabledClass: "swiper-button-disabled"
        },
        on: {
          init: updateCartFbtNav,
          resize: updateCartFbtNav,
          lock: updateCartFbtNav,
          unlock: updateCartFbtNav,
          slideChange: updateCartFbtNav,
          toEdge: updateCartFbtNav,
          fromEdge: updateCartFbtNav
        }
      });
      carousel.swiper = swiper;
      requestAnimationFrame(() => {
        updateCartFbtNav(swiper);
      });
    });
  }
  function appendCartFbtSlides(drawer, slidesHtml) {
    const wrapper = drawer.querySelector("[data-hygge-cart-fbt-wrapper]");
    const carousel = drawer.querySelector("[data-hygge-cart-fbt-swiper]");
    if (!wrapper || !slidesHtml) return;
    const bundleSlide = wrapper.querySelector("[data-hygge-cart-fbt-bundle-slide]");
    const existingProductIds = new Set(
      [...wrapper.querySelectorAll("[data-product-id]")].map((el) => el.dataset.productId)
    );
    const container = document.createElement("div");
    container.innerHTML = slidesHtml;
    container.querySelectorAll(".swiper-slide").forEach((slide2) => {
      const productId = slide2.dataset.productId || slide2.querySelector("[data-product-id]")?.dataset.productId;
      if (productId && existingProductIds.has(productId)) return;
      if (productId) existingProductIds.add(productId);
      if (bundleSlide) {
        wrapper.insertBefore(slide2, bundleSlide);
      } else {
        wrapper.appendChild(slide2);
      }
    });
    if (carousel?.swiper) {
      carousel.swiper.update();
      updateCartFbtNav(carousel.swiper);
    } else {
      initCartDrawerFbtSwipers(drawer);
    }
  }

  // src/js/cart-drawer-hygge.js
  function initCartDrawerFbtAuto(drawer) {
    const autoSource = drawer.querySelector("[data-hygge-cart-fbt-auto]");
    if (!autoSource) return;
    const from = autoSource.dataset.from;
    if (!from) return;
    if (autoSource.dataset.hyggeCartFbtLoadedFrom === from) return;
    autoSource.dataset.hyggeCartFbtLoadedFrom = from;
    fetch(from).then((response) => {
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      return response.text();
    }).then((html) => {
      if (!html.includes("hygge-cart-drawer__fbt-slide")) return;
      appendCartFbtSlides(drawer, html);
    }).catch(() => {
    });
  }
  async function swapCartPackVariant(lineKey, variantId) {
    await fetch(`${window.Shopify?.routes?.root || "/"}cart/change.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    });
    await fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh"));
    document.dispatchEvent(new CustomEvent("dispatch:cart:refresh", { bubbles: true }));
  }
  function bindCartDrawerMultipack(root) {
    root.querySelectorAll("[data-hygge-cart-multipack-option]").forEach((button) => {
      if (button.dataset.hyggeCartMultipackReady) return;
      button.dataset.hyggeCartMultipackReady = "true";
      button.addEventListener("click", async () => {
        const { variantId, lineKey } = button.dataset;
        if (!variantId || !lineKey || button.disabled) return;
        button.disabled = true;
        try {
          await swapCartPackVariant(lineKey, Number(variantId));
        } finally {
          button.disabled = false;
        }
      });
    });
  }
  function initCartDrawerHygge(root = document) {
    root.querySelectorAll(".hygge-cart-drawer").forEach((drawer) => {
      initCartDrawerFbtSwipers(drawer);
      initCartDrawerFbtAuto(drawer);
      bindCartDrawerMultipack(drawer);
    });
  }
  function observeCartDrawerHygge(root = document) {
    document.addEventListener("on:cart-drawer:after-open", () => initCartDrawerHygge());
    document.addEventListener("on:cart:after-merge", () => initCartDrawerHygge());
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches?.(".hygge-cart-drawer") || node.querySelector?.(".hygge-cart-drawer")) {
            initCartDrawerHygge(node);
          }
        });
      });
    });
    root.querySelectorAll("cart-drawer").forEach((drawer) => {
      observer.observe(drawer, { childList: true, subtree: true });
    });
  }

  // src/js/cart-drawer-open-from-url.js
  function openCartDrawerFromUrl() {
    const params = new URLSearchParams(window.location.search);
    if (params.get("open_cart") !== "1") return;
    params.delete("open_cart");
    const query = params.toString();
    const cleanUrl = `${window.location.pathname}${query ? `?${query}` : ""}${window.location.hash}`;
    window.history.replaceState({}, "", cleanUrl);
    const open = () => {
      document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open"));
    };
    if (document.querySelector("cart-drawer")) {
      open();
    } else {
      customElements.whenDefined("cart-drawer").then(open);
    }
  }

  // src/js/bundle-product-form.js
  var BundleProductForm = class extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector("form");
      this.submitBtn = this.querySelector('[name="add"]');
      if (this.form && this.submitBtn && theme.settings.afterAddToCart !== "no-js") {
        this.form.addEventListener("submit", this.handleSubmit.bind(this));
      }
    }
    async handleSubmit(evt) {
      evt.preventDefault();
      if (this.submitBtn.getAttribute("aria-disabled") === "true" || this.submitBtn.classList.contains("is-loading")) {
        return;
      }
      this.submitBtn.setAttribute("aria-disabled", "true");
      this.submitBtn.classList.add("is-loading");
      const formData = new FormData(this.form);
      const sectionsToUpdate = ["page-header", "cart-drawer"].map((sel) => document.querySelector(sel)).filter((el) => el);
      const sectionIds = sectionsToUpdate.map((el) => el.dataset.sectionId);
      formData.append("sections_url", window.location.pathname);
      formData.append("sections", sectionIds.join(","));
      const fetchRequestOpts = {
        method: "POST",
        headers: {
          Accept: "application/javascript",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: formData
      };
      try {
        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        let error = typeof data.description === "string" ? data.description : data.message;
        if (data.errors && typeof data.errors === "object") {
          error = Object.entries(data.errors).map((item) => item[1].join(", "));
        }
        if (data.status) {
          throw new Error(error || "Error adding product to cart");
        }
        if (!response.ok) {
          throw new Error(response.status);
        }
        if (data.sections && sectionsToUpdate.length === Object.keys(data.sections).length) {
          sectionsToUpdate.forEach((el) => {
            el.updateFromCartChange(data.sections[el.dataset.sectionId]);
          });
        } else {
          this.dispatchEvent(new CustomEvent("on:cart:change", { bubbles: true }));
        }
        if (theme.settings.afterAddToCart === "drawer") {
          const drawer = document.querySelector(".js-cart-drawer");
          if (drawer && typeof drawer.open === "function") {
            drawer.open(this.submitBtn);
          }
        } else if (theme.settings.afterAddToCart === "page") {
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else if (theme.settings.afterAddToCart === "notification") {
          const notification = document.getElementById("AddedNotification").content.firstElementChild.cloneNode(true);
          notification.dataset.productTitle = data.product_title;
          let notificationContainer = document.querySelector(".pageheader--sticky");
          if (!notificationContainer) {
            notificationContainer = document.querySelector("body");
          }
          notificationContainer.appendChild(notification);
        }
        this.dispatchEvent(
          new CustomEvent("on:cart:add", {
            bubbles: true,
            detail: {
              variantId: data.variant_id
            }
          })
        );
        this.submitBtn.classList.add("is-success");
        this.submitBtn.removeAttribute("aria-disabled");
        setTimeout(() => {
          this.submitBtn.classList.remove("is-loading");
          this.submitBtn.classList.remove("is-success");
        }, 2e3);
      } catch (error) {
        console.log("[bundle-product] error", error.message || error);
        this.dispatchEvent(
          new CustomEvent("on:cart:error", {
            bubbles: true,
            detail: {
              error: error.message || String(error)
            }
          })
        );
        this.dispatchEvent(new CustomEvent("on:cart:change", { bubbles: true }));
        this.submitBtn.classList.remove("is-loading");
        this.submitBtn.classList.remove("is-success");
        this.submitBtn.removeAttribute("aria-disabled");
      }
    }
  };
  function defineBundleProductForm() {
    if (!customElements.get("bundle-product-form")) {
      window.customElements.define("bundle-product-form", BundleProductForm);
    }
  }

  // src/js/theme.js
  defineBundleProductForm();
  function setHyggeHeaderHeight() {
    const announcement = document.querySelector(".section-announcement-bar");
    const section = document.querySelector(".section-header");
    let offsetHeight = 0;
    let sectionHeight = 0;
    if (announcement) {
      const announcementHeight = Math.ceil(announcement.offsetHeight);
      offsetHeight += announcementHeight;
      document.documentElement.style.setProperty("--announcement-height", `${announcementHeight}px`);
    } else {
      document.documentElement.style.setProperty("--announcement-height", "0px");
    }
    if (section) {
      sectionHeight = Math.ceil(section.offsetHeight);
      offsetHeight += sectionHeight;
    }
    document.documentElement.style.setProperty("--theme-header-height", `${offsetHeight}px`);
    const isSticky = section && (getComputedStyle(section).position === "sticky" || getComputedStyle(section).position === "-webkit-sticky");
    const stickyHeaderHeight = isSticky ? sectionHeight : 0;
    document.documentElement.style.setProperty("--theme-sticky-header-height", `${stickyHeaderHeight}px`);
  }
  function patchPageHeaderHeight() {
    const pageHeader = customElements.get("page-header");
    if (!pageHeader?.prototype?.setHeaderHeightProperty) return;
    pageHeader.prototype.setHeaderHeightProperty = function setHeaderHeightProperty() {
      setHyggeHeaderHeight();
    };
  }
  function initScrollToTopLinks() {
    document.addEventListener("click", (event2) => {
      const link = event2.target.closest("a[href]");
      if (!link) return;
      const href = link.getAttribute("href");
      if (!href || href.toLowerCase() !== "#top") return;
      event2.preventDefault();
      const behavior = window.theme?.settings?.internalLinksSmoothScroll ? "smooth" : "instant";
      window.scrollTo({ top: 0, left: 0, behavior });
    });
  }
  window.HyggeTheme = {
    init() {
      document.documentElement.classList.add("hygge-theme-js");
      patchPageHeaderHeight();
      setHyggeHeaderHeight();
      initScrollToTopLinks();
      initMobileMenu();
      initFeaturedCollectionSwipers();
      observeFeaturedCollectionSwipers();
      initGalleryCarouselSwipers();
      observeGalleryCarouselSwipers();
      initHyggeGalleryCarouselVideos();
      observeHyggeGalleryCarouselVideos();
      initFeatureColumnsSwipers();
      observeFeatureColumnsSwipers();
      initProductGallerySwipers();
      observeProductGallerySwipers();
      initProductDetailsAccordion();
      observeProductDetailsAccordions();
      initHyggeSizeSelects();
      observeHyggeSizeSelects();
      initHyggeDeliveryStock();
      initHyggeSimpleBundlesSelects();
      observeHyggeSimpleBundlesSelects();
      initHyggeCollectionFilters();
      observeHyggeCollectionFilters();
      initHyggeCollectionCards();
      observeHyggeCollectionCards();
      initHyggeComparisonTable();
      observeHyggeComparisonTable();
      initCartDrawerHygge();
      observeCartDrawerHygge();
      openCartDrawerFromUrl();
    },
    setHeaderHeight: setHyggeHeaderHeight
  };
  document.addEventListener("DOMContentLoaded", () => {
    HyggeTheme.init();
    window.addEventListener("resize", () => {
      window.requestAnimationFrame(setHyggeHeaderHeight);
    });
  });
})();
